import { supportEmailaddr } from "../constants";

export const gDEAppsString =
{
    "matchonly": "Nur Übereinstimmungen",
    "selectpersonid": "Eingabe PersonID",
    "solidborder": "Feste Grenze",
    "A2": "A2",
    "concatinvalid": "Regel ungültig.",
    "iwizerr4": "Zu viele Datensätze für eine einzige Seite. Passen Sie die Unterorganigramm-Optionen an und versuchen Sie es erneut.",
    "orphanrecords": "Aufzeichnungen über verwaiste Daten",
    "SI": "SI",
    "sysstyles": "System-Stile",
    "More Options": "Weitere Optionen",
    "Container": "Behälter",
    "loaderr3": "Das Feld 'ID' ist für den internen Gebrauch reserviert und kann nicht als Feldname verwendet werden.",
    "showscnum": "Unterorganigramm anzeigen #",
    "extrawidem": "Extra breit",
    "results": "Ergebnisse",
    "To": "Ze",
    "Formatting": "Formatierung",
    "Groups": "Gruppen",
    "notes": "Anmerkungen:",
    "Enterit": "Geben Sie ein",
    "charttemplate": "Organigramm-Vorlage",
    "allowsort": "Resort-Boxen, um Platz zu sparen",
    "worker": "ADP-Arbeitskräfte jetzt",
    "tadded": "Box hinzugefügt",
    "createuiprofile": "Neues UI-Profil",
    "A0": "A0",
    "nov": "November",
    "useradderr": "Benutzer-ID in Verwendung. Bitte versuchen Sie eine andere ID.",
    "connmsg2": "als Hilfe bei der Konfiguration von Konnektoren.",
    "language": "Sprache",
    "scarrowstyles": "Unterorganigramm Pfeil-Stil",
    "sandboxupdate": "Sandbox-Konto aktualisiert.",
    "unlimited": "Unbegrenztes Wickeln",
    "refreshdate": "Aktualisierungsdatum",
    "Email": "E-Mail",
    "occtext": "Position Titel",
    "RefText": "Zusammenfassung",
    "retrievingdata": "Daten abrufen...",
    "fieldlabel": "Feldbezeichnung",
    "Load": "Laden Sie",
    "june": "Juni",
    "oct": "Okt.",
    "Monthly": "Monatlich",
    "Directory": "Verzeichnis",
    "aligncenter": "Zentrum ausrichten",
    "dashline": "Gestrichelte Linie",
    "Grid": "Raster",
    "showql": "Quick Links nach dem Login anzeigen",
    "archivefail": "Archivierungsanfrage fehlgeschlagen.",
    "exportnotfound": "Archiv für das angegebene Datum nicht gefunden.",
    "exportfailure": "Archivexport nicht erfolgreich",
    "exportfullaccessonly": "Der Archivexport ist nur für Benutzer mit vollem Zugriff auf dieses Organigramm verfügbar.",
    "Track": "Verfolgen Sie",
    "Alignment": "Ausrichtung",
    "orginfo": "Kontoinformationen erfolgreich aktualisiert.",
    "Filters Applied": "Angewandte Filter",
    "l_name": "Nachname",
    "A1": "A1",
    "ql4": "Laden Sie eine Excel-Datei hoch.",
    "Box Shape": "Boxform",
    "Formula": "Formel",
    "breakbylevel": "Aufgliederung nach Ebene",
    "querytoomanyresults3": "Zu viele Ergebnisse, um in ein Dokument zu passen",
    "ADPKeyFailurePremium": "OrgChart Premium benötigt Ihre Zustimmung, bevor wir Ihre HR-Daten laden können. Klicken Sie auf den untenstehenden Link, um Ihre Zustimmung zu erteilen. Nachdem Sie Ihre Zustimmung erteilt haben, klicken Sie auf die Schaltfläche RETRY, um mit der Nutzung von OrgChart zu beginnen.",
    "hideline": "ausblenden",
    "replacefile": "Es gibt bereits eine Datei mit demselben Namen im aktuellen Ordner. Klicken Sie auf OK, um die Datei zu ersetzen.",
    "requestaccess": "Zugang beantragen",
    "pagex": "Seite X",
    "bsreload2": "Alle Änderungen werden verworfen.",
    "selectadpprofile": "Daten aus ADP importieren",
    "copymessage": "Kopiert",
    "saving": "[1] Speichern...",
    "unableimport": "Daten können nicht importiert werden",
    "stickbottom": "Unten auf die Größe kleben",
    "singlepage": "Einzelne Seite Chart",
    "excelmgr": "Geschäftsführer",
    "and": "und",
    "Headcount": "Personalbestand",
    "orgprefs": "Präferenzen",
    "rptemplate": "Organigramm-Vorlage",
    "emailtxt": "Komma getrennte Liste eingeben",
    "Chart": "Organigramm",
    "shape": "Form",
    "nameinuse": "Name bereits in Gebrauch oder reserviert.",
    "adminuser2": "Verwaltung",
    "boxheight": "Box-Höhe",
    "iwizselectSAPmsg4": "Klicken Sie auf die Schaltfläche 'Daten importieren', um eine Datei aus dem Cloud-Storage zu importieren.",
    "Fields & Formulas": "Felder und Formeln",
    "customFontCmd": "Name der Schriftart",
    "Chart Builder Masters": "Chart Builder-Meister",
    "setascomgr": "Als Co-Manager festgelegt",
    "autosmart": "Auto (Intelligent)",
    "Set Fill Color": "Füllfarbe einstellen",
    "loaderr4c": "wird durch eine vordefinierte Berechnung reserviert. Bitte ändern Sie den Feldnamen in der Datenquelle.",
    "viewdeldmsg": "Die ausgewählte Ansicht wurde gelöscht. Bitte wenden Sie sich an Ihren Systemadministrator.",
    "bsapply": "Box-Stil anzuwenden:",
    "Merge": "zusammenführen",
    "API": "API",
    "assistrulemanual": "Manuell eingestellte Assistenten-Zweigstile",
    "Title": "Titel",
    "IMPORT": "EINFÜHRUNGSDATEN",
    "removebreak": "Unterkartenbruch entfernen",
    "selectctemplate": "Organigrammvorlage auswählen",
    "customf": "Benutzerdefiniert",
    "excludebackgrnd": "Weißer Hintergrund",
    "Cell": "Zelle",
    "notlinked": "-",
    "saveconfirm2": "?",
    "enabledittemp2": "",
    "successupload": "erfolgreich hochgeladen",
    "nosearchresults": "Keine Elemente entsprechen Ihrer Suche",
    "Subcharts": "Unterdiag",
    "enableexcel": "Aktivieren Sie den Excel-Export",
    "excelsubs": "Untergeordnete",
    "Password": "Kennwort",
    "group": "Gruppe",
    "invalidaccesspriv1": "Fehler - Datei leer.",
    "phone": "Telefon",
    "ruleorder": "Regel (Anwendung in der angegebenen Reihenfolge)",
    "Link": "Link",
    "dataresetinprogress": "Daten zurücksetzen",
    "replacewith": "Ersetzen durch",
    "comparecurfile": "Vergleichsdatei auswählen",
    "deltaconfig": "Konfiguration des Delta-Berichts",
    "preservesb": "Benutzeränderungen an der Paginierung beibehalten (Unterkarten-Unterbrüche)",
    "paywallhover": "Premium-Merkmal",
    "automatic": "Automatisch",
    "headerrow2": "Freier Text - 2-spaltig",
    "freetrial4a": "ermöglicht Ihnen die Erstellung von Organigrammen direkt aus ADP Workforce Now oder Vantage.",
    "portrait": "Porträt",
    "Current Screen": "Dieser Bildschirm",
    "DATA": "DATEN",
    "Applied From": "Angewendet von",
    "Never": "Niemals",
    "lockmsg": "Bei der Datenaktualisierung werden gesperrte Elemente nicht aktualisiert.",
    "defaultchartlevels": "Standard-Organigramm-Ebenen",
    "expirytool": "Abonnementbericht:",
    "Thursday": "Donnerstag",
    "hidemaster": "Stammseitenelemente ausblenden",
    "april": "April",
    "Presentation Options": "Präsentation",
    "companyname": "Name des Unternehmens",
    "selectmatches": "Streichhölzer auswählen",
    "triallen": "Dauer der Studie (Tage):",
    "Copyright": "Urheberrecht",
    "Get started with OrgChart Premium!": "Beginnen Sie mit OrgChart Premium!",
    "iwizselectmsg2": "Wenn Sie eine Excel-Datei erstellen müssen, laden Sie die Beispieltabelle herunter und modifizieren Sie sie dann nach Bedarf.",
    "assistruledef": "Regeln zum Festlegen von Assistenten-Zweigstilen verwenden",
    "rightcalc": "RICHTIG",
    "dateformat": "Datumsformat",
    "German": "Deutsch",
    "cellborder": "Zellrand",
    "Purchase": "Kaufen",
    "iframe": "iFrame",
    "downexcel": "Excel vorbereiten...",
    "acctdisable3": "Bitte senden Sie uns eine E-Mail an",
    "buildinghierarchy": "Hierarchie aufbauen...",
    "LookupU": "Nachschlagen",
    "Size for Printing": "Größe für den Druck",
    "quickstartc": ">>> Senden Sie uns bei Fragen eine E-Mail",
    "source2": "Quelle auswählen",
    "october": "Oktober",
    "General": "Allgemein",
    "Subtract": "Subtrahieren",
    "Multiply": "Multiplizieren",
    "Divide": "Teilen",
    "Average": "Durchschnittlich",
    "Count": "Zählung",
    "Sum": "Summe",
    "Split": "Aufspalten",
    "enteraccessgroup": "Zugriffsgruppen-Name eingeben",
    "filemgr": "Akte Mgr",
    "AddNew": "Neu hinzufügen",
    "Orphan": "Waise",
    "orginfo2": "Org-Info:",
    "renderpdf": "Rendern der Seite",
    "Company Name": "Name des Unternehmens",
    "autoself": "Auto (Selbst)",
    "Highlight": "Hervorheben",
    "highlight": "Hervorheben",
    "addfields": "Felder hinzufügen",
    "savescheduler": "Sie müssen dieses Organigramm speichern, bevor Sie den Aktualisierungsplaner aktivieren.",
    "Right": "Rechts",
    "Highlights": "Höhepunkte",
    "autoopencur": "Automatisches Öffnen des aktuellen Organigramms",
    "iwizselectAPDmsg2": "Klicken Sie auf das ? für Informationen zur Konfiguration Ihrer ADP-Verbindung.",
    "notset": "<Nicht gesetzt>",
    "acctexpired1": "Kostenlose Testversion abgeschlossen",
    "trialstart": "Start der Studie:",
    "agroupnameused": "Der Name der Zugriffsgruppe muss eindeutig sein.",
    "nomask": "Keine Maske",
    "setlabel": "Etikett einstellen",
    "xmlformat": "XML-Format",
    "ninebox": "Neun Box",
    "Box Sorting": "Box-Sortierung",
    "Parking": "Parken",
    "decimalplaces": "Nachkommastellen",
    "uploadfail": "Upload fehlgeschlagen",
    "sumif": "ZUSAMMENFASSUNG",
    "0400": "Die API hat einen Berechtigungs- oder Authentifizierungsfehler zurückgegeben. Überprüfen Sie Ihre Verbindungseinstellungen.",
    "using": "unter",
    "archivenotfound": "Archiv für das angegebene Datum nicht gefunden.",
    "freetrial2": "Danke für den Versuch",
    "reloadpic": "Foto neu laden",
    "Basic Math": "Mathematische Grundlagen",
    "resetcharts": "Leer",
    "Self": "Selbst",
    "querybuildsetuperr": "OrgChart Builder ist nicht konfiguriert. Wenden Sie sich für die nächsten Schritte an den technischen Support.",
    "managefields": "Felder verwalten",
    "Views": "Ansichten",
    "Navigation Sidebar": "Navigationsseitenleiste",
    "acctexpired2": "Danke für den Versuch",
    "commalerts": "Warnungen",
    "sendbackward": "Rückwärts senden",
    "paywalldropdownGeneral": "Premium-Funktionen - nicht aktiviert",
    "Friday": "Freitag",
    "Width": "Breite",
    "buildhier1": "Bitte identifizieren Sie die erforderlichen und optionalen Felder.",
    "noqueryresults": "Die Abfrage stimmt mit keinen Datensätzen überein.",
    "moreviews": "Ansichten verwalten...",
    "rpadvoptions": "Fortgeschritten",
    "fieldeditor": "Außendienstleiter",
    "querytoomanyresults4": "Zu viele Ergebnisse, die nicht auf eine einzige Seite passen",
    "publiclink": "Öffentlicher Link",
    "Launch File": "Datei starten",
    "movebox": "Box oder Zweig verschieben",
    "ADPKeyFailure": "ADP-Schlüssel konnten nicht abgerufen werden. Stellen Sie sicher, dass die Zustimmung auf dem ADP-Marktplatz gegeben wurde.",
    "isolvedKeyFailure": "Es sind noch keine isolved-Mitarbeiterdaten verfügbar. Möglicherweise müssen Sie die nächste Mitarbeitersynchronisierung abwarten. Wenden Sie sich an den Support, falls dies erneut auftritt.",
    "acctdetails2": "Konto-Details",
    "Chart Info": "Über",
    "dynloading": "Erstellt Organigramm...",
    "Actions": "Aktionen",
    "ql3": "Download von Excel-Beispieldaten.",
    "Format": "Format",
    "TopOfSubChart": "Oben im Unterorganigramm",
    "allgroups": "Alle gruppierten Felder",
    "chainofcommand": "Befehlskette",
    "sortselection": "Auswahl",
    "iwizselectsample": "Beispiel",
    "seed": "Seed (Auf Zweig beschränken)",
    "Hide Field": "Feld ausblenden",
    "Launch Workbench": "OrgChart-Workbench",
    "ctloaderr": "Fehler beim Laden von Organigrammvorlagen. Bitte versuchen Sie es erneut.",
    "folderempty": "Dieser Ordner ist leer.",
    "a2ps": "A2",
    "complexpass": "Komplexe Kennwörter erfordern",
    "scopechart": "Organigramm oben verwenden",
    "userinfo": "Benutzerinformationen erfolgreich aktualisiert. Die Änderungen gelten bei der nächsten Anmeldung.",
    "currentpage": "Diese Seite",
    "tab": "Registerkarte 'Einleitung':",
    "stdassistantrule": "Regel zur Identifizierung von Standard-Assistenten verwenden",
    "renamebreaks": "Alle Pausen umbenennen",
    "pagebreaks": "Seitenumbrüche",
    "userinfo2": "Benutzer-Info:",
    "sum": "SUM",
    "Help Resources": "Hilfe-Ressourcen",
    "piccache": "Mitarbeiter-Fotos nachladen",
    "solidfill": "Feste Füllung",
    "Locked": "Gesperrt",
    "alignleft": "Links ausrichten",
    "Box Styles": "Box-Stile",
    "lookup": "LOOKUP",
    "orgcharts": "Org-Charts",
    "seatcount": "Anzahl der Sitze:",
    "rpassistwiz": "Assistenten",
    "dataresetconfirm": "Sind Sie sicher, dass Sie die Organigrammdaten zurücksetzen möchten? Alle Änderungen, die vor diesem Kontrollpunkt vorgenommen wurden, gehen verloren.",
    "enableaccesslist": "Sicherheit auf Zeilenebene aktivieren",
    "Predefined": "Vordefiniert",
    "confidential": "Vertraulich - nur interne Verwendung",
    "Location": "Standort",
    "loaderr9": "Ungültiges Fotoformat (Fotos in jpg konvertieren).",
    "nofolderselect": "Kein Ordner ausgewählt",
    "dohyperlink": "Hyperlink öffnen",
    "REFRESH": "Aktualisieren Sie",
    "moveerr": "Es können nicht alle ausgewählten Dateien verschoben werden. Bitte versuchen Sie es erneut.",
    "iwizerr2": "Rundschreiben gefunden. Verwenden Sie die Option 'Oberstes Feld angeben' oder fixieren Sie Daten.",
    "Save": "Speichern",
    "passwordt": "Passwort eingeben",
    "linesubgroup": "Zeile Untergruppe",
    "scalingOptions": "Skalierung",
    "forcepass": "Passwortänderung nach dem Zurücksetzen erzwingen",
    "iwizautobreakchk": "Große Seiten automatisch aufbrechen",
    "folderlocked": "Sie haben nicht die Berechtigung, diesen Ordner umzubenennen oder zu löschen.",
    "percentage": "Prozentsatz",
    "UserID": "Benutzer-ID",
    "orgChiefID": "ID des Leiters der Org-Einheit",
    "labelvalue": "Etikett:Wert",
    "querytoomanyresults": "Zu viele Datensätze wurden zurückgeschickt.",
    "copyall": "Alle",
    "Archived Charts": "Archiv",
    "addboxerr2": "Ungültige hinzufügen. Zum ersten Mitglied der Co-Manager-Gruppe hinzufügen.",
    "on": "Auf",
    "applychanges": "Änderungen anwenden auf",
    "manageusers": "Benutzer verwalten",
    "deleteself": "Der aktuelle Benutzer kann nicht gelöscht werden.",
    "moreoptions": "Mehr Optionen...",
    "onematch": "1 Übereinstimmung gefunden.",
    "loaderr2c": "Spalte überprüfen",
    "Configure": "Konfigurieren",
    "clickhidden": "Klicken Sie hier, um versteckte Gegenstände anzuzeigen",
    "Optimize": "Optimieren",
    "entirechart": "Gesamtes Organigramm",
    "Result": "Ergebnis",
    "summary": "Zusammenfassung",
    "summsg": "Wählen Sie das zu summierende Feld aus.",
    "Text": "Text",
    "userlisterr": "Transaktion gescheitert (USERLISTFAIL).",
    "Help": "Hilfe",
    "Type": "Geben Sie ein",
    "ql5": "Starten Sie den Import-Assistenten.",
    "Day": "Tag",
    "refinvalid": "!ungültig",
    "Fit to Screen": "Auf Bildschirm anpassen",
    "wplan": "Planung der Belegschaft",
    "LookupField": "Nachschlagschlüssel:",
    "Input": "Eingabe",
    "Application": "Bewerbung",
    "breakbyfield": "Aufgliederung nach Bereichen",
    "averageif": "AVERAGEIF",
    "Search & Directory": "Suche & Verzeichnis",
    "enablesched": "Organigramm automatisch aktualisieren",
    "mar": "Mrz",
    "ctsaveerror": "Fehler beim Speichern von Organigrammvorlagen. Bitte versuchen Sie es erneut.",
    "Move": "Verschieben",
    "limitfields": "Felder begrenzen",
    "topbox": "Oberste Box",
    "Import": "Importieren",
    "clearsearch": "Löschen",
    "servercharterr": "Konnte keine Organigrammdaten laden! Wenden Sie sich an den Kundendienst, wenn dieses Problem weiterhin besteht.",
    "createpreview": "Erstellt Vorschau...",
    "addfolders": "Ordner hinzufügen",
    "notequal": "nicht gleich",
    "allowallfolders": "Klicken Sie auf (+), um den Zugriff auf den Ordner zu ermöglichen.",
    "orgname2": "Gesetzlicher Name:",
    "preservebl": "Manuelle Änderungen an der Box-Präsentation (Box-Layouts) beibehalten",
    "iwizselectAPDmsg1": "Der Import-Assistent erstellt automatisch ein Organigramm über eine direkte Verbindung zu Ihrem ADP Workforce Now- oder ADP Vantage-Konto.",
    "nowrap": "Text abschließen",
    "quickstarta": ">>> Einrichten Ihrer ADP-Verbindung",
    "Comparison": "Vergleich",
    "OK": "OK",
    "or": "oder",
    "Auto Apply": "Automatisches Anwenden",
    "Operations": "Betrieb",
    "Fast Select": "Schnelle Auswahl",
    "Retry": "Wiederholen Sie",
    "Image": "Bild",
    "LookupValue": "Lookup-Ergebnis:",
    "Bkgrnd": "Hintergrund",
    "7029": "Unbekannter Befehl. Bitte aktualisieren Sie Ihren Browser oder wenden Sie sich an den Kunden-Support, falls das Problem weiterhin besteht.",
    "Limit Fields": "Abfrage auf Felder einschränken",
    "rpsubcharts": "Unterdiag",
    "invaliddate": "UNGÜLTIG",
    "enterrule": "Regel eingeben",
    "Background Publish": "Hintergrund veröffentlichen",
    "Table": "Tabelle",
    "serverqueryerr": "Suche fehlgeschlagen. Wenden Sie sich an den technischen Support, wenn dieses Problem weiterhin besteht.",
    "removebreakstoomany": "Alle Pausen entfernen (Deaktiviert - zu viele Datensätze)",
    "signout": "Abmeldung",
    "agroupnofolders": "Die Zugriffsgruppe enthält alle Ordner.",
    "SalesMsg": "Weitere Informationen erhalten Sie bei",
    "queryoptions": "Suche nach Top-Position",
    "allmgr": "Alle Manager",
    "buildhier": "Felder definieren",
    "testlink": "Test-Link",
    "TestLinkTokenError": "Dieser Link kann derzeit nicht getestet werden. Bitte versuchen Sie es erneut.",
    "Chart Background": "Hintergrund der Grafik",
    "Rule Configuration": "Regelkonfiguration:",
    "deleteallmsg": "Sind Sie sicher, dass Sie alle Dateien in diesem Ordner löschen möchten?",
    "blackscarrow": "Schwarzer Pfeil",
    "cursubchart": "Aktuelles Unterorganigramm",
    "persistlock": "Nicht löschen (für manuell hinzugefügte Boxen)",
    "refreshnow": "Daten jetzt aktualisieren",
    "groupfolders": "Ordner",
    "iwizselectSAPmsg1": "Der Import-Assistent erstellt automatisch ein Organigramm aus einer SAP-XML-Datei.",
    "Down": "Nach unten",
    "readonly": "Nur lesen",
    "adpadvopt": "ADP-Profil:",
    "Login mode": "Anmeldemodus",
    "includechain": "Befehlskette einbeziehen",
    "Container Box Style": "Container-Box-Stil",
    "enterfilter": "Filterregel hier eingeben",
    "Author": "Autor",
    "testauth": "Authentifizierungs-Test",
    "No Rule": "Keine Regel",
    "Find": "Finden",
    "Background": "Hintergrund",
    "about": "Über",
    "breakfield": "Pause auf dem Feld:",
    "usernameupdatefail": "Der Benutzername dieses Benutzers kann nicht geändert werden.",
    "letterps": "Brief",
    "contactemail": "Kontakt E-Mail:",
    "serverinfo": "Informationen zum Server:",
    "ats": "ATS:",
    "branchstyleerr2": "Es müssen mindestens 2 Felder ausgewählt werden.",
    "assistonleft": "Erster Assistent auf der linken Seite des Managers platzieren",
    "Cut": "Schnitt",
    "Edition": "Ausgabe",
    "queryblank": "Keine obere Position angegeben",
    "Server": "Server",
    "Try to pull records from Parking": "Versuchen Sie, Aufzeichnungen aus dem Parkhaus zu holen",
    "fileloaderr3": "Datei fehlt oder ungültiges Format",
    "Blank": "Leere",
    "Null - Not configured": "Null - Nicht konfiguriert",
    "Scheduled By": "Geplant von",
    "buildingchart": "[2] Das Laden...",
    "enablelimitaccess": "Sicherheit auf Zweigstellenebene einstellen",
    "sortsubchart": "Aktuelles Unterorganigramm",
    "outwhat": "Was ausgeben",
    "Sort": "Sortieren",
    "assistL": "Assistentin links",
    "scarrowstyle": "Unterorganigramm Pfeile",
    "openmychart": "Öffnen Sie 'Mein Organigramm‘",
    "removefolders": "Ordner entfernen",
    "passmsg2": "Zeichen sein und enthalten eine Zahl, einen Großbuchstaben und ein Sonderzeichen (!#@*+?)",
    "Edit": "bearbeiten",
    "autodelta": "Automatische Benachrichtigungen",
    "savemaster": "Vorlage für die Master-Seite",
    "acctdisable2": "Ihr Konto ist deaktiviert.",
    "Min": "Min.",
    "Security": "Sicherheit",
    "Alert": "Alarm",
    "Basic Rule": "Grundregel",
    "allassist": "Alle Assistenten",
    "Time Formats": "Zeitformate",
    "includelevels": "Zu berücksichtigende Ebenen",
    "Role Assignment": "Rollenzuweisung",
    "Add": "Hinzufügen",
    "Build": "Bauen",
    "Setup": "Einrichtung",
    "selection": "Auswahl",
    "valuedefinvalid": "Ungültiger Feldwert: Feld existiert nicht.",
    "endpoint": "Endpunkt",
    "orgnamemin": "Der Firmenname kann nicht leer sein.",
    "Allow Groups with Managers": "Gruppen mit Managern erlauben",
    "subchartbr": "Unterorganigramm-Assistent",
    "Header1": "Kopfzeile1",
    "Level": "Ebene",
    "breakevery": "Pause alle:",
    "dynmsg1": "[1] Das Abrufen von Daten...",
    "bringforward": "Vorwärts bringen",
    "portal": "Portal",
    "iwizselectmsg4": "Klicken Sie auf die Schaltfläche 'Daten importieren', um eine Datei aus dem Cloud-Storage zu importieren.",
    "Settings": "Einstellungen",
    "reqpitinfo": "Klicken Sie hier, um mehr über Point in Time Charts zu erfahren.",
    "Tutorials": "Tutorials",
    "Default Template": "Standard-Vorlage",
    "nofill": "Keine Befüllung",
    "allowedlimit": "Erlaubte Box-Beschränkung:",
    "accessprivs": "Zugriffsprivilegien",
    "rows": "Zeilen",
    "loaderr1": "Das Datendateiformat ist ungültig.",
    "copypubfolder": "Speichern unter",
    "singleborder": "Einzelne Grenze",
    "allboxes": "Alle Boxen",
    "buildhier2": "Wenn Ihre Daten keine Hierarchiefelder (Personen-ID und Vorgesetzten-ID) enthalten, können Sie manuell",
    "reqaccessacct": "Zugang zu einem bestehenden Konto beantragen.",
    "rowsecrestrictedfields": "Eingeschlossene Felder sind eingeschränkt",
    "nofileresults": "Keine Suchergebnisse in",
    "pwemail": "E-Mail-Adresse eingeben",
    "textboxes": "Textfelder",
    "fileinfoerr": "Fehler beim Abrufen von Dateiinformationen.",
    "freetrial5": "Am Ende Ihrer Probezeit werden Sie auf ein kostenloses Nur-Lese-Konto zurückgestuft und haben weiterhin Zugang zu allen Ihren Dokumenten.",
    "ql2": "Öffnen Sie ein vorhandenes Organigramm.",
    "customfonts": "Benutzerdefinierte Schriften",
    "downloadaccess": "Aktuelle Privs herunterladen",
    "View": "Siehe",
    "acctexpired3": "Ihr kostenloser Test ist abgeschlossen.",
    "disabledAccount": "Konto deaktiviert. Klicken Sie hier für Details.",
    "No chart data loaded - select the Refresh Data Now option to load data": "Keine Organigrammdaten geladen - wählen Sie die Option Organigramm aktualisieren, um Daten zu laden.",
    "emailadderr": "E-Mail bereits in Gebrauch. Bitte versuchen Sie eine andere E-Mail.",
    "ql7": "Gehen Sie die Tutorials durch.",
    "Close": "Schließen",
    "Duplicate": "Doppelt",
    "ruledriven": "Regelgesteuertes Organigramm (manuelle Präsentationsänderungen sind nicht dauerhaft)",
    "Insert": "Einfügen",
    "acctdisable1": "Konto deaktiviert",
    "Rule": "Regel",
    "leftmsg": "Geben Sie Zeichen aus der linken Spalte zurück.",
    "useinches": "Anzeigeeinheiten in Zoll",
    "Allow View": "Ansicht zulassen",
    "Dense": "Dicht",
    "displayoptions": "Anzeige-Optionen",
    "may": "Mai",
    "launchmode": "Startmodus",
    "layoutlock": "Layout des Schlosses",
    "miniscarrow": "Mini-Pfeil",
    "mapmsg": "Mapping eingeben.",
    "Chart Management": "Chart-Management",
    "grouplisterr": "Transaktion fehlgeschlagen (GROUPLISTFAIL).",
    "january": "Januar",
    "filteroptions": "Herausfiltern",
    "Extras": "Extras",
    "textwrapchars": "Bruch-Zeichen",
    "alllevels": "Alle Ebenen",
    "Branch Style": "Zweig-Stil",
    "passinvalid": "Altes Passwort ungültig.",
    "pagenum": "Seite #",
    "parentUnitID": "ID der übergeordneten Orgeinheit",
    "pagexy": "Seite X von Y",
    "acctdisable4": "wenn Sie Ihr Konto reaktivieren möchten.",
    "renameuiprofile": "Name des UI-Profils eingeben",
    "resetpwfail": "Es konnte kein Benutzer mit dieser E-Mail-Adresse gefunden werden. Wenden Sie sich an Ihren Systemadministrator, um Zugangsdaten zu erhalten.",
    "notsandbox": "Kein Sandboxkonto.",
    "sep": "Sep.",
    "prefix": "Präfix",
    "commDialogueMessage": "Einstellungen für E-Mail-Benachrichtigungen",
    "Link Type": "Link-Typ",
    "groupprops": "Eigenschaften der Gruppe",
    "Importfiltereditor": "Importfilter-Editor",
    "Field": "Feld",
    "Page": "Seite",
    "freetrial4": "Ihr Testkonto ermöglicht Ihnen den Import von bis zu 1000 Datensätzen. Kontaktieren Sie uns, wenn Sie mehr Kapazität benötigen.",
    "fieldSelect": "Wählen Sie ein Feld aus",
    "UI Profile": "UI-Profil",
    "profloaderr": "Profil kann nicht geladen werden. Bitte versuchen Sie es erneut.",
    "createcomgr": "Co-Manager-Gruppe erstellen",
    "workerrun": "ADP-RUN",
    "novalue": "Wert muss mindestens 2 Zeichen lang sein",
    "assistPR": "Assistentin Peer Right",
    "needsrefresh": "Eine neue Version des OCN wurde veröffentlicht. Bitte laden Sie Ihren Browser neu (Strg+Umschalt+R).",
    "stickright": "Rechts auf die Größe kleben",
    "Search": "Suche",
    "Filters & Highlights": "Filter und Highlights",
    "edition": "Ausgabe:",
    "dofile": "Datei öffnen",
    "refnotconfig": "!Nicht konfiguriert",
    "0503": "Die Einverständniserklärung des Klienten ist nicht verfügbar. Wenden Sie sich an Ihren ADP-Vertreter.",
    "color": "Farbe",
    "sortchart": "Gesamtes Organigramm",
    "pitenabled": "Automatisches archiv",
    "invaliddatemsg": "Ungültiges Datum",
    "unablebuildhier": "Keine Hierarchie aufbauen können",
    "pageverydense": "Sehr dicht",
    "Default": "Standardmäßig",
    "docopy": "Text kopieren",
    "Potential": "Potenzielle",
    "Previous": "Vorherige",
    "passnomatch": "Passwörter stimmen nicht überein.",
    "Time Format": "Zeitformat",
    "noheaders": "Sie müssen die Daten einmal importieren, bevor Sie Hilfsaufseher hinzufügen können.",
    "basicAdminPaywall": `Um OrgChart Premium zu erwerben, besuchen Sie den ADP Marketplace oder senden Sie für weitere Informationen eine E-Mail an ${supportEmailaddr} oder rufen Sie 1.415.462.1313 an.`,
    "Subordinates": "Untergebene",
    "grouptype1": "Gruppe mit Leiter",
    "Font Face": "Schriftart",
    "Clear Existing Groups": "Bestehende Gruppen löschen",
    "offCommSet": "Benachrichtigen Sie mich nicht über bevorstehende Produktupdates, Änderungen und Ankündigungen.",
    "subsonly": "Untergebene",
    "Log in": "Anmelden",
    "preferredlast": "Bevorzugte Letzte",
    "iwizsc1": "Wenn Ihr Organigramm zu viele Kästchen enthält, um auf eine einzige Seite zu passen, können Sie Ihr Organigramm in mehrere Seiten aufteilen.",
    "uploadfile": "Dateien hochladen/herunterladen",
    "countifdesc": "Zählen Sie nur, wenn der Datensatz definierte Kriterien erfüllt.",
    "breakcharacter": "Pausenzeichen",
    "disablecuruser": "Sie können Ihr eigenes Konto nicht deaktivieren.",
    "fieldcompblank": "Felder und Vergleiche können nicht leer sein.",
    "includefiltered": "Gefilterte Manager einbeziehen",
    "Connecting Line Style": "Stil der Verbindungslinie",
    "buildcharton": "Organigramm erstellen auf",
    "selectmasterfile": "Wählen Sie die Vorlage für die Master-Seite",
    "Gutter": "Rinne",
    "togglesaml": "SAML-Tieflink",
    "currentbranch": "Dieser Zweig",
    "valueSelect": "Wählen Sie eine",
    "landscape": "Landschaft",
    "successrupload": "erfolgreich ersetzt",
    "used": "verwendet",
    "rightassist": "Richtiger Assistent",
    "companynamedd": "Geben Sie den Firmennamen ein:",
    "profload": "Profil geladen.",
    "exporto": "Exportieren nach",
    "nomatches": "Keine Übereinstimmungen gefunden.",
    "loaderr4b": "mehr als einmal in der Datendatei verwendet wird.",
    "onecolL": "Eine Säule links",
    "optimizeall": "Optimieren Sie alle Unterorganigramme",
    "Scope": "Umfang",
    "wirehiererr": "Die Felder Personen-ID und/oder Supervisor-ID sind nicht gesetzt.",
    "ql10": "Laden Sie den Getting Started Guide herunter.",
    "loaderr8": "Es fehlen Felddefinitionen.",
    "directsubs": "Direkte Untergebene einbeziehen",
    "Max": "Max",
    "oldInternetExplorer": "Internet Explorer 9 erkannt. Bitte aktualisieren Sie auf eine neuere Version von Internet Explorer oder versuchen Sie es mit Google Chrome.",
    "ql8": "Prüfen Sie die Beispieldateien.",
    "configerrormsg": "Ein oder mehrere Felder sind für dieses Organigramm nicht korrekt definiert. Bitte verwenden Sie den Abschnitt 'Mapping', um sie entsprechend einzustellen.",
    "dirreports": "Direkte Berichte",
    "ungroup": "Gruppe auflösen",
    "defsubfilter": "Untergeordnete Regel bearbeiten...",
    "wplantools": "Planungswerkzeuge",
    "Replace": "Ersetzen",
    "moveboxtool": "Box verschieben",
    "ctreload1": "Sind Sie sicher, dass Sie Ihre Organigrammvorlagen neu laden möchten?",
    "requestaccessmsg": "Wenden Sie sich an Ihren Administrator, wenn die E-Mail-Adresse nicht gefunden wurde.",
    "filelocked": "Sie haben nicht die Erlaubnis, diese Datei zu ändern. Datei oder Ordner gesperrt.",
    "passmsg": "Passwort muss mindestens",
    "Security Profile": "Sicherheitsprofil",
    "highlightcolor": "Hervorhebungsfarbe",
    "createppt": "PPT erstellen...",
    "mapmsg2": "Beispiel: '94121':'Richmond','94122':'Sunset'",
    "pnghiquality": "Hohe Qualität",
    "Box": "Box",
    "Links": "Links",
    "includebkgrndcolor": "Hintergrundfarbe",
    "Access": "Zugang",
    "assistwiz1": "Legen Sie Assistenten-Zweigstile auf der Grundlage von Regeln oder Daten fest.",
    "selected": "ausgewählt.",
    "whitescarrow": "Weißer Pfeil",
    "archivesuccess": "Archiv erfolgreich erstellt.",
    "delctmsg1": "Sind Sie sicher, dass Sie die ausgewählten Organigrammvorlagen löschen möchten?",
    "tmoved": "Box verschoben",
    "include": "einbeziehen",
    "Peers": "Ähnliche",
    "occcount": "Positionszählung",
    "scheduleoptions": "Optionen für die Zeitplanung",
    "Loading": "Laden von",
    "loaderr5": "Die Datei enthält keine Daten.",
    "Scheduler": "Terminplaner",
    "iwizfiltermsg1": "Optional können Sie Ihre Quelldaten filtern.",
    "aug": "Aug",
    "removefields": "Felder entfernen",
    "Cloud": "Datenbank",
    "usersummary": "Benutzer-Bericht",
    "SupervisorID": "SupervisorID",
    "orgchart": "OrgCharts",
    "Off": "Aus",
    "Span": "Spanne",
    "branchstyleerr3": "Ungültige Auswahl. Alle ausgewählten Felder müssen denselben Manager haben.",
    "Allowed fields": "Erlaubte Felder",
    "Chart Access": "Zugang zu den Organigrammen",
    "Chart Template Missing": "Die Organigrammvorlage für die ausgewählte Ansicht fehlt. Bitte wenden Sie sich zur Behebung an Ihren Systemadministrator.",
    "Select All": "Alle auswählen",
    "EDITM": "Master bearbeiten",
    "uploadaccess": "Neue Privs hochladen",
    "copyformat": "Format kopieren",
    "greaterequal": "größer oder gleich",
    "expirybutton": "herunterladen",
    "testmath": "Mathematik testen",
    "stayconnected": "Verbunden bleiben",
    "My Settings": "Meine Einstellungen",
    "2016": "Präprozessor-Ausfall",
    "privatefolder": "Privaten Ordner hinzufügen",
    "Files": "Dateien",
    "user": "Benutzer",
    "Auto": "Auto",
    "Dynamic": "Dynamisch",
    "march": "März",
    "unknownqerr": "System nicht konfiguriert. Wenden Sie sich an den Kundensupport unter:",
    "mathmsg2": "Beispiel: '[FeldA]/[FeldB]*100'.",
    "buildhier3": "Drag & Drop-Boxen, um ein Organigramm zu erstellen, nachdem die Daten importiert wurden.",
    "reenteremail": "Bitte geben Sie eine oder mehrere gültige E-Mail-Adressen ein.",
    "december": "Dezember",
    "acctdetails": "Kontodetails",
    "welcometo": "Willkommen bei",
    "uploadingnow": "Datei hochladen...",
    "OrgChart Workbench": "OrgChart-Workbench",
    "Publisher": "Herausgeber",
    "textbox": "Textfeld",
    "files": "Dateien",
    "querydata": "Ersteller",
    "tabloidps": "Boulevardzeitung",
    "solidline": "Solide",
    "iwizselectmsg1": "Der Import-Assistent erstellt automatisch ein Organigramm aus einer Excel-Datei.",
    "refreshmsg": "Änderungen werden bei der nächsten Datenaktualisierung übernommen.",
    "box": "Box",
    "quickstart": ">>>Klicken Sie hier, um die Schnellstartanleitung zu öffnen<<<",
    "Paste": "Einfügen",
    "customcolor": "Benutzerdefinierte Farbe",
    "pagedense": "Dicht",
    "Shared": "Geteilt",
    "isnotempty": "ist nicht leer",
    "andor": "Und/Oder",
    "genlayout": "Layout erzeugen",
    "Header2": "Kopfzeile2",
    "pleaseReduceNumberLevels": "Bitte reduzieren Sie die Anzahl der Ebenen Ihres Organigramms.",
    "Custom": "Benutzerdefiniert",
    "Pan": "Schwenken",
    "scalefill": "Skalieren, um die gesamte Seite zu füllen",
    "rightpassist": "Rechter Peer-Assistent",
    "section508": "Abschnitt 508",
    "deleteChart": "Dieses Organigramm löschen",
    "nousertemps": "Alle verwendeten (oder keine definierten) Vorlagen. Verwenden Sie das Vorlagen-Panel, um zusätzliche Vorlagen zu erstellen.",
    "Fixed": "Festgelegt",
    "Apply Box Style To Members": "Box-Stil auf Mitglieder anwenden",
    "rowscols": "Zeilen und Spalten",
    "banded": "Gebänderte",
    "copyclipboard": "In die Zwischenablage kopieren",
    "preferredfirst": "Bevorzugt zuerst",
    "Data": "Daten",
    "Connecting Line Color": "Farbe der Verbindungslinie",
    "noborder": "Keine Grenze",
    "Templates": "Vorlagen",
    "minbreak": "Mindest-Subs für die Pause:",
    "clicktoadd": "Klicken Sie auf (+), um Folgendes hinzuzufügen",
    "commit": "Verpflichtung",
    "moveobj": "Organigramm oder Objekt verschieben",
    "Current Chart": "Organigramm-Informationen",
    "validuserid": "Minimale Länge der Benutzerkennung 6 Zeichen.",
    "addsubtool": "Box hinzufügen",
    "nospaceuiprofile": "UI-Profile dürfen keine Leerzeichen enthalten",
    "contentlock": "Inhalt sperren",
    "boxcount": "Box-Anzahl",
    "Value": "Wert",
    "screenpdf": "Für Bildschirm optimieren",
    "gmttime": "Zeit (GMT)",
    "autoopen": "Automatisches Öffnen des angegebenen Organigramms",
    "Add new chart confirm": "Möchten Sie ein neues Organigramm manuell erstellen? Sie müssen sicherstellen, dass Ihre Datenquelle und die Konfiguration korrekt sind.",
    "removebreaks": "Alle Pausen entfernen",
    "mpdoc": "Nicht verfügbar. Das aktuelle Dokument ist eine Stammseitenvorlage.",
    "lastrefresh": "Zuletzt aufgefrischt",
    "lastrefreshdatetime": "{date}, um {time}{german24hour}",
    "searchdir": "Suche",
    "sapoption2": "Kombinieren Sie OrgEinheiten und Chef-Positionen",
    "Match": "Spiel",
    "dynmsg2": "2] Die Verarbeitung von Daten...",
    "dynmsg3": "[3] Gebäude Organigramm...",
    "username": "Benutzer-Name",
    "themearrow": "Themen-Pfeil",
    "acctexpired": "Das Abonnement ist abgelaufen. Klicken Sie hier für Details.",
    "createxml": "XML erstellen...",
    "connmsg1": "E-Mail",
    "passmin2": "Figuren.",
    "leftassist": "Linker Assistent",
    "showprofpanel": "Profil-Panel einbeziehen",
    "availableviews": "Verfügbare Ansichten",
    "twelvecolumn": "Zwölf Spalten",
    "jul": "Jul",
    "year": "Jahr",
    "nogroup": "Keine Gruppe ausgewählt",
    "s_title": "Titel",
    "boxlayouteditor": "Box-Layout-Editor",
    "addboxerr1": "Ungültige hinzufügen. Drilldown zum Hinzufügen von Boxen.",
    "passexpired": "Das Passwort ist abgelaufen. Benutzen Sie den Link Passwort vergessen, um es zurückzusetzen.",
    "Set Text Style": "Textstil festlegen",
    "fieldblank": "Nachschlagfelder auswählen.",
    "Division": "Abteilung",
    "iwizselectupload": "Dateien hochladen",
    "Enable Right-Click": "Rechtsklick aktivieren",
    "restrictaccess": "Zugriff auf das aktuelle Dokument einschränken",
    "allconn": "Alle Verbindungsleitungen",
    "sixcolumn": "Sechs Spalten",
    "onecolR": "Eine Spalte rechts",
    "Position": "Position",
    "doesnotcontain": "enthält nicht",
    "croptochart": "Auf Grafik beschneiden",
    "nomaster": "Leere Master-Seite",
    "Custom Colors": "Benutzerdefinierte Farben",
    "smartstartlevel": "Pausen beginnen um:",
    "changeimportfile": "Datenquelle auswählen",
    "selectboxprop": "Bitte setzen Sie mindestens eine Box-Eigenschaft",
    "onlaunch": "Beim Start:",
    "PersonID": "PersonID",
    "uploadfailfiletype": "Upload abgebrochen - ungültiger Dateityp",
    "function": "Funktion",
    "Top": "Nach oben",
    "twentycolumn": "Zwanzig Spalten",
    "agroupnamemin": "Der Name der Zugriffsgruppe kann nicht leer sein.",
    "userid": "Benutzer-ID",
    "branchlevelsecurity": "Sicherheit auf Branchenebene",
    "average": "AVERAGE",
    "july": "Juli",
    "Email address": "E-Mail adresse",
    "FILE": "Datei",
    "rpreqfields": "Felder definieren",
    "Subchart": "Unterorganigramm",
    "filterinvalid": "Ungültige Filterregel",
    "checkpoint": "Checkpoint",
    "Complex Math": "Komplexe Mathematik",
    "assistR": "Assistent Recht",
    "adminuser": "Verwalter",
    "logintoomany": "Zu viele Anmeldeversuche. Konto für 5 Minuten gesperrt.",
    "SelectP": "Wählen Sie...",
    "saveerror": "Fehler beim Speichern der Datei. Bitte versuchen Sie es erneut.",
    "NewSuperID": "SuperID-Suche",
    "FieldValue": "Feldwert",
    "concatmsg2": "Beispiel: '[Vorname] [Nachname]'.",
    "noheader": "Keine Kopfzeile",
    "iwizfilterchk": "Datenfilter angeben",
    "accountinfo": "Konto-Details",
    "Up": "Nach oben",
    "greater": "größer als",
    "adprefropt": "Ausgewähltes ADP-Profil:",
    "ActivityR": "Aktivitätsbericht",
    "valuedefvalid": "Gültiger Feldwert",
    "setposition": "Position auf der linken Seite",
    "userdetails": "Benutzer-Details",
    "userdetails (short)": "Benutzer-Details",
    "isempty": "ist leer",
    "subchartoptions": "Einfügen von Unterkarten-Unterbrechungen",
    "resetpass": "Bitte setzen Sie das Passwort zurück.",
    "Criteria": "Kriterien",
    "Department": "Abteilung",
    "Apply Template": "Vorlage anwenden",
    "invalidaccesspriv2": "Fehler - Kontrollzeile:",
    "Folders": "Ordner",
    "profsaveerr": "Profil kann nicht erstellt werden. Bitte versuchen Sie es erneut.",
    "Line": "Zeile",
    "channel": "Kanal:",
    "boxsame": "Boxen mit gleichem Format",
    "Recent Target Positions": "Jüngste Spitzenpositionen",
    "retrievingkey": "Schlüssel abrufen...",
    "sendtoback": "Zurückschicken",
    "Grouping": "Gruppierung",
    "groupupdateerr": "Die Transaktion ist fehlgeschlagen (GROUPUPDATEFAIL).",
    "Output": "Ausgabe",
    "freetrialtl1": "Ihr kostenloser Test hat",
    "Middle": "Mitte",
    "testpanel": "Test-Panel",
    "Rename": "Umbenennen",
    "from": "Von",
    "splitaltkey": "Alternativer Schlüssel",
    "Custom fields": "Benutzerdefinierte Felder",
    "orgchartbuild": "OrgChart-Ersteller",
    "Always Apply": "Immer bewerben",
    "replacemsg": "Die Datei ist bereits vorhanden. Möchten Sie die Datei ersetzen?",
    "sapouoptions": "Optionen für SAP-OrgUnit-Organigramme",
    "enterval": "Wert eingeben",
    "Private Folder Access": "Zugang zu privaten Ordnern",
    "Options": "Optionen",
    "presentation": "Präsentation",
    "Prev": "Vorherige",
    "VIEW": "ANSEHEN",
    "Update": "Aktualisierung",
    "usage": "Verwendung:",
    "testrule": "Test Regel",
    "AuxSuperID": "Aux-Supervisor-ID",
    "howto": "Wie geht das?",
    "iwizselectSAPmsg2": "Bitte wenden Sie sich an den technischen Support, um Hilfe beim Export von Daten aus Ihrem SAP-System zu erhalten.",
    "Arrange": "Ordnen Sie",
    "Equal": "Gleich",
    "Levels": "Ebenen",
    "printpdf": "Optimieren für den Druck",
    "aligncells": "Zellen ausrichten",
    "rpdatasource": "Quelle",
    "privatelink": "Privater Link",
    "accounttype": "Konto-Typ:",
    "helploaderr": "Fehler beim Laden der Hilfedatei. Bitte versuchen Sie es erneut.",
    "hierlock": "Sperre als Untergebener des Managers",
    "items": "Artikel",
    "createchart": "Organigramm erstellen",
    "System": "System",
    "inlist": "in Liste",
    "sortorder": "Bestellung",
    "fourcolumn": "Vier Spalten",
    "checkdelconfirm": "Sind Sie sicher, dass Sie diesen Kontrollpunkt löschen wollen?",
    "max": "MAX",
    "freetrialtl2": "links.",
    "Print Current Screen": "Aktuellen Bildschirm drucken",
    "selectfolder": "Ordner auswählen",
    "checkall": "Alles prüfen",
    "refcirc": "!Rundschreiben Referenz",
    "Normal": "Normal",
    "ql9": "Sehen Sie sich Videos zum Thema 'How To' an.",
    "thousandssep": "1000 Trennzeichen verwenden",
    "Tabloid": "Boulevardzeitung",
    "Shortcuts": "Abkürzungen",
    "totalpages": "Seiten insgesamt",
    "Upload": "Hochladen",
    "action": "Aktion",
    "savingaccountsettings": "Kontoeinstellungen speichern",
    "pagestandard": "Standard",
    "clearprops": "Eigenschaften löschen",
    "enablemw": "Mausrad aktivieren",
    "validmongouserid": "Die minimale Länge der Benutzerkennung beträgt 3 Zeichen.",
    "invalidrange": "Ungültiger Datumsbereich",
    "profsave": "Profil gespeichert.",
    "selfsubs": "Selbst + Untergebene",
    "mergecurfile": "Datei zum Zusammenführen auswählen",
    "takenoaction": "Keine Maßnahmen ergreifen",
    "boxwidth": "Box-Breite",
    "dashedline": "Gestrichelt",
    "saveas": "Speichern unter",
    "saveas (short)": "Speichern unter",
    "showheadfoot": "Kopf- und Fußzeilen anzeigen",
    "scalehorz": "Skalierung zum Füllen der Seite (horizontal)",
    "Show fields": "Felder anzeigen",
    "startdate": "Startdatum:",
    "Crop": "Beschneiden",
    "Bottom": "Unten",
    "buildchart": "Los",
    "selectfieldprop": "Feld und mindestens eine Feldeigenschaft auswählen",
    "selectcmasterIW": "Master-Seite",
    "reload": "Neu laden",
    "ctreload2": "Alle Änderungen werden verworfen.",
    "pngstdquality": "Standard-Qualität",
    "standardm": "Standard",
    "Editing": "Redaktion",
    "Set Font Color": "Schriftfarbe einstellen",
    "curuserchgid": "Die Benutzer-ID des aktuellen Benutzers kann nicht geändert werden.",
    "mymap": "Meine Karte",
    "Field Properties": "Feld-Eigenschaften",
    "Include Active on Leave": "Aktive im Ausgang einbeziehen",
    "spliton": "Aufteilen mit",
    "notinlist": "nicht in der Liste",
    "canEditTemps": "Vorlagen bearbeiten",
    "concatmsg": "Geben Sie Text und Felder zur Verkettung ein. Schließen Sie Felder mit eckigen Klammern ein.",
    "Layout": "Layout",
    "OptionsP": "Optionen...",
    "maxfilesize": "Die maximale Dateigröße beträgt",
    "tupdated": "Box aktualisiert",
    "placeholdercb": "Platzhalter-Organigramm",
    "Range": "Bereich",
    "filtervalid": "Gültige Filterregel",
    "november": "November",
    "source": "Quelle:",
    "appinfo": "Informationen zur Anwendung",
    "DOCUMENT": "Dokument",
    "uiprofile": "Name des Profils",
    "adpoid": "ADP-OID",
    "unziperr": "Die Datei kann nicht entpackt werden. Überprüfen Sie die Zip-Datei und versuchen Sie es erneut.",
    "acctexpired4": "Ihr Konto wurde auf ein schreibgeschütztes Konto herabgestuft. Sie haben weiterhin Zugang zu allen Ihren Dokumenten.",
    "standardppt": "Standard (4:3)",
    "buildpit": "Aus Archiv bauen",
    "sumifdesc": "Summe nur, wenn der Datensatz den definierten Kriterien entspricht.",
    "Filter values": "Filter-Werte",
    "Tools": "Werkzeuge",
    "userstyles": "Benutzer-Stile",
    "branchstyleerr4": "Ungültige Auswahl. Unterbrechungen in Unterorganigrammen nicht erlaubt.",
    "legalps": "Legal",
    "Point In Time": "Punkt in der Zeit",
    "Box Style": "Box-Stil",
    "containstext": "Text eingeben",
    "Profile": "Profil",
    "removecomgr": "Co-Manager-Gruppe entfernen",
    "twocolumn": "Zwei Spalten",
    "datarefreshinfo": "Aktualisieren Sie das aktuelle Organigramm durch Anfordern der Datenquelle.",
    "Yes": "Ja",
    "onecolCR": "Eine Säule Mitte rechts",
    "customps": "Benutzerdefiniert",
    "delbsmsg2": "Warnung: Einige Box-Stile, die von Organigrammvorlagen referenziert werden.",
    "keycontact": "Die wichtigsten Kontakte:",
    "filemgrfolder": "Ordner",
    "a4ps": "A4",
    "Add Access Group": "Zugangsgruppe hinzufügen",
    "profilesavepanel": "Profil speichern",
    "pubdest": "Wählen Sie das Ziel der Veröffentlichung",
    "SubChartLevel": "SubChart Ebene",
    "paywalldropdown": "Upgrade zur Freischaltung von Premium-Funktionen",
    "Complex Rule": "Komplexe Regel",
    "folderadderr": "Es ist nicht möglich, Ordner hinzuzufügen. Bitte versuchen Sie es erneut.",
    "country": "Land:",
    "manageaccessgroups": "Zugangsgruppen verwalten",
    "doprofile": "Mitarbeiterprofil",
    "assistwiz": "Assistenz-Assistent",
    "renameallsc": "Alle umbenennen",
    "newpassinvalid": "Neues Passwort ungültig.",
    "branchstyleerr1": "Ausgewählter Zweigstil nicht erlaubt.",
    "standardh": "Standard-Kopfzeile",
    "CSVRefreshFailure": "Die CSV-Daten konnten nicht geladen werden. Stellen Sie sicher, dass sich die Datei im angegebenen Verzeichnis befindet.",
    "buildhier4": "Daten enthalten Hierarchiefelder",
    "Boxes": "Boxen",
    "prefstyle": "Bevorzugter Stil",
    "Performance": "Leistung",
    "pagelimit": "Einzelne Seitengrenze überschritten!",
    "bringtofront": "Nach vorne bringen",
    "deleteerr": "Es ist nicht möglich, ausgewählte Dateien zu löschen. Bitte versuchen Sie es erneut.",
    "Authentication": "Beglaubigung",
    "frequency": "Frequenz",
    "Monday": "Montag",
    "Load Charts": "Organigramme laden",
    "averagemsg": "Wählen Sie das Feld für den Mittelwert aus.",
    "Utilities": "Versorgungsunternehmen",
    "sortboxescb": "Boxen nach der Aktualisierung sortieren",
    "redeployed": "Nur umverteilt",
    "entityid": "Entitäts-ID:",
    "Connectors": "Verbinder",
    "INSERT": "EINFÜGEN",
    "showmarg": "Randlinien anzeigen",
    "generalchartbuilder": "Allgemeine Chart Builder-Einstellungen",
    "Fields Included": "Enthaltene Felder",
    "sharedstyles": "Gemeinsame Stile",
    "retrieveuser": "Benutzername abrufen",
    "0429": "Zu viele Anfragen. Bitte versuchen Sie es in ein paar Minuten noch einmal.",
    "uploaderror": "Datei kann nicht hochgeladen werden. Bitte versuchen Sie es erneut.",
    "autoopenlogin": "Nach der Anmeldung:",
    "selectcmasterSA": "Optionen für die Master-Seite",
    "curpagesize": "Aktuelle Seitengröße",
    "hexcolor": "HEX-Farbe eingeben",
    "selfdirreports": "Selbst + direkte Berichte",
    "uploadcncl": "Upload abgebrochen",
    "pagedensity": "Seitendichte:",
    "fullaccess": "Voller Zugang",
    "Exit": "Verlassen Sie",
    "Saturday": "Samstag",
    "preserveassist": "Manuelle Identifikation der Assistenten beibehalten",
    "filename": "Dateiname",
    "UI Colors": "UI-Farben",
    "expiredSession": "Die Sitzung ist abgelaufen. Bitte versuchen Sie erneut, sich anzumelden.",
    "usertype": "Benutzer-Typ",
    "tdelete": "Feld gelöscht",
    "permdel": "Sind Sie sicher, dass Sie die ausgewählten Dateien dauerhaft löschen möchten?",
    "deleteallpermmsg": "Sind Sie sicher, dass Sie {fileCount} Dateien im Papierkorb dauerhaft löschen möchten?",
    "ssofail": "Single-Sign on fehlgeschlagen. Klicken Sie hier für weitere Informationen",
    "SpanOfControl": "Kontrollspanne",
    "dec": "Dez",
    "authenticating": "Authentifizierung...",
    "unzipping": "Das Auspacken...",
    "delbsmsg1": "Sind Sie sicher, dass Sie die ausgewählten Box-Stile löschen möchten?",
    "enterhighlight": "Geben Sie hier die Hervorhebungsregel ein",
    "mrbprops": "Eigenschaften der Gruppe",
    "lockedboxes": "Geschlossene Boxen",
    "Chart Name": "Name des Organigramms",
    "setdashed": "Gestrichelt setzen",
    "Matches": "Streichhölzer",
    "Browser": "Browser",
    "basicROPaywall": `Ihre ADP-Rolle erlaubt es Ihnen nicht, Käufe im ADP Marketplace zu tätigen. Um einen Kauf zu tätigen, wenden Sie sich an Ihren ADP Workforce Now-Administrator. Für weitere Informationen senden Sie eine E-Mail an ${supportEmailaddr} oder rufen Sie 1.415.462.1313 an.`,
    "loadingprofile": "Profil laden...",
    "User": "Benutzer",
    "Refreshing": "Aktualisieren",
    "Legend": "Legende",
    "lookupmsg": "Schlagen Sie einen Wert aus einem anderen Datensatz nach.",
    "namescusing": "Name über Feld:",
    "narrowm": "Schmal",
    "Rules": "Regeln",
    "smspass": "Verwenden Sie SMS für den Passwortabruf",
    "feb": "Feb",
    "viewerdatafilters": "Importfilter",
    "preservebo": "Box-Sortierung beibehalten (setzt die Sortierung nach der Aktualisierung außer Kraft)",
    "zoom": "vergrößern",
    "headfoot": "Kopf- und Fußzeile",
    "CopyChartDBConfig": "Wollen Sie eine bestehende Organigrammkonfiguration kopieren?",
    "configerror": "KONFIGURATIONSFEHLER",
    "unitID": "Org-Einheit-ID",
    "ufuserfeed": "UserFeed-Ordner",
    "Levels Shown": "Angezeigte Ebenen",
    "Height": "Höhe",
    "invalidconcatfield": "Regel ungültig. Ein oder mehrere Feldbezüge nicht gefunden",
    "Too many matches Expand your search to narrow the results": "Zu viele Treffer. Grenzen Sie Ihre Suche ein.",
    "insertbreak": "Unterkartenbruch einfügen",
    "deletefoldererr": "Der Ordner kann nicht gelöscht werden. Bitte versuchen Sie es erneut.",
    "Margins": "Ränder",
    "Border Color": "Farbe des Randes",
    "deffilter": "Regel bearbeiten...",
    "schedulerna": "Scheduler nicht für kostenlose Tests verfügbar.",
    "validated": "Validiert",
    "oneline": "Beschränkung auf 1 Zeile",
    "Headers": "Überschriften",
    "iwizselectimport": "Daten importieren",
    "domgraction": "Manager-Aktionen",
    "status": "Status:",
    "Days": "Tage",
    "deltafailure": "Delta-Berichterstellung erfolglos",
    "Account Settings": "Konto-Einstellungen",
    "allsubs": "Alle Untergebenen einbeziehen",
    "Description": "Beschreibung",
    "openfile": "Tabelle öffnen",
    "Tuesday": "Dienstag",
    "showvalues": "Werte anzeigen",
    "selectsupervisorid": "Eingabe-SupervisorID",
    "Configuration": "Konfiguration",
    "readonlyuser": "Nur lesen",
    "workerdemo": "ADP-Vantage",
    "Calculation": "Berechnung",
    "accountdetails": "Kontodetails erfolgreich aktualisiert.",
    "enablepublish": "Veröffentlichung aktivieren",
    "Filters": "Filter",
    "freetext": "Freier Text",
    "legendprops": "Legenden-Editor",
    "reenteremailviewer": "Die Mindestlänge einer E-Mail beträgt 4 Zeichen.",
    "benchtoviewer": "ANSEHEN",
    "refreshwarning1a": "Warnung:",
    "return": "Zurück",
    "autologon": "Automatisch anmelden",
    "Master Page": "Master-Seite",
    "clocktime": "24-Stunden-Uhr",
    "launchto": "Start nach",
    "boxes": "Boxen",
    "Apply": "Bewerben Sie sich unter",
    "separator": "Trennzeichen",
    "less": "weniger als",
    "autoposition": "Start in eigene Chartbox",
    "Border Style": "Rahmen-Stil",
    "duperr": "Es ist nicht möglich, ausgewählte Dateien zu duplizieren. Bitte versuchen Sie es erneut.",
    "Chart Builder": "Organigramm-Ersteller",
    "filterinuse": "Name des bereits verwendeten Filters",
    "file2": "Datei",
    "nofoldersexist": "Keine Ordner vorhanden",
    "rowsecnocharts": "Es wurden keine Organigramme geladen. Fügen Sie ein Organigramm hinzu, um mit der Konfiguration der Sicherheitsregeln zu beginnen.",
    "Print Preview": "Druckvorschau",
    "genreport": "Diagnose-Bericht generieren",
    "Measurements": "Messungen",
    "hscroll": "Blättern (links/rechts)",
    "dataoptions": "Daten-Optionen",
    "grouptype3": "Co-Manager-Gruppe",
    "entirechartplus": "Gesamtes Organigramm (erweitert)",
    "entercompany": "Firmenname eingeben",
    "readwriteuser": "Lesen/Schreiben",
    "publimit2": "Seiten?",
    "transbk": "Transparenter Hintergrund",
    "mobile": "Mobil (optional)",
    "averageifdesc": "Durchschnitt nur, wenn der Datensatz den definierten Kriterien entspricht.",
    "ReportsTo": "Berichte an",
    "equals": "ist gleich",
    "GroupName": "Gruppe:",
    "RefreshConfirm": "Sind Sie sicher, dass Sie dieses Organigramm aus der Datenquelle aktualisieren möchten?",
    "a1ps": "A1",
    "onCommSet": "Benachrichtigen Sie mich über bevorstehende Releases, neue Funktionen und Ankündigungen für OrgChart",
    "Values": "Werte",
    "More": "Mehr",
    "formulaerrnoname": "Name kann nicht leer sein.",
    "Template": "Vorlage",
    "f_name": "Vorname",
    "addexecteam": "„Ausführendes Team' hinzufügen",
    "OrgID": "OrgID",
    "missingmissing": "Das Verzeichnis photos enthält keine missing.jpg.",
    "seattype": "Typ des Sitzes",
    "Merge Data": "Daten zusammenführen",
    "Web": "Web",
    "includereftbl": "Referenztabelle verwenden",
    "Persist": "Bleiben Sie auf",
    "fieldtype": "Feldtyp",
    "maxmsg": "Wählen Sie das Feld für die Max-Funktion aus.",
    "deployment": "Einsatz:",
    "accessgroups": "Zugang Gruppen",
    "agroupdirerr": "Transaktion gescheitert (GROUPDIRFAIL).",
    "scalevert": "Skalierung zum Füllen der Seite (vertikal)",
    "hyperlink": "Hyperlink",
    "loadeddate": "Derzeit geladenes Archiv",
    "loaderr2": "Die erste Zeile der Datendatei muss Feldnamen enthalten.",
    "WorkPhone": "Telefon Arbeit",
    "Newsletters": "Nachrichten",
    "refreshdata": "Daten auffrischen",
    "sysadmin": "Systemadministrator",
    "New": "Neu",
    "invalidaccountdate": "Ungültiges Datumsformat. Bitte verwenden Sie das Datumsformat 'jjjj-mm-tt'.",
    "needid": "Starten Sie eine kostenlose Testversion",
    "aboxcount": "Erlaubte Anzahl der Boxen:",
    "Clipboard": "Zwischenablage",
    "adjboxmarg": "Boxenränder anpassen",
    "SecurityRules": "Sicherheitsregeln",
    "maintainaspect": "Seitenverhältnis sperren",
    "users": "Benutzer",
    "Name": "Name",
    "RestrictP": "Beschränken...",
    "OnlineDocs": "Online-Docs",
    "Include Master": "Master-Seite einbeziehen",
    "userlookup": "Benutzer-Lookup:",
    "Filter": "Filter",
    "fourlines": "Beschränkung auf 4 Zeilen",
    "uploadinprogress": "Datei hochladen...",
    "freetrial1": "Kostenloser Test",
    "Manage": "Verwalten",
    "Properties": "Eigenschaften",
    "Limit to single row": "Beschränkung auf eine einzelne Zeile",
    "createpdf": "PDF erstellen...",
    "You do not have permission to view this chart": "Sie haben keine Berechtigung, dieses Organigramm anzuzeigen.",
    "bssaveerror": "Fehler beim Speichern von Box-Stilen. Bitte versuchen Sie es erneut.",
    "Group Configuration": "Konfiguration der Zugriffsgruppe",
    "matchesfound": "Übereinstimmungen gefunden.",
    "Branch Security": "Sicherheit in der Niederlassung",
    "clearsubgroup": "Untergruppe löschen",
    "savingprofile": "Profil speichern...",
    "downloadprep": "Download vorbereiten...",
    "addassist": "Assistent hinzufügen",
    "Box Properties": "Box-Eigenschaften",
    "cirmask": "Kreisförmige Maske",
    "LookUp": "Nachschlagen",
    "comingsoon": "Demnächst!",
    "defaultgroupname": "Gruppenname eingeben",
    "usemetric": "Anzeigeeinheiten in Zentimetern",
    "Manage Filters": "Filter verwalten...",
    "dblborder": "Doppelte Grenze",
    "savewhat": "Was speichern",
    "Condition": "Bedingung",
    "treesingles": "Baumstil für Einzelpersonen verwenden",
    "alignmiddle": "Mitte ausrichten",
    "iwizerr3": "PersonID- und/oder SupervisorID-Felder, die in den Quelldaten nicht gefunden werden.",
    "customh": "Benutzerdefiniert",
    "addsub": "Untergeordnete Box hinzufügen",
    "doskype": "Skype anrufen",
    "Checkpoint": "Checkpoint",
    "comgr": "Co-Mgrs",
    "sticktop": "Oben auf die Größe kleben",
    "noitems": "Keine Elemente entsprechen Ihrer Suche.",
    "copymessage2": "in die Zwischenablage",
    "Standard": "Standard",
    "curusersysadmin": "Die Sitzart kann für den aktuellen Benutzer nicht geändert werden.",
    "noemailwarning": "Warnung! Benutzer benötigen eine E-Mail, um sich anzumelden. Sind Sie sicher, dass Sie Änderungen speichern möchten?",
    "searching": "Suche...",
    "apikey": "API-Schlüssel",
    "boxlimit": "Boxbeschränkung:",
    "interactive": "Interaktiver Modus",
    "Lookup": "Nachschlagen",
    "apr": "Apr",
    "fieldblank2": "Wählen Sie ein Feld aus.",
    "Saved Filters": "Gespeicherte Filter",
    "closeeditor": "Editor schließen",
    "skype": "Skype",
    "Additional fields": "Zusätzliche Felder",
    "invalidaccesspriv3": "Fehler - Kopfzeile ungültig.",
    "subchartnum": "Unterorganigramm #",
    "Concatenate": "Verkettung",
    "upgradepremiumemail": "Upgrade auf OrgChart Premium",
    "gradientfill": "Gradienten-Füllung",
    "Label": "Etikett",
    "twolines": "Beschränkung auf 2 Zeilen",
    "deleteall": "Alle Dateien löschen",
    "deluserserr": "Die Transaktion ist fehlgeschlagen. Bitte versuchen Sie es erneut (USERDELFAIL).",
    "restrictedlink": "Eingeschränkter Link",
    "iwizerr1": "Der Filter passte zu keinen Datensätzen.",
    "Unzip": "Entpacken",
    "enabledittemp1": "Aktualisieren von Organigrammvorlagen und Box-Stilen",
    "dumpMetadata": "Neuen Checkpoint erstellen",
    "Document": "Dokument",
    "highlightinuse": "Bereits verwendeten Namen hervorheben",
    "alternatetitle": "Alternativer Titel",
    "selectuser": "Benutzer des Eingabedienstes",
    "selectedtemp": "Ausgewählte Organigrammvorlage",
    "genlink": "Link generieren",
    "totalusers": "Benutzer insgesamt.",
    "ppt1ps": "PowerPoint 4:3",
    "perfreport": "Test-Durchführung",
    "alignright": "Recht ausrichten",
    "newchart": "Neue Tabelle",
    "widem": "Breit",
    "levelchartcb": "Ebenenorganigramm erstellen",
    "Home": "Startseite",
    "chartinfo": "Organigramm-Informationen",
    "passreuse": "Das Passwort kann nicht wiederverwendet werden.",
    "Open": "Öffnen",
    "allnonmgr": "Alle Nicht-Führungskräfte",
    "validaccesspriv": "Zugriff auf erfolgreich geladene Privs.",
    "Link Template": "Link-Vorlage",
    "Sunday": "Sonntag",
    "selectimportfile": "Zu importierende Datendatei auswählen",
    "Continue": "Weiter",
    "topboxmin": "Die oberen Kästchen-IDs können nicht leer sein.",
    "PLAN": "PLANEN",
    "optbs": "Optimieren von Zweigstilen",
    "nobreakstoomany": "Einseitiges Organigramm (deaktiviert - zu viele Datensätze)",
    "topboxcb": "Obere Box angeben",
    "freetrial4b": "Rufen Sie die Nummer 1-415-462-1313 an, um Hilfe zu erhalten oder eine Vorführung zu vereinbaren.",
    "exclude": "ausschließen",
    "dayofweek": "Tag",
    "orgname": "Org-Name",
    "refreshtime": "Datum und Uhrzeit aktualisieren",
    "loadMetadata": "Einen Kontrollpunkt hochladen",
    "customexcel": "Benutzerdefiniert...",
    "standardf": "Standard Fußzeile",
    "unknownerrnoemail": "Unbekannter Fehler. Versuchen Sie, die Seite neu zu laden, oder wenden Sie sich an den Support, wenn dieses Problem weiterhin besteht.",
    "publimit1": "Sind Sie sicher, dass Sie veröffentlichen wollen",
    "queryresults": "Top-Position",
    "scopebranch": "Zweig oben verwenden",
    "File": "Datei",
    "No": "Nein",
    "assistrulefield": "Verwenden Sie das Feld 'isAssistent', um die Stile der Assistentenzweige festzulegen",
    "useringroup": "Gruppenmitglieder können auf die Ordner zugreifen:",
    "Support": "Unterstützung",
    "svrchart": "Mein Chart",
    "Version": "Version",
    "uncheckall": "Deaktivieren Sie die Option Alle",
    "resetdirs": "Ordner zurücksetzen",
    "saving2": "[2] Speichern...",
    "Back": "Zurück",
    "newpass": "Neues Kennwort",
    "customm": "Benutzerdefiniert",
    "selectuiprofile": "Eingabe-UI-Profil",
    "concatblank": "Der Text kann nicht leer sein.",
    "pinoff": "Abstecken",
    "stickleft": "Bei Größenänderung links ankleben",
    "jun": "Jun",
    "fileloaderr2": "Daten können nicht geladen werden",
    "passmin": "Mindestlänge ist",
    "Legal": "Legal",
    "Organization ID": "Organisations-ID",
    "blankselection": "Kann nicht sortiert werden. Wählen Sie mindestens ein Feld aus.",
    "Advanced Search Keys": "Erweiterte Suchschlüssel",
    "Mapping": "Kartierung",
    "Create": "Erstellen Sie",
    "setasdef": "Als Standardlayout festgelegt",
    "postfix": "Postfix",
    "Left": "Links",
    "Number": "Nummer",
    "Not In": "Nicht in",
    "Fields": "Felder",
    "newnameuiprofile": "UI-Profil umbenennen",
    "iwizselectmsg3": "Alle Datendateien müssen auf Ihr Cloud-Storage-Konto hochgeladen werden, bevor sie verwendet werden können.",
    "fileloaderr": "Datei kann nicht geladen werden. Prüfen Sie die Dateiberechtigungen.",
    "HELP": "Hilfe",
    "startswith": "beginnt mit",
    "leftpassist": "Linke Peer-Assistentin",
    "boxsimiliar": "Schachteln mit ähnlichem Format",
    "Publish": "Veröffentlichen Sie",
    "iwizselectSAPmsg3": "Alle Datendateien müssen auf Ihr Cloud-Storage-Konto hochgeladen werden, bevor sie verwendet werden können.",
    "ql1": "Erstellen Sie manuell ein neues Organigramm.",
    "copyuiprofile": "UI-Profil kopieren",
    "colorvalmin": "Ungültige Farbe",
    "september": "September",
    "rulevalid": "Regel gültig.",
    "readwrite": "Lesen/Schreiben",
    "SHARE": "Teilen",
    "importwiz": "Import-Assistent",
    "occcode": "Positionscode",
    "delviewmsg1": "Sind Sie sicher, dass Sie die ausgewählten Ansichten löschen möchten?",
    "uploadfailmultiplefiles": "Upload fehlgeschlagen: Mehrere Dateien können nicht hochgeladen werden. Bitte laden Sie immer nur eine Datei hoch.",
    "chartaccess": "Zugriff erlauben",
    "spacingmode": "Boxenabstand auswählen",
    "A4": "A4",
    "Download": "Herunterladen",
    "ReportsToName": "Zu benennende Berichte",
    "All": "Alle",
    "basicPaywallExcl": `OrgChart Premium ist in Ihrer Region noch nicht verfügbar. Für weitere Informationen senden Sie eine E-Mail an ${supportEmailaddr} oder rufen Sie 1.415.462.1313 an.`,
    "formulaerrdupname": "Der Name existiert bereits.",
    "Delete": "Löschen",
    "widescreenppt": "Breitbild (16:9)",
    "accesserr1": "Sie haben keine Berechtigung zum Öffnen dieser Datei.",
    "delfltrwmsg1": "Sind Sie sicher, dass Sie den ausgewählten Filter löschen möchten?",
    "refnotfound": "Nicht gefunden",
    "lefttriangle": "Linkes Dreieck",
    "fileinfoerror": "Verzeichnis kann nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
    "Weekly": "Wöchentlich",
    "Session Timeout": "Auslaufende Sitzung",
    "assistPL": "Assistentin Peer Left",
    "Box Flag": "Box-Flagge",
    "querybuilddataerr": "Ihr Organigramm konnte nicht geladen werden. ",
    "custommaster": "Benutzerdefinierte Master-Seite",
    "deletect": "Sind Sie sicher, dass Sie die ausgewählten Organigrammvorlagen löschen möchten?",
    "Current top box": "Aktuelle top-box",
    "nochartsloaded": "Keine Organigramme geladen",
    "None": "Keine",
    "Launch": "Starten",
    "Reset Password": "Passwort zurücksetzen",
    "math": "MATHEMATIK",
    "jan": "Jan",
    "addcoheadscb": "Co-Head-Organigramm erstellen",
    "comparedirs": "Verzeichnisse vergleichen",
    "Configuration Settings": "Konfigurationseinstellungen",
    "branchstyles": "Zweig-Stile",
    "imageinfo": "Bild-Eigenschaften",
    "bsreload1": "Sind Sie sicher, dass Sie Box-Stile neu laden möchten?",
    "enterhighlightname": "Geben Sie hier den Namen der Hervorhebung ein",
    "customFontMsg": "z.B. Helvetica",
    "Cancel": "Abbrechen",
    "Current View": "Aktuelle Ansicht",
    "Filtered Managers": "Gefilterte Manager",
    "addafolder": "Es existieren keine Dateien",
    "datarefreshoptions": "Daten-Aktualisierungsoptionen",
    "Enter Name Here": "Name hier eingeben",
    "subchartname": "Name des Unterorganigramms",
    "copypuberr": "Es ist nicht möglich, die Ausgabe in den ausgewählten Ordner zu kopieren. Bitte versuchen Sie es erneut.",
    "Locking": "Sperren von",
    "setcolor": "Farbe einstellen",
    "English": "Englisch",
    "nofooter": "Keine Fußzeile",
    "archiveloadsuccess": "Archiv erfolgreich geladen",
    "Master": "Meister",
    "multipage": "Seitenumbrüche einfügen",
    "Missing": "Fehlende",
    "svrsummary": "Mieter-Bericht",
    "Formulas": "Formeln",
    "twocolortri": "Zweifarbiges Dreieck",
    "seatsused": "verwendete Lese-/Schreibplätze",
    "february": "Februar",
    "august": "August",
    "createsvg": "SVG erstellen...",
    "Untitled": "Ohne Titel",
    "applyto": "Bewerben Sie sich bei:",
    "leftcalc": "LINKS",
    "Excel Settings": "Excel-Einstellungen",
    "chiefID": "Position Chef ID",
    "Box Color": "Box-Farbe",
    "optpage": "Seite optimieren",
    "Administration": "Verwaltung",
    "Page size": "Seitengröße",
    "concatenate": "VERKNÜPFEN",
    "Photo": "Foto",
    "entertopbox": "Komma getrennte Liste der Top-Box-IDs eingeben",
    "rightmsg": "Geben Sie Zeichen von der RECHTEN Seite zurück.",
    "tree": "Baum",
    "freeaspect": "Seitenverhältnis freischalten",
    "Chart Settings": "Organigramm-Einstellungen",
    "Open Existing Chart": "Vorhandenes Organigramm öffnen",
    "loginfail": "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "Export": "Export",
    "renamefolder": "Der Ordner kann nicht umbenannt werden. Bitte versuchen Sie es erneut.",
    "quicklinks": "Schnelle Links",
    "Data Refresh Successful!": "Daten-Aktualisierung erfolgreich!",
    "vscroll": "Blättern (nach oben/unten)",
    "LookupR": "Suchergebnis",
    "ActivityLog": "Protokolle...",
    "Existing Chart": "Vorhandene Tabelle",
    "Size": "Größe",
    "grouptype2": "Kopflose Gruppe",
    "copylink": "Link kopieren",
    "Checkpoints": "Kontrollpunkte",
    "customFontTitle": "Neue Schriftart",
    "Restricted fields": "Eingeschränkte Felder",
    "notSelected": "Bitte wählen Sie eine Quelle aus.",
    "Notification": "Benachrichtigung",
    "aligntop": "Oben ausrichten",
    "advancedSettings": "Erweiterte Einstellungen",
    "Definitions": "Definitionen",
    "setChartDefault": "Organigramm als Standard festlegen",
    "Wednesday": "Mittwoch",
    "maximagesize": "Die maximale Bilddateigröße beträgt 1MB.",
    "nameblank": "Name kann nicht leer sein.",
    "ql6": "Veröffentlichen Sie das aktuelle Organigramm als PNG, SVG oder PDF.",
    "moveobjtool": "Objekt bewegen",
    "refreshorgprops": "Refresh-Eigenschaften",
    "Wizard": "Zauberer",
    "optimizing": "Optimieren...",
    "sapoption3": "Getrennte OrgEinheiten und Positionen",
    "Letter": "Brief",
    "Section": "Abschnitt",
    "createnew": "Neu erstellen",
    "Header": "Kopfzeile",
    "tableprops": "Tabellen-Editor",
    "logindisabled": "Anmeldung deaktiviert",
    "uiprofiles": "UI-Profile",
    "pdftype": "PDF",
    "customfont": "Benutzerdefiniert",
    "Number of Boxes": "Angezeigte Boxen",
    "grouptype": "Gruppe Typ",
    "countif": "COUNTIF",
    "adjboxsubs": "Untergeordnete Abstände anpassen",
    "docut": "Text ausschneiden",
    "Preview": "Vorschau",
    "minpagesize": "Minimale Seitengröße",
    "Mouse wheel": "Maus-Rad",
    "combinerecords": "Untergruppe nach Bereich",
    "selecttemplate": "Wählen Sie eine Vorlage aus, die auf das Organigramm angewendet werden soll. Nachdem das Organigramm erstellt wurde, können Sie im Vorlagenbereich zu einer anderen Vorlage wechseln.",
    "Layout Type": "Layout-Typ",
    "doemail": "E-Mail senden",
    "validfile": "Bitte wählen Sie einen gültigen Dateityp aus.",
    "restrictcb": "Abfrage einschränken",
    "enableexporte": "Export nach Excel aktivieren",
    "minmsg": "Wählen Sie das Feld für die Min-Funktion aus.",
    "Default view": "Standard-Ansicht",
    "AutoText": "AutoText",
    "boxingroup": "Alle Felder dieser Gruppe",
    "onecolCL": "Eine Spalte Mitte links",
    "quickstartb": ">>> Öffnen Sie die Schnellstartanleitung",
    "savefolder": "Konto-Ordner",
    "leftblank": "Der Wert kann nicht leer sein.",
    "deleteConfirm": "Sind Sie sicher, dass Sie dieses Organigramm löschen möchten?",
    "peerassistantrule": "Regel zur Identifizierung von Peer-Assistenten verwenden",
    "outoptions": "Organigramm-Größe",
    "Local": "Lokale",
    "sapoption1": "In Position zu Position umwandeln",
    "6004": "Eine oder mehrere Formeln enthalten ungültige Referenzen. Bitte überprüfen Sie die Formeln (Mehr > Organigrammeinstellungen > Felder und Formeln) auf ihre Richtigkeit oder wenden Sie sich an den Kundensupport, wenn dieses Problem weiterhin besteht.",
    "subchartpath": "Unterorganigramm Pfad",
    "enterrgb": "RRGGBB",
    "enablefilemgr": "Dateimanager aktivieren",
    "applymaster": "Vorlage für die Stammseite anwenden",
    "Date Format": "Datumsformat",
    "A3": "A3",
    "optimizebranch": "Optimieren Sie das Seitenverhältnis (wenn die Seite zu klein ist):",
    "ppt3ps": "PowerPoint 16:10",
    "Share": "Teilen",
    "resettocheckpoint": "Aktuellen Checkpoint wiederherstellen",
    "forgotpw": "Passwort zurücksetzen",
    "Refine": "Verfeinern durch",
    "manual": "Handbuch",
    "Invalid or unset default chart Define the default chart in the database config panel": "Ungültige oder nicht eingestellte Standardtabelle. Definieren Sie die Standardgrafik im Datenbank-Konfigurationspanel.",
    "rightleftmsg": "Geben Sie # ein oder brechen Sie das Zeichen ab",
    "Allowed": "Erlaubt",
    "selectimport": "Zu importierende Datendatei auswählen",
    "contains": "enthält",
    "uploadfailtoobig": "Upload abgebrochen - Datei zu groß",
    "resetpwsuccess": "Überprüfen Sie Ihre E-Mail für die Zugangsdaten.",
    "showscpanel": "Subchart-Panel einbeziehen",
    "maxseats": "Alle verwendeten Lese-/Schreibplätze.",
    "sysutilities": "Werkzeuge:",
    "Security Profile Configuration": "Sicherheitskonfiguration",
    "compoundcb": "Multi-Chart-Dokument erstellen",
    "Manual": "Handbuch",
    "dashedborder": "Gestrichelte Grenze",
    "importerr": "Die ausgewählte Datendatei konnte nicht importiert werden. Bevor die Datei importiert werden kann, muss das folgende Problem gelöst werden:",
    "User Information": "Benutzer-Informationen",
    "viewernochartserr": "Es wurden keine Organigramme konfiguriert. Klicken Sie auf Neues Organigramm erstellen, um zu beginnen.",
    "No charts have been configured": "Es wurden keine Organigramme konfiguriert",
    "renamesinglesc": "Ausgewählte umbenennen",
    "yesfileresults": "Suchergebnisse in",
    "Date": "Datum",
    "ppt2ps": "PowerPoint 16:9",
    "creatingchart": "Chart erstellen...",
    "eightcolumn": "Achtspalte",
    "merge": "zusammenführen",
    "enterMyMap": "Eingabe-Zuordnungsfeld",
    "orginfochgfail": "Aktualisierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "Copy": "Kopieren",
    "AddNewChartDBConfig": "Möchten Sie neue Organigramme aus Ihrer Metadaten-Datei hinzufügen?",
    "Linked Template": "Verknüpfte Vorlage",
    "generatepdf": "Herunterladen von PDF",
    "webpublish": "Im Web veröffentlichen",
    "Creating": "Erstellen von",
    "Main Data Source": "Hauptdatenquelle",
    "headerrow": "Freier Text - 1 Spalte",
    "lastpit": "Letztes archiv",
    "oldpass": "Altes Passwort",
    "mathvalid": "Mathematik gültig.",
    "Terms of Service": "Nutzungsbedingungen",
    "findwhat": "Was finden",
    "Columns": "Spalten",
    "Spanish": "Spanisch",
    "stdmaster": "Standard-Stammseite",
    "viewernotset": "Nicht festgelegt",
    "deltaerr": "Fehler bei der Erstellung des Delta-Berichtes",
    "map": "MAP",
    "border": "Grenze",
    "French": "Französisch",
    "expiredate": "Verfallsdatum:",
    "entercheckpointname": "Geben Sie einen Kontrollpunktnamen ein",
    "accessgroup": "Gruppenzugang",
    "reloadusers": "Neu laden",
    "usernamet": "Benutzername eingeben",
    "rpfilter": "Daten filtern",
    "sandboxtool": "Sandbox-Konto:",
    "Map": "Karte",
    "adjboxspace": "Boxenabstände anpassen",
    "Ascending": "Aufsteigend",
    "Row Level Security": "Sicherheit auf Reihenebene",
    "iwizfiltermsg2": "Es werden nur Datensätze importiert, die dem angegebenen Filter entsprechen.",
    "stagger": "Staffelung",
    "autofixhier": "Handhabung mehrerer Abteilungsleiter",
    "supportfunction": "Unterstützende Funktion",
    "filterdata": "Daten filtern",
    "initialpass": "Anfangs-Passwort",
    "selectimportsapfile": "Zu importierende SAP XML-Datei auswählen",
    "basicPaywallLegacy": `Sie haben bereits eine ältere Version von OrgChart abonniert. Senden Sie eine E-Mail an ${supportEmailaddr} oder rufen Sie 1.415.462.1313 an, um zu OrgChart Premium zu wechseln.`,
    "today": "Heute",
    "loaderr6a": "Sie sind beschränkt auf den Import von maximal",
    "Daily": "Täglich",
    "loading": "[1] Lädt...",
    "backlogin": "Zurück zum Anmeldebildschirm",
    "EDIT": "Organigramm bearbeiten",
    "threelines": "Beschränkung auf 3 Zeilen",
    "nobreaks": "Einseitiges Organigramm",
    "Seed Value": "Seed-Wert",
    "ppttype": "PPT",
    "Reset": "Zurücksetzen",
    "managegroups": "Gruppen verwalten",
    "Lock": "Sperre",
    "msgpostlogin": "Zeigen Sie diese Nachricht beim nächsten Login.",
    "of": "von",
    "scaleh": "Skala Höhe %",
    "Branch": "Zweigstelle",
    "selectbs": "Bitte wählen Sie einen Box-Stil",
    "applyingtemplate": "Vorlage anwenden...",
    "saveconf": "Sind Sie sicher, dass Sie gehen wollen? Sie werden alle nicht gespeicherten Änderungen verlieren.",
    "min": "MIN",
    "Theme": "Thema",
    "Records": "Aufzeichnungen",
    "allowedviews": "Erlaubte Ansichten",
    "Change Password": "Passwort ändern",
    "Descending": "Absteigend",
    "Guide": "Leitfaden",
    "linegroup": "Liniengruppe",
    "saveconfirm1": "Wollen Sie Änderungen an",
    "scalew": "Skala Breite %",
    "term": "Laufzeit:",
    "a0ps": "A0",
    "Allrights": "Alle Rechte vorbehalten.",
    "triangle": "Dreieck",
    "addval": "Wert hinzufügen",
    "docall": "Telefon anrufen",
    "a3ps": "A3",
    "UI Profiles": "UI-Profile",
    "unexpectederr": "Aktualisierung fehlgeschlagen. Ein interner Fehler ist aufgetreten.",
    "filenotfound": "Datei nicht gefunden. Bitte geben Sie einen gültigen Dateinamen ein.",
    "Manage Profile": "Profil verwalten...",
    "Optional": "Fakultativ",
    "adphelpemail": "Unterstützung bei der kostenlosen ADP-Testverbindung",
    "noFilterName": "Bitte geben Sie einen Filternamen ein.",
    "replaceall": "Alle ersetzen",
    "fontstyle": "Schriftarten",
    "resizeimage": "Bildgröße ändern",
    "maketop": "Seitenanfang machen",
    "renameerr": "Es ist nicht möglich, ausgewählte Dateien umzubenennen. Bitte versuchen Sie es erneut.",
    "Remove": "Entfernen",
    "Next": "Nächste",
    "advancedoptions": "Erweiterte Optionen",
    "Dynamic Navigation": "Pfeile zur Navigation",
    "Refresh": "Aktualisieren",
    "selectimagefile": "Bild auswählen",
    "selectadpoid": "Eingabe ADP OID",
    "mathmsg": "Berechnung eingeben. Schließen Sie Felder mit eckigen Klammern ein.",
    "copyitem": "Punkt",
    "Details": "Einzelheiten",
    "loadingfolder": "Lädt...",
    "deltareport": "Delta-bericht",
    "Root": "Root",
    "enterfontstyle": "Geben Sie einen Schriftnamen ein (z.B. Helvetica)",
    "pinoptions": "Positionierung",
    "sortfield": "Sortierfeld",
    "sixteencolumn": "Sechzehn Kolonne",
    "dirtyfilter": "Das Organigramm wurde vom Benutzer geändert. Änderungen verwerfen?",
    "loadingpages": "Seite laden",
    "rpmaster": "Master-Seite",
    "enterfiltername": "Geben Sie hier den Namen des Filters ein",
    "Orientation": "Orientierung",
    "alignbottom": "Unten ausrichten",
    "appenddata": "Daten anhängen",
    "emailnote": "E-Mail-Benachrichtigung",
    "tmoveupdate": "Box verschoben & aktualisiert",
    "ReleaseNotesLink": "Veröffentlichungen",
    "generateppt": "Herunterladen von PPT",
    "Required": "Erforderlich",
    "savinggroups": "Änderungen speichern...",
    "lessequal": "weniger oder gleich",
    "Zoom": "vergrößern",
    "connector": "Verbinder:",
    "selectpassword": "Passwort für den Eingabedienst",
    "datarefresh": "Daten-Aktualisierung",
    "bsloaderr": "Fehler beim Laden von Box-Stilen. Bitte versuchen Sie es erneut.",
    "Static Formula Editor": "Statischer Formel-Editor",
    "startpoint": "Der Ausgangspunkt",
    "chartbuildertemplates": "Vorlagen für den Chart Builder",
    "Videos": "Videos",
    "ufsystem": "System-Ordner",
    "restrictblank": "Liste kann nicht leer sein",
    "loaderr7": "Die Anzahl der Datenelemente in einer Zeile muss mit der Anzahl der Felder übereinstimmen (Zeile prüfen:",
    "refreshwarning1b": "Die Option wird nicht für Organigramme mit mehr als 100 Kästchen empfohlen. Verwenden Sie bedingte Formatierung (Organigrammvorlagen) oder Box-Sperren.",
    "preservebs": "Manuelle Änderungen an Zweigstilen beibehalten",
    "Show Username": "Benutzername anzeigen",
    "rowsecallowedfields": "Eingeschlossene Felder sind erlaubt",
    "showFilenames": "Dateinamen anzeigen",
    "freetrial6": "Es besteht keine Verpflichtung Ihnen gegenüber.",
    "canExportExcel": "Export nach Excel",
    "loaderr2b": "Die erste Zeile der Datendatei enthält einen leeren Feldnamen.",
    "In": "In",
    "photoqueue": "Laden von Fotos",
    "Conditional rule": "Bedingte regel",
    "iwizerr0": "Laden von Vorlagen. Bitte versuchen Sie es erneut.",
    "noautoopen": "Keine Maßnahmen ergreifen",
    "subchartwiz": "Unterorganigramm-Assistent",
    "selbranchstyle": "Zweigstil auswählen",
    "Not Equal": "Nicht gleich",
    "unlinkerr1": "Entfernen Sie die Unterteilungsunterbrechungen, bevor Sie die Verknüpfung eines Zweigs aufheben.",
    "month": "Monat",
    "autochildren": "Auto (Kinder)",
    "Assistant": "Assistentin",
    "selectmaster": "Elemente auf der Master-Seite erscheinen auf allen Seiten Ihres Organigramms.",
    "Current": "Aktuell",
    "autobreaks": "Automatische Pausen",
    "DecimalPlaces": "Nachkommastellen",
    "currentimportfile": "Daten importieren aus:",
    "SortP": "Sortieren...",
    "Operation": "Betrieb",
    "toporphans": "Verwaiste Daten auf höchster Ebene",
    "refreshorg": "Organigramm aktualisieren",
    "loaderr6b": "Aufzeichnungen. Sie müssen Ihr Konto aktualisieren, um mehr Datensätze zu importieren.",
    "SupportMsg": "Wenn dieses Problem weiterhin besteht, kontaktieren Sie",
    "currentmaster": "Aktuelle Master-Seite",
    "nofieldvalues": "Keine mit dem Feld verbundenen Werte",
    "compare": "Vergleichen Sie",
    "securityoverride": "Systemsicherheitszuweisung aufheben",
    "loadingdata": "Laden von Daten...",
    "Access Group": "Gruppenzugang",
    "Role": "Rolle",
    "uifont": "UI-Schriftart",
    "Select": "Wählen Sie",
    "loaderr4a": "Feldnamen müssen eindeutig sein. Das Feld",
    "unknownerr": "<Unbekannter Fehler>",
    "includeorphans": "Waisen einschließen",
    "filterbuild": "Die ausgewählten Filter werden beim nächsten Build angewandt.",
    "maxplimit": "Maximale Abfragebegrenzung für mehrere Seiten",
    "singleplimit": "Maximale Abfragebegrenzung auf einer Seite",
    "Plan Status": "Status des Plans",
    "Archive Plan": "Archiv-Plan",
    "importsaveconfirm": "Sie sind gerade dabei, neue Daten zu importieren.",
    "Target": "Ziel",
    "loadheadersfailure": "Ein oder mehrere Probleme wurden bei der Zuordnung der Datenquellenfelder festgestellt. Zur Behebung klicken Sie auf Mapping konfigurieren.",
    "addrestricted": "Eingeschränktes Feld hinzufügen",
    "Lock Plan": "Sperrplan",
    "Enable Administrator User Impersonation": "Aktivieren der Administrator-Benutzer-Imitation",
    "Showing": "Anzeigen",
    "managers": "Manager",
    "Showing X of Y managers": "{visibleCount} von {totalCount} Managern angezeigt",
    "Limit": "Limit",
    "refreshsaveconfirm": "Sie sind gerade dabei, eine Datenaktualisierung durchzuführen.",
    "Change": "Ändern",
    "Show Overlay": "Overlay anzeigen",
    "selectagroup": "Wählen Sie eine Gruppe aus der Liste aus",
    "Browse": "Durchsuchen",
    "viewer": "Betrachter",
    "addnewgroup": "Um eine Gruppe zu erstellen, klicken Sie auf 'Hinzufügen'.",
    "generatedelta": "Delta-Bericht generieren",
    "Additional Tables": "Zusätzliche Tabellen",
    "directory": "Verzeichnis",
    "Compare Plans": "Pläne vergleichen",
    "Talent Pool": "Talente-Pool",
    "savemasteras": "Master speichern unter",
    "Date Modified": "Datum geändert",
    "No Plans Alert": "Hier klicken, um Ihren ersten Plan zu erstellen.",
    "Private": "Privat",
    "addkey": "Schlüssel hinzufügen",
    "Online": "Online",
    "deleteusers": "Möchten Sie die ausgewählten Benutzer wirklich löschen?",
    "addparams": "Parameter",
    "SystemError": "Die Transaktion konnte nicht durchgeführt werden:",
    "Active Plans": "Aktive Pläne",
    "Offline": "Offline",
    "Search Archived Charts": "Archivierte Organigramme durchsuchen",
    "Minimum Group Size": "Mindest-Gruppengröße",
    "deletesource": "Quelldatei nach Aktualisierung löschen",
    "Share with others": "Teilen mit anderen",
    "Delete Plan": "Plan löschen",
    "nosavedfilter": "Keine gespeicherten Filter gefunden.",
    "searchkeys": "Suchschlüssel",
    "Edit Plan": "Plan bearbeiten",
    "Duplicate Plan": "Plan duplizieren",
    "Save Master": "Master speichern",
    "Last Synchronized": "Zuletzt synchronisiert",
    "Away": "Weg",
    "New User": "Neuer Benutzer",
    "Private Plan": "Privater Plan",
    "Plan On": "Planen auf",
    "Plan Explorer": "Plan-Explorer",
    "Error": "Fehler",
    "Planning": "Planung",
    "Plan": "Plan",
    "keyname": "Name des Schlüssels",
    "Starting": "Start",
    "collaborator": "Kollaborant",
    "allowcommitsds": "Übergaben an die Datenquelle erlauben",
    "Save Plan": "Plan speichern",
    "Plan Name": "Name des Plans",
    "containsuser": "Geben Sie Benutzername oder E-Mail ein",
    "notsupported": "Nicht unterstützt von",
    "PersonUnitID": "Position Org-Einheit-ID",
    "deleteuser": "Möchten Sie wirklich den Benutzer löschen",
    "customoutfields": "Verwendung benutzerdefinierter Ausgabefelder",
    "owner": "Eigentümer",
    "allowmanualrefresh": "Lassen Sie dieses Organigramm manuell aktualisiert werden",
    "saveandcontinue": "Änderungen speichern und fortfahren?",
    "Created": "Erstellt",
    "Plan Builder": "Plan-Ersteller",
    "includeself": "Selbst einschließen",
    "Rename Plan": "Plan umbenennen",
    "Plan Metrics": "Plan-Metriken",
    "createcheck": "Klicken Sie auf 'Neu', um einen Kontrollpunkt zu erstellen.",
    "Change Levels": "Ebenen ändern",
    "headerssaveconfirm": "Sie sind gerade dabei, die Datenquelle für das gewählte Organigramm zu modifizieren.",
    "loadtoedit": "Ein Organigramm laden, um Filter und Hervorhebungen zu bearbeiten",
    "NoPlansExist": "Bisher wurden noch keine Pläne angefertigt. Bitte klicken Sie hier oder wählen Sie Neuer Plan, um zu beginnen.",
    "conddefeditor": "Editor für bedingte Definitionen",
    "Edit Box": "Bearbeitungsfeld",
    "Comments": "Anmerkungen",
    "Unlock Plan": "Plan entsperren",
    "people": "Leute",
    "person": "Person",
    "selectf": "Feld auswählen",
    "Plan Name cannot be left blank": "Name des Plans kann nicht unausgefüllt bleiben",
    "Team members": "Team-mitglieder",
    "Distance To Target": "Abstand zum Ziel",
    "Status": "Stand",
    "nosavedhighlight": "Es wurden keine gespeicherten Highlights gefunden.",
    "Open Plan": "Offener Plan",
    "dropdups": "Duplikate ablegen",
    "Archived Plans": "Archivierte Pläne",
    "Comment": "Kommentar",
    "Enter": "Eingabe",
    "Enter (Value)": "Eingabe",
    "New Plan": "Neuer Plan",
    "Dashboard": "Dashboard",
    "Unable to Save Changes": "Speichern von Änderungen nicht möglich",
    "SystemError2": "Laden Sie die Seite neu oder kontaktieren Sie den Support, falls das Problem weiterhin besteht.",
    "restrictq": "Abfrage auf diese Felder begrenzen.",
    "Select a user to start sharing": "Wählen Sie einen Benutzer zum Beginn der Freigabe",
    "6000": "Der Verbinder ist mit dem ausgewählten Dateityp nicht vereinbar.",
    "addoperations": "Klicken Sie auf (+), um Operationen einzufügen.",
    "NoValuesAdded": "Keine Werte. Klicken Sie hier, um sie hinzuzufügen.",
    "Change Topbox": "Topbox ändern",
    "piechartprops": "Kuchendiagramm-Editor",
    "Activity Log": "Aktivitäten-Protokoll",
    "Last Modified": "Letzte Änderung",
    "Active": "Aktiv",
    "Paused": "Pausiert",
    "Inactive": "Inaktiv",
    "Shared Plans": "Geteilte Pläne",
    "background": "Hintergrund",
    "NoSharedUsers": "Sie teilen diesen Plan nicht. Bitte klicken Sie hier, um mit der Freigabe zu beginnen.",
    "addtemplate": "Vorlage hinzufügen",
    "Share Plan": "Teilungsplan",
    "Target Field": "Zielfeld",
    "Enter Plan Name": "Name des Plans eingeben",
    "Change History": "Geschichte ändern",
    "Create Metrics": "Kennzahlen erstellen",
    "Validation Alert": "Validierungs-Alarm",
    "grayscale": "Graustufen",
    "Total Changes": "Gesamte Änderungen",
    "NoMetrics": "Klicken Sie hier, um eine Kennzahl hinzuzufügen.",
    "Moves": "Umzug",
    "Uniform Scaling": "Einheitliche Skalierung",
    "stageNew": "Keine Aufzeichnungen inszeniert. Suchen, um neue Datensätze hinzuzufügen.",
    "Target Value": "Ziel-Wert",
    "Hover Profile": "Hover-Profil",
    "Add Metric": "Kennzahl hinzufügen",
    "Edits": "Bearbeitet",
    "Metric": "Metrisch",
    "Index Page": "Index-Seite",
    "Loading Plan": "Lade Plan",
    "Last Sync": "Letzte Synchronisierung",
    "Building Plan": "Bauplan",
    "Adds": "Fügt hinzu",
    "Deletes": "Löscht",
    "No formulas have been created": "Es wurden keine Formeln erstellt. Wählen Sie Organigrammeinstellungen > Felder & Formeln, um Formeln hinzuzufügen.",
    "Add metrics": "Hinzufügen von Kennzahlen zum Festlegen von Planzielen und Verfolgen von Änderungen",
    "Inverted": "Umgekehrt",
    "Fields editable in plan": "Die folgenden Felder sind in Ihrem Plan editierbar",
    "Shortcut Field": "Kurzbefehl-Feld",
    "fotm": "1. des Monats",
    "Included Headers": "Enthaltene Kopfzeilen",
    "Summary": "Zusammenfassung",
    "Fields available": "Felder, die hier angezeigt werden, werden in Ihrem Plan zur Bearbeitung verfügbar",
    "History": "Geschichte",
    "Sharing & Collaboration": "Gemeinsame Nutzung & Zusammenarbeit",
    "Share to collaborate": "Anderen Nutzern kollaborativen oder Nur-Ansicht-Zugriff auf diesen Plan gewähren",
    "alldivisions": "Alle Abteilungen",
    "Expand": "Erweitern",
    "Select a user to share with": "Wählen Sie einen Benutzer für die Freigabe",
    "motm": "15. des Monats",
    "No archives have been created": "Es wurden keine Archive erstellt",
    "Chart Builder & Publisher Subchart Breaks": "Chart Builder & Publisher Unterorganigramm-Umbrüche",
    "Default Fields": "Standard-Felder",
    "Manage Editable Fields": "Editierbare Felder verwalten",
    "All plans are shared with you": "Alle Pläne werden mit Ihnen geteilt",
    "Metrics & Data Visualization": "Kennzahlen & Datenvisualisierung",
    "Collapse": "Zusammenbruch",
    "Syncing Plan": "Synchronisierungsplan",
    "Effective Dates": "Effektive Termine",
    "Subcharts & Shortcuts": "Unterorganigramme & Abkürzungen",
    "Timeline": "Zeitleiste",
    "by": "von",
    "eotm": "Letzter des Monats",
    "Editable Fields": "Editierbare Felder",
    "Manage metrics": "Kennzahlen verwalten",
    "Documents": "Dokumente",
    "Object": "Objekt",
    "ViewerLoadChartError": "Nur Organigramme, die aus einem Hauptorganigramm erstellt wurden, können zum Viewer hinzugefügt werden. Erstellen Sie Ihr Organigramm mit dem Chart Builder, um es zum Ansichtsfenster hinzuzufügen.",
    "Table Manager": "Tabellen-Manager",
    "tabledeleteconfirm": "WARNUNG: Alle Organigramme, die diese Tabelle als Append-Quelle verwenden, enthalten keine Append-Daten mehr, die mit dieser Tabelle verbunden sind (Änderungen werden bei der nächsten Datenaktualisierung berücksichtigt).\n\nSind Sie sicher, dass Sie diese Tabelle dauerhaft löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "eqdesc": "Bedingte Felder werden ausgeblendet, wenn der Wert eines Datensatzes dem Feldwertkriterium entspricht.",
    "enumeratedbranch": "Aufgezählte Zweige",
    "No Append Entries": "Es wurden keine Append-Einträge erstellt. Verwenden Sie die Schaltflächen auf der linken Seite, um Ihren ersten Eintrag zu erstellen.",
    "Link User Configuration": "Benutzerkonfiguration verknüpfen",
    "Remove rule": "Regel entfernen",
    "neqdesc": "Bedingte Felder werden ausgeblendet, wenn der Wert eines Datensatzes nicht den Feldwertkriterien entspricht.",
    "Also Reports To": "Auch Berichte an",
    "Chart Documents": "Organigrammdokumente",
    "Right Bound": "Rechte Grenze",
    "Revert": "Zurückkehren",
    "Allow public access": "Wenn Sie den öffentlichen Zugriff zulassen, kann jeder im Internet, der eine Verbindung zu diesem Benutzer hat, auf OCN zugreifen. Sind Sie sicher, dass Sie fortfahren möchten?",
    "Months": "Monate",
    "Show Activity": "Aktivität anzeigen",
    "Activity": "Aktivität",
    "Use Source": "Quelle verwenden",
    "Use Plan": "Plan verwenden",
    "Allowed Referrer Domains": "Erlaubte Referrer-Domains",
    "Archive Cleanup": "Archivbereinigung",
    "About Append Tables": "Angehängte Tabellen ermöglichen es Ihnen, Werte aus Ihren Quelldaten zu ändern.",
    "Delegated": "Delegiert",
    "Auto-Assignment Configuration": "Auto-Zuordnung Konfiguration",
    "documentproperties": "Dokument-Eigenschaften",
    "Card": "Karte",
    "Append Table": "Angehängte Tabelle",
    "Left Bound": "Linke Grenze",
    "indesc": "Bedingte Felder werden ausgeblendet, wenn der Wert eines Datensatzes mit einem der Feldwertkriterien übereinstimmt.",
    "formulareservedname2": "Bitte geben Sie einen eindeutigen Feldnamen ein.",
    "Set which groups line up with values in your data": "Einstellen, welche Gruppen mit Werten in Ihren Daten übereinstimmen",
    "Document Settings": "Dokument-Einstellungen",
    "Use Presentation": "Präsentation verwenden",
    "ExportChart": "Organigramm exportieren",
    "dateBracket": "Datumsbereich",
    "Select UI Profile": "UI-Profil auswählen",
    "Source Data": "Quelldaten",
    "topboxids": "Topbox-IDs",
    "Authorization": "Autorisierung",
    "Data field used for assignment": "Datenfeld für die Gruppenzuordnung",
    "Delete Confirm Append Entry": "Sind Sie sicher, dass Sie den ausgewählten Append-Eintrag entfernen möchten? (Änderungen werden bei der nächsten Aktualisierung der Tabelle wirksam).",
    "allowedHighlights": "Erlaubte Highlights",
    "Configure whitelist domains for restricted link access": "Konfigurieren Sie Whitelist-Domänen für eingeschränkten Link-Zugriff",
    "All fields are exported by default": "Alle Felder werden standardmäßig exportiert.",
    "Static Range": "Statischer Bereich",
    "Rule Comparison": "Regelvergleich",
    "Auto Format": "Auto-Formatierung",
    "Use default group instead of denying access": "Standardgruppe verwenden, statt Zugriff zu verweigern",
    "branchaccesslist": "Filialzugriffsfeld",
    "Branch Level Security": "Sicherheit auf Zweigebene",
    "Choose Source": "Wählen Sie zwischen Plan- oder Quellwerten, um den Konflikt aufzulösen.",
    "Master chart used to validate user": "Master-Organigramm verwendet, um Benutzer zu validieren",
    "formulareservedname": "ist ein reservierter Name.",
    "Dynamic Range": "Dynamischer Bereich",
    "Symbols": "Symbole",
    "Date Bracket": "Datumsbegrenz",
    "Automated Chart Export": "Automatischer Organigramm-Export",
    "Use data field for Row Level Security assignment": "Datenfeld für Row Level Security-Zuweisung verwenden",
    "Find Record": "Datensatz suchen",
    "Append Entry Help": "Hinzufügen, Aktualisieren, Verschieben und Unterdrücken von Datensätzen in Ihrem Organigramm.",
    "Older Than": "Archive Löschen Älter Als",
    "Bounded": "Begrenzt",
    "Configure Link Access": "Link-Zugriff konfigurieren",
    "Suppress": "Entfernen",
    "New Table": "Klicken Sie hier, um eine Tabelle zu erstellen.",
    "Allow Public Access": "Öffentlichen Zugriff zulassen",
    "ownbranch": "Auf eigenen Zweig einschränken",
    "Master Charts": "Hauptorganigramm",
    "Reserved Field Name": "Reservierter Feldname",
    "Revert To Source": "Zur Quelle zurückkehren",
    "SFTP": "SFTP",
    "nindesc": "Bedingte Felder werden ausgeblendet, wenn der Wert eines Datensatzes mit keinem der Feldwertkriterien übereinstimmt.",
    "Automatically assign users to access group upon login": "Benutzer bei der Anmeldung automatisch einer Zugriffsgruppe zuordnen",
    "Export Options": "Export-Optionen",
    "useuiprofile": "UI-Profil verwenden",
    "confirmAddDelegated": "Ein Benutzer mit dieser E-Mail-Adresse existiert bereits in einer anderen Organisation. Möchten Sie ihm Zugang zu Ihrer Organisation gewähren?",
    "allowedFilters": "Erlaubte Filter",
    "Employee Removed": "Der Datensatz existiert nicht mehr in den Quelldaten. Machen Sie die Änderung rückgängig, um den Konflikt zu beheben.",
    "Add Branch Rule": "Sicherheitsregel für Zweigstellen hinzufügen",
    "Select a Profile": "Wählen Sie ein Profil",
    "Bounds": "Grenzen",
    "Weeks": "Wochen",
    "Conflict Detected": "Konflikt zwischen Datenquelle und Plan erkannt",
    "Image Settings": "Bild-Einstellungen",
    "Additional Levels": "Zusätzliche Ebenen",
    "personidinuse": "PersonID wird bereits verwendet.",
    "Chart Editor": "Organigrammeditor",
    "User Record Retrieval": "Abrufen von Benutzerdatensätzen",
    "Overwrite Existing Data": "Existierende Daten überschreiben",
    "Append Plan": "Plan Anhängen",
    "confirmexit": "Sie sind sicher, dass Sie beenden wollen",
    "Filter Options": "Optionen filtern",
    "Error importing views message": "Fehler beim Importieren von Ansichten. Stellen Sie sicher, dass Sie die Schaltfläche 'Ansichten exportieren' in einem anderen OCN-Konto verwenden, und klicken Sie auf die Schaltfläche Einfügen auf diesem Bildschirm.",
    "New Record": "Neuer Eintrag",
    "enablegoogleslides": "Google Slides-Export Aktivieren",
    "Please Correct": "Bitte Korrigieren",
    "Interactive": "Interaktiv",
    "Configure the fields used to identify a chart record that corresponds with a user.": "Konfigurieren Sie die Felder, mit denen ein Organigrammdatensatz identifiziert wird, der einem Benutzer entspricht.",
    "No activity yet": "Noch keine Aktivität.",
    "Add Branch": "Zweig hinzufügen",
    "Prebuilt Filters": "Vorgefertigte Filter",
    "Filtering": "Filtern",
    "View successfully imported. Be sure to save the changes to your shared templates and box styles libraries.": "Ansicht erfolgreich importiert. Stellen Sie sicher, dass Sie die Änderungen an Ihren freigegebenen Vorlagen und Box-Styles-Bibliotheken speichern.",
    "addmanualsub": "Untergeben hinzufügen",
    "Interactive Filtering": "Interaktive Filterung",
    "Effective date": "Datum des Inkrafttretens",
    "Confirm Overwrite Manual Data Source": "MIT VORSICHT FORTFAHREN! Durch Ändern Ihrer Datenquellendatei werden alle vorhandenen Daten einschließlich aller manuellen Änderungen überschrieben. \n Möchten Sie Ihre Quelldaten wirklich überschreiben?",
    "Remove Field": "Feld entfernen",
    "Overwrite": "Überschreiben",
    "Add to plan": "Zum Plan hinzufügen",
    "Return to Chart": "Zurück zum Organigramm",
    "privateinfotext": "Mit privaten Links können Sie benutzerdefinierte Einstiegspunkte in Ihr Organigramm einbauen, wobei die Authentifizierung weiterhin erzwungen wird (SSO oder direkte Anmeldung).",
    "Show Details": "Detailen Zeigen",
    "Hit the paste shortcut on your keyboard to import templates": "Klicken Sie auf die Verknüpfung zum Einfügen auf Ihrer Tastatur, um Vorlagen zu importieren",
    "linnkuserconfigwarning": "Für diesen Verbindungstyp wurden keine Benutzer konfiguriert. Gehen Sie zu Mehr -> Konto-Einstellungen -> Autorisierung, um Benutzer für Links zu konfigurieren. Drücke den ? Schaltfläche für weitere Details.",
    "Are you sure you want to": "Sind Sie sicher, dass Sie den Plan Builder schließen möchten?",
    "Move within plan": "Im Plan bewegen",
    "creategoogleslides": "Google Slides erstellen ...",
    "publicinfotext": "Öffentliche Links sind für jeden im Internet zugänglich, wobei ein Link an diesen Benutzer gebunden ist.",
    "Do you want to resume planning in your last open plan?": "Möchten Sie die Planung in Ihrem letzten offenen Plan fortsetzen?",
    "Additional Info": "Zusätzliche Information:",
    "About Plan": "Über Plan",
    "generategoogleslides": "Hochladen von Google Slides auf Google Drive",
    "restrictedinfotext": "Eingeschränkte Links sind gesichert und nur von den von Ihnen angegebenen Websites aus zugänglich.",
    "navtocell": "Tabelle Zeigen",
    "Basic Info": "Basisinformation",
    "Remove from pool": "Aus dem Talent-Pool entfernen",
    "Close Plan Builder": "Plan Builder Schließen",
    "deletemanualbox": "Box Löschen",
    "Shadow": "Schatten",
    "Get Started": "Loslegen",
    "Box Spacing": "Boxabstand",
    "SVG Image": "SVG Bild",
    "Mode": "Modus",
    "Save Alert": "Änderungen speichern?",
    "Justify": "Orient",
    "Dynamic Value": "Dynamischer Wert",
    "See Plans": "Pläne ansehen",
    "Refresh chart now": "Organigramm jetzt aktualisieren",
    "JPG Image": "JPG Bild",
    "supportdeskhelp2": "support-desk",
    "Permission denied to access Planning module. Ensure your role and organization have access to Planning": "Die Berechtigung zum Zugriff auf das Planungsmodul wurde verweigert. Stellen Sie sicher, dass Ihre Rolle und Ihr Unternehmen Zugriff auf Planning haben.",
    "Align Chart Top": "Oben ausrichten",
    "Last Login": "Letzte Anmeldung",
    "Font Selector": "Schriftauswahl",
    "Metadata Type": "Metadatentyp",
    "PNG Image": "PNG Bild",
    "Sync Now": "Jetzt synchronisieren",
    "Buy Now": "Kaufe jetzt",
    "Label Options": "Etikettenoptionen",
    "Do you want to roll up the subordinates from other pages": "Möchten Sie die Untergebenen von anderen Seiten aufrollen",
    "Unable to locate target box!": "Zielbox kann nicht gefunden werden!",
    "Sync plan": "Plan Synchronisieren",
    "Locked plans cannot be synced with base chart data": "Gesperrte Pläne können nicht mit den Basisorganigrammdaten synchronisiert werden",
    "Archived plans cannot be synced with base chart data": "Archivierte Pläne können nicht mit den Basisorganigrammdaten synchronisiert werden",
    "Cannot sync with unsaved background changes": "Synchronisierung mit nicht gespeicherten Hintergrundänderungen nicht möglich",
    "Launch to Self": "Starte zu meinem Rekord",
    "Load Headers": "Header laden",
    "Standard Search": "Standardsuche",
    "Resume last open plan": "Letzten offenen Plan fortsetzen?",
    "Branch Level": "Filialebene",
    "Google Slides": "Google Slides",
    "Save Changes": "Änderungen speichern",
    "PPT Document": "PPT Dokument",
    "Line Thickness": "Dicke der Linie",
    "Remote": "Entfernt",
    "Center Chart Horizontal": "horizontal zentrieren",
    "Open Last Plan": "Letzten Plan öffnen",
    "Launch Configuration": "Startkonfiguration",
    "Box Sort": "Box Sortieren",
    "Line Color": "Linienfarbe",
    "Single Logout": "Einzel Ausloggen",
    "Click Setup Chart to get started": "Klicken Sie auf Setup-Organigramm, um zu beginnen",
    "Please Wait": "Bitte Warten",
    "Delete SSO Configuration": "SSO-Konfiguration löschen",
    "Confirm delete SSO configuration": "Löschen der SSO-Konfiguration bestätigen",
    "SSO Entity ID": "SSO Entitäts ID",
    "Static Value": "Statischer Wert",
    "SSO Configuration": "SSO Konfiguration",
    "Master Chart Settings": "Master-Organigramm Einstellungen",
    "Font Color": "Schriftfarbe",
    "darkmode": "Dunklermodus",
    "Planning Access Denied": "Planungszugriff verweigert",
    "PDF Document": "PDF Dokument",
    "Discard Changes": "Änderungen verwerfen",
    "Staging": "Vorbereitung",
    "Contact your system administrator if this issue persists": "Wenden Sie sich an Ihren Systemadministrator, wenn dieses Problem weiterhin besteht.",
    "Session Warning": "Sie haben eine Zeitüberschreitung aufgrund von Inaktivität. Bitte wählen Sie aus, ob Sie eingeloggt bleiben oder sich abmelden möchten. Andernfalls werden Sie automatisch abgemeldet.",
    "Excel Spreadsheet": "Excel Tabelle",
    "Metadata Location": "Speicherort der Metadaten",
    "Create a Workbench document": "Erstellen Sie ein Workbench-Dokument",
    "No Shortcuts Found": "Keine Verknüpfungen gefunden",
    "lightmode": "Lichtmodus",
    "Auto Provision": "Automatische Bereitstellung",
    "User Value": "Benutzerwert",
    "Revert Change": "Änderung rückgängig machen?",
    "Move Out": "bewegen außerhalb plan",
    "Font Size": "Schriftgröße",
    "Use Value from current User Record": "Wert aus aktuellem Benutzerdatensatz verwenden",
    "Web Link": "Weblink",
    "Cell Fill": "Zellen füllen",
    "Confirm New Password": "Bestätige neues Passwort",
    "Wrap Text": "Zeilenumbruch",
    "leave the Plan Builder": "verlasse den Planbauer",
    "Italic": "Kursiv",
    "Configure AzureAD Photos": "Konfigurieren von AzureAD-Fotos",
    "Exit Plan Builder": "Planerstellung beenden",
    "Enable Workbench": "Workbench Ermöglichen",
    "Privacy Policy": "Datenschutz Bestimmungen",
    "saveconfirm3": "Alle nicht gespeicherten Änderungen gehen verloren.",
    "Master Editor": "Meisterredakteur",
    "SSO Metadata Location": "Speicherort der SSO Metadaten",
    "Group Assigned": "Gruppe zugewiesen",
    "Confirm Delete Plan": "Möchten Sie diesen Plan wirklich endgültig löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "AzureAD Photo Configuration": "AzureAD-Fotokonfiguration",
    "supportdeskhelp": "Wenn das Problem weiterhin besteht, können Sie sich an unseren Kundendienst wenden unter:",
    "Search Name or Title": "Name oder Titel suchen",
    "Password reset successfully. Be sure to update your password manager, if you use one.": "Passwort erfolgreich zurückgesetzt. Stellen Sie sicher, dass Sie Ihren Passwort-Manager aktualisieren, falls Sie einen verwenden.",
    "Pie Chart": "Kreisdiagramm",
    "Stay Logged In": "Bleibe eingeloggt",
    "Plan Needs Sync": "Plan muss synchronisiert werden",
    "Switch To Branch Level": "Zur Zweig Level wechseln",
    "Advanced Search": "Erweiterte Suche",
    "Switch To Field Level": "in Feldebene wechseln",
    "Continue Working": "Zur Filialebene wechseln",
    "Enable Report Issue": "Problem Melden Ermöglichen",
    "Comm Preferences": "Komm. Einstellungen",
    "App Settings": "App Einstellungen",
    "Stay": "Bleibe",
    "Underline": "Unterstreichen",
    "Bold": "Fett gedruckt",
    "Plan Updates Available": "Plan-Updates verfügbar",
    "Revert Confirm": "Möchten Sie diese Änderung wirklich rückgängig machen?",
    "Localization": "Lokalisierung",
    "Set your AzureAD credentials here to import Azure AD photos with your chart data.": "Legen Sie hier Ihre AzureAD-Anmeldeinformationen fest, um Azure AD-Fotos mit Ihren Organigrammdaten zu importieren.",
    "Exit Builder": "Builder beenden",
    "Continue Planning": "Planung fortsetzen",
    "and return to your chart": "und kehren Sie zu Ihrem Organigramm zurück?",
    "SSO Metadata Type": "SSO Metadatentyp",
    "Plan Needs Updates": "Dieser Plan wurde seit dem letzten Öffnen synchronisiert. Bestätigen Sie, um die neuesten Updates zu erhalten.",
    "Open Plan Explorer": "Plan-Explorer öffnen",
    "Show different fields depending on user language.": "Zeigen Sie je nach Benutzersprache unterschiedliche Felder an.",
    "Saved Highlights": "Gespeicherte Highlights",
    "moveoutboxtool": "bewegen außerhalb plan",
    "Center Chart Vertical": "Vertikal Zentrieren",
    "Chart Templates": "Organigrammvorlagen",
    "Presentation": "Präsentation",
    "Current Set": "Aktueller Vorlagensatz",
    "No Recent Documents": "Keine kürzlichen Dokumente",
    "Enter Hex Value": "Hexadezimalwert eingeben",
    "Rename view": "Ansicht umbenennen",
    "Chart Setting Mismatch": "Warnung! Das zu konfigurierende Organigramm unterscheidet sich von dem aktuell geöffneten Organigramm. Die Bearbeitung ist deaktiviert.",
    "Undo": "Rückgängig machen",
    "New Append Table": "Neue Append-Tabelle",
    "SAML Invalid Mapping": "Ungültige oder fehlende Werte im SAML-Gruppenattribut.",
    "SAML Attribute To": "Anwendungssicherheitsgruppe",
    "Manage Views": "Ansichten verwalten",
    "SSO Enabled": "SSO aktiviert",
    "No archives found for this chart.": "Für dieses Organigramm wurden keine Archive gefunden.",
    "Alter the appearance the chart box layout.": "Ändern Sie das Aussehen des Organigrammkastenlayouts.",
    "No records found outside the scope of the plan": "Keine Datensätze außerhalb des Geltungsbereichs des Plans gefunden",
    "Duplicate View": "Doppelte Ansicht",
    "Redo": "Wiederholen",
    "SAML Attributes Handling": "Umgang mit SAML-Attributen",
    "Recent documents": "Zuletzt verwendete Dokumente",
    "Delete View": "Ansicht löschen",
    "Save View": "Ansicht speichern",
    "Field in Record": "Feld im Datensatz",
    "Missing Photos": "Fehlende Fotos",
    "Move View": "Ansicht verschieben",
    "File Name": "Dateiname",
    "Select a view to start editing": "Wählen Sie eine Ansicht aus, um mit der Bearbeitung zu beginnen",
    "Launch Chart Builder": "Chart Builder starten",
    "New View": "Neue Ansicht",
    "Automatically create new users if they do not already exist": "Erstellen Sie automatisch neue Benutzer, wenn sie noch nicht vorhanden sind",
    "Invalid File Name": "Ungültiger Dateiname",
    "SAML Group Attribute": "SAML-Gruppenattribut",
    "No File Selected": "Keine Datei ausgewählt",
    "Open document": "Dokument öffnen",
    "File Manager": "Dateimanager",
    "Custom Accent Color": "Benutzerdefinierte Akzentfarbe",
    "Accent": "Akzent",
    "Roll Up": "Zusammenfassen",
    "Rename Subchart": "Subchart umbenennen",
    "What would you like to do with the subordinates of this manager?": "Was möchten Sie mit den Untergebenen dieses Managers machen?",
    "SSO Enabled Warning": "Sind Sie sicher, dass Sie SSO aktivieren möchten? SSO wird für diese EntityID aktiviert",
    "System Vew Edit Prompt": "Dies ist eine Systemansicht und kann nicht geändert werden.",
    "A file name can't contain": "Ein Dateiname darf die folgenden Zeichen nicht enthalten:",
    "File Preview": "Dateivorschau",
    "Rename Field": "Feld umbenennen",
    "SSO Disabled Warning": "Sind Sie sicher, dass Sie SSO deaktivieren möchten? Alle Benutzer, die derzeit SSO verwenden, können sich nicht mehr mit der IDP anmelden, die der EntityID entspricht.",
    "AdvSecEnterperisePaywall": "Erweiterte Sicherheit ist eine Funktion nur für Enterprise. Weitere Informationen erhalten Sie von Ihrem Vertriebsmitarbeiter.",
    "New SSO Configuration": "Warnung: Bitte aktivieren Sie das Kontrollkästchen SSO aktiviert, um die SSO-Anmeldung zu aktivieren.",
    "Switch Mode": "Modus ändern",
    "View Manager": "Ansichtsmanager",
    "Automatically sign users out of IDP in addition to application sign-out.": "Melden Sie Benutzer zusätzlich zur Anwendungsabmeldung automatisch von IDP ab.",
    "Refresh document": "Dokument aktualisieren",
    "Appearance": "Aussehen",
    "SAML Attribute From": "IDP-Sicherheitsgruppe",
    "Delete Manager": "Manager löschen",
    "Create blank chart": "Leeres Organigramm erstellen",
    "Custom Background Color": "Benutzerdefinierte Hintergrundfarbe",
    "Compare Charts": "Organigramme vergleichen",
    "Plan Options": "Plan-Optionen",
    "Igloo": "Igloo",
    "Click on a topbox from the list below": "Ihre Filterkriterien haben alle Felder auf dem Bildschirm entfernt. Klicken Sie auf eine Topbox aus der Liste unten, um zu einem nicht gefilterten Zweig zu navigieren, oder passen Sie Ihre Filterkriterien an.",
    "Phone": "Telefon",
    "sharepointqerr": "Fehler beim Konfigurieren von SharePoint. Kontaktieren Sie den Kundensupport unter:",
    "NoSharepointConfig": "Unvollständige oder keine SharePoint-Anmeldeinformationen konfiguriert. Klicken Sie hier, um zu konfigurieren.",
    "Effective Dating": "Gültigkeitsdatum",
    "ViewerNoMasterChartsNotAdmin": "Es konnten keine Organigrammdaten geladen werden. Wenden Sie sich an Ihren Systemadministrator, um Ihr Konto zu konfigurieren.",
    "unableOpenPlan": "Plan kann nicht geöffnet werden. Bestätigen Sie die Datenintegrität des Quellorganigramms und die Feldzuordnung.",
    "New Mapping": "Neue Zuordnung",
    "Mute": "Stumm",
    "Reload Directory": "Verzeichnis neu laden",
    "All fields are shown in the Profile Tab by default": "Alle Felder werden standardmäßig im Profil-Tab angezeigt.",
    "Photo Source": "Fotoquelle",
    "AzureAD": "AzureAD",
    "incompletesharepointcreds": "Bitte schließen Sie die automatische SharePoint-Einrichtung ab, indem Sie Ihre SharePoint-Anmeldeinformationen im Bereich Kontoeinstellungen > Autorisierung speichern.",
    "Snapshot": "Schnappschuss",
    "delegatedsameorgemail": "wurde bereits Zugriff auf diese Organisation gewährt.",
    "This is a Point in Time chart generated": "Dies ist ein generiertes Point-in-Time-Organigramm",
    "Metrics": "Messwerte",
    "permanentaction": "Warnung: Diese Aktion kann nicht rückgängig gemacht werden",
    "Additional photo configuration": "Zusätzliche Fotokonfiguration",
    "Users": "Benutzer",
    "No Snapshots found for this chart. Click here to configure automated snapshot generation.": "Für dieses Organigramm wurden keine Snapshots gefunden. Klicken Sie hier, um die automatische Snapshot-Generierung zu konfigurieren.",
    "Sharepoint Domain": "SharePoint-Domäne",
    "Move With Manager": "Umzug mit Manager",
    "Duplicate EntityID": "Die SSO-Konfiguration kann nicht gespeichert werden. Bestätigen Sie, dass die Entitäts-ID korrekt ist, und wenden Sie sich an den Support, wenn das Problem weiterhin besteht.",
    "Invalid SSO Metadata": "Die SSO-Konfiguration kann nicht gespeichert werden. Überprüfen Sie den Metadatentyp und den Speicherort.",
    "No Snapshots found for the above date range.": "Keine Snapshots für den oben genannten Zeitraum gefunden.",
    "ConfigureSharePoint": "Konfiguration der SharePoint-Anmeldeinformationen",
    "Sharepoint Configuration": "Sharepoint-Konfiguration",
    "Select the field to translate based on the end-user's language settings.": "Wählen Sie das zu übersetzende Feld basierend auf den Spracheinstellungen des Endbenutzers aus.",
    "Enable Automatic Archives to Begin Configuring Automated Delta Report Emails": "Aktivieren Sie automatische Archive, um mit der Konfiguration automatisierter Delta-Berichts-E-Mails zu beginnen",
    "Skype": "Skype",
    "Move Manager": "Verschieben Manager",
    "planinfo": "Planinfo",
    "Move Out Manager": "Verschieben den Manager",
    "Filtered Records will be removed when possible": "Gefilterte Datensätze werden nach Möglichkeit entfernt",
    "Field Mapping": "Feldzuordnung",
    "email": "Email",
    "Create an Archive to begin making use of Delta Reports": "Erstellen Sie ein Archiv, um Delta Reports zu verwenden",
    "Add Fields to Table": "Felder zur Tabelle hinzufügen",
    "Filtered records will show with a filter overlay": "Gefilterte Datensätze werden mit einem Filter-Overlay angezeigt",
    "Hyperlink": "Hyperlink",
    "BuilderNoMasterChartsNotAdmin": "Der Chart Builder benötigt ein Master-Organigramm, um schnell Organigramme zu erstellen. Wenden Sie sich an Ihren Systemadministrator, um Ihr Konto zu konfigurieren.",
    "Do you want to create a manual Archive for": "Möchten Sie ein manuelles Archiv erstellen für",
    "restrictedfiletypeupload": "Um diese Art von Datei hochzuladen, gehen Sie zu Workbench → Dokument → Dateimanager",
    "ExportIndexPage": "Das Publizieren mit der Indexseite beschränkt den Download auf 'Gesamtes Organigramm'.",
    "Configure dedicated API photo connectors.": "Konfigurieren Sie dedizierte API-Fotokonnektoren.",
    "Filtered records other than managers will be removed from the chart when possible": "Gefilterte Datensätze, mit Ausnahme von Managern, werden nach Möglichkeit aus dem Organigramm entfernt",
    "Enable SSO": "SSO aktivieren",
    "Change AutoText": "AutoText ändern",
    "DeleteSharepointConfig": "Sind Sie sicher, dass Sie Ihre Sharepoint-Konfiguration dauerhaft löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden.",
    "ssodisableinfotext": "SSO kann NICHT deaktiviert werden, solange die Direktanmeldung deaktiviert ist.",
    "pinobj": "Position anheften",
    "Enable Direct Sign-In": "Direkte Anmeldung aktivieren",
    "Backgrounds": "Hintergründe",
    "estimateorgsize": "Es ist in Ordnung, eine ungefähre Angabe zu machen, Sie können später Mitarbeiter hinzufügen oder entfernen.",
    "HRIS Connection": "HRIS Verbindung",
    "Employee": "Mitarbeiter",
    "Start From Scratch": "Von vorne beginnen",
    "invalidchartappend": "Sie müssen ein Masterorganigramm im Viewer geöffnet haben, um mit der Konfiguration einer Anhangstabelle beginnen zu können.",
    "AggregatedField": "Aggregiertes Feld",
    "Field Picker": "Feld-Auswahl",
    "selectfieldsh": "Welche Datenfelder möchten Sie einschließen?",
    "multiple unread": "ungelesene Nachrichten",
    "SSO Deletion": "SSO Löschung",
    "Interactive Highlighting": "Interaktive Hervorhebung",
    "About BackgroundEditorQuickLink": "Erstellen & Anpassen von Hintergründen",
    "Direct Sign-In": "Direktanmeldung",
    "Edit Users": "Benutzer bearbeiten",
    "Inbox": "Posteingang",
    "Select Build Position Level": "Wie viele Ebenen unter dieser Position möchten Sie einschließen",
    "Data Fields": "Datenfelder",
    "Select Merge Data Source": "Wählen Sie Datenquelle zusammenführen",
    "Disable Direct Sign-In": "Direktanmeldung deaktivieren",
    "signInDisabled": "Die Direktanmeldung wurde deaktiviert. Bitte kontaktieren Sie Ihren Administrator für weitere Informationen.",
    "enumeratedtableprops": "Editor für enumerierte Tabellen",
    "I Use an HRIS System": "Ich verwende ein HR-System",
    "Open Background": "Hintergrund öffnen",
    "About View Manager": "Konfigurieren Sie Ihre Ansichten und Box-Layouts",
    "sloinfotext": "Melden Sie Benutzer automatisch von IDP ab, zusätzlich zur Anwendungsabmeldung.",
    "Review": "Überprüfen",
    "deleteOpenConfirm1": "Sind Sie sicher, dass Sie dieses Organigramm löschen möchten? Sobald Sie Ihre Änderungen speichern, wird das aktuell geöffnete Organigramm geschlossen.",
    "nochartsforplanning": "Es wurden noch keine Organigramme konfiguriert. Bitte klicken Sie hier, um zunächst ein Organigramm zu konfigurieren.",
    "All Files": "Alle Dateien",
    "ssoenableinfotext": "Aktivieren/Deaktivieren Sie, dass sich Benutzer über die konfigurierte IDP anmelden können.",
    "Legacy": "Legacy",
    "Background Editor": "Hintergrund-Editor",
    "openchartdoc": "Dokument öffnen",
    "Currently Applied": "Derzeit angewendet",
    "failedauth": "Authentifizierung fehlgeschlagen",
    "Position Management": "Verwaltung der Position",
    "Max Char Limit Warning": "Warnung Max. Zeichen-Limit",
    "Filters and Highlights": "Filter & Highlights",
    "Open Existing": "Vorhandene öffnen",
    "About Account Settings": "Verwalten Sie Ihre Benutzer und Sicherheitseinstellungen",
    "SAML Email Attribute": "SAML E-Mail-Attribut",
    "Welcome to OrgChart": "Willkommen bei OrgChart",
    "Custom Filter": "Benutzerdefinierter Filter",
    "Diversity": "Diversität",
    "Find by username or email": "Suche nach Benutzernamen oder E-Mail",
    "Allow Photo Search": "Fotosuche zulassen",
    "BackgroundEditorTools": "Werkzeuge",
    "Contact": "Kontakt",
    "enterAttributeNameID": "SAML-Attribut für nameID eingeben",
    "main SAML assertion": "Haupt-SAML-Assertion",
    "Plan Builder Position Directions": "Benennen Sie Ihren Plan, wählen Sie einen Startpunkt und beginnen Sie mit der Planung",
    "Parent PositionID": "Übergeordnete PositionID",
    "I have no data": "Neu beginnen",
    "Start From File": "Aus Datei beginnen",
    "enterorgsizeh": "Wie viele Mitarbeiter hat Ihre Organisation?",
    "addcoheadsplancb": "Co-Head-Plan erstellen",
    "System views cannot be modified": "Systemansichten können nicht geändert werden",
    "Chart Builder Directions": "Wählen Sie einen Startpunkt und klicken Sie auf Erstellen, um einen Plan zu erstellen.",
    "Positions": "Positionen",
    "selectfields": "Wählen Sie die Felder, die Sie in Ihre Organigrammdaten aufnehmen möchten",
    "ssodirectinfotext": "Aktivieren/Deaktivieren Sie, dass sich Benutzer direkt anmelden können.",
    "Delete Sharepoint": "Sharepoint löschen",
    "Turn On": "Einschalten",
    "About API": "Daten aus meinem HR-System synchronisieren",
    "Set the group new users are created in by default.": "Bestimmen Sie die Gruppe, in der neue Benutzer standardmäßig angelegt werden.",
    "Select Initial Import Method": "Wo kann ich die Daten meines Organigramms am besten abrufen?",
    "BackgroundEditorQuickLink": "Hintergrund-Editor",
    "Edit Fields": "Felder bearbeiten",
    "Blank Notification": "Diese Nachricht hat keinen Inhalt.",
    "BreadCrumbs": "Brotkrümel",
    "cohead": "Co-Leiter",
    "reviewmanual": "Wenn alles gut aussieht, klicken Sie auf Fertig stellen, um die Einrichtung abzuschließen!",
    "Reference Table": "Referenz-Tabelle",
    "Default Background": "Standard-Hintergrund",
    "Build Employees Chart": "Welchen Mitarbeiter möchten Sie oben in dieser Tabelle sehen?",
    "Upload Image": "Bild hochladen",
    "Unread": "Ungelesen",
    "Launch directory with all records": "Verzeichnis mit allen Datensätzen starten",
    "Excel File": "Excel-Datei",
    "ssoautoproinfotext": "Automatisch neue Benutzer erstellen, wenn sie noch nicht vorhanden sind.",
    "Welcome Message 2": "Wir brauchen Daten, um Ihr Organigramm zu erstellen",
    "Unread Force Read Messages": "Sie haben wichtige ungelesene Nachrichten, die Sie auswählen müssen, bevor Sie das Benachrichtigungscenter verlassen",
    "Where is your data": "Wo befinden sich Ihre Mitarbeiterdaten",
    "SSO Deletion Warning": "Sie sind im Begriff, diese SSO-Konfiguration zu löschen. Bitte bestätigen Sie, dass Sie fortfahren möchten.",
    "SSO Save Warning": "Dadurch verbleibt die Organisation ohne aktive SSO-Anmeldung. Bitte bestätigen Sie, dass Sie fortfahren möchten.",
    "Maximum character limit reached": "Maximales Zeichenlimit erreicht",
    "Browse Files": "Dateien durchsuchen",
    "No Subject": "Kein Betreff",
    "enterorgsize": "Geben Sie die Anzahl der Datensätze ein, die Sie in Ihrer Organisation haben und klicken Sie auf Weiter",
    "Allow RW Users to Refresh Master Charts": "RW-Benutzern erlauben, Masterorganigramme zu aktualisieren",
    "Recently Opened Charts": "Kürzlich geöffnete Organigramme",
    "Recommended": "Empfohlen",
    "I Have an Excel File": "Ich habe eine Excel-Datei",
    "enterAttributeName": "SAML-Attribut für Namen eingeben",
    "No API Support": "Wir verfügen noch nicht über eine direkte API-Verbindung mit diesem System. Klicken Sie hier, um mit uns über die Einrichtung einer Integration zu sprechen.",
    "Editor Tools": "Editor-Werkzeuge",
    "Select Background": "Hintergrund auswählen",
    "About flatfile": "Daten aus einer Excel- oder CSV-Datei verwenden",
    "Sign-In Enabled Warning": "Sind Sie sicher, dass Sie die direkte Anmeldung aktivieren möchten? Die Benutzer können sich auch außerhalb von SSO anmelden.",
    "Build Employees Plan": "Welchen Mitarbeiter möchten Sie ganz oben auf diesem Plan sehen?",
    "About manualchart": "Manuell meine Daten eingeben",
    "Notification Center": "Benachrichtigungszentrale",
    "New Blank": "Neue leere Seite",
    "Background Name": "Hintergrund Name",
    "addfolder": "Ordner hinzufügen",
    "Choose Plan Name": "Wählen Sie einen Namen für diesen Plan",
    "Select a message to read": "Wählen Sie eine Nachricht zum Lesen",
    "Edit Metrics": "Metriken bearbeiten",
    "Disable SSO": "SSO deaktivieren",
    "Assign Data Source": "Wählen Sie eine Datenquelle, um mit der Einrichtung zu beginnen",
    "Case Insensitive Match": "Groß-/Kleinschreibung nicht beachten",
    "NameID Handling": "NameID-Behandlung",
    "API Connection": "API-Verbindung",
    "Yesterday": "Gestern",
    "Refresh Now": "Jetzt aktualisieren",
    "Create New Background": "Neuen Hintergrund erstellen",
    "Holder": "Stelleninhaber",
    "single unread": "ungelesene Nachricht",
    "What View To Apply": "Welche Ansicht möchten Sie anwenden",
    "Org Size": "Org-Größe",
    "enterAttributeGroup": "SAML-Attribut für Gruppe eingeben",
    "Active Background": "Aktiver Hintergrund",
    "genericsave": "Möchten Sie Ihre Änderungen speichern? Alle nicht gespeicherten Änderungen gehen verloren.",
    "Character length cannot exceed": "Zeichenlänge nicht überschreiten",
    "Chart Builder Position Directions": "Wählen Sie einen Startpunkt und klicken Sie auf Erstellen, um ein Organigramm zu erstellen.",
    "Include Background": "Hintergrund einschließen",
    "Open In Editor": "Im Editor öffnen",
    "Open Image": "Bild öffnen",
    "Enum Table": "Enum-Tabelle",
    "Start From Connection": "Start aus Verbindung",
    "redirectToIDP": "Umleitung zu Ihrer IDP.",
    "Create Field Map": "Feldübersicht erstellen",
    "Page Breaks": "Seitenumbrüche",
    "Plan Builder Directions": "Benennen Sie Ihren Plan, wählen Sie einen Startpunkt und beginnen Sie mit der Planung",
    "Behavior": "Verhalten",
    "SAML attributes": "SAML-Attribute",
    "SAML NameID Attribute": "SAML-Attribut NameID",
    "Setting Up Background": "Hintergrund einrichten",
    "Loading Background Editor": "Hintergrund-Editor laden",
    "Do not automatically format document layout": "Dokumentlayout nicht automatisch formatieren",
    "openbackground": "Hintergrund öffnen",
    "Build Position Plan": "Welche Position möchten Sie oben in diesem Plan haben",
    "Select Language": "Sprache auswählen",
    "PositionID": "PositionID",
    "notvalidated": "Nicht validiert",
    "No chart data loaded mobile": "Keine Organigrammdaten geladen. Wählen Sie die Schaltfläche Aktualisieren im Menü Werkzeuge unten, um die Daten zu laden. Wenn das Problem weiterhin besteht, konfigurieren Sie das Organigramm in der Vollversion von OrgChart.",
    "ManualBlank": "Leer lassen für 4-Personen-Organigramm",
    "This chart exceeds your total box limit": "Dieses Organigramm überschreitet die Anzahl Ihrer Felder",
    "Core": "Kern",
    "deleteOpenConfirm2": "Sie haben das aktuell geöffnete Organigramm gelöscht. Um ein neues Organigramm zu öffnen, schließen Sie das Menü Kontoeinstellungen und wählen dann ein Organigramm aus dem Dropdown-Menü Organigramm in der oberen Symbolleiste.",
    "FieldAccessReminder": "Die Sicherheit auf Zeilenebene gilt für jedes Masterorganigramm. Die Felder und Werte in den Auswahlfeldern hier sind nur mit dem aktuell geöffneten Masterorganigramm verknüpft. Um Felder aus einem anderen Masterorganigramm hinzuzufügen, schließen Sie dieses Panel, wählen das Masterorganigramm aus dem Dropdown-Menü des Organigramms aus und öffnen dann erneut diese Oberfläche.",
    "No Messages": "Keine Meldungen",
    "Select Main Data Source": "Hauptdatenquelle auswählen",
    "Select Build Chart Level": "Wie viele Ebenen unter diesem Mitarbeiter möchten Sie einschließen?",
    "Default Group": "Standardgruppe",
    "No Content": "Kein Inhalt",
    "StaticFormula": "Statische Formel",
    "reviewmanualh": "Organigramm-Einstellung überprüfen",
    "Unhandled Validation": "Die Anmeldedaten können in der Anwendung nicht validiert werden. Bitte überprüfen Sie, ob die von Ihnen eingegebenen Anmeldedaten korrekt sind. Wenn die Validierung weiterhin fehlschlägt, wenden Sie sich bitte an den Support, wenn Sie die Berechtigungsnachweise validieren möchten.",
    "Select Append Data Source": "Anhangdatenquelle wählen",
    "Sign-In Disabled Warning": "Sind Sie sicher, dass Sie die direkte Anmeldung deaktivieren möchten? Die Benutzer können sich dann NUR mit SSO anmelden.",
    "Select Photo Data Source": "Wählen Sie Foto-Datenquelle",
    "About Background Editor": "Konfigurieren Sie Ihre Hintergründe",
    "SAML Name Attribute": "SAML Name Attribut",
    "generateSPMetadata": "SAML SP-Metadaten",
    "Build Position Chart": "Welche Position möchten Sie oben in diesem Organigramm haben",
    "Manual Chart": "Manuelles Organigramm",
    "Default Background Info": "Starten Sie mit einem vorgefertigten Hintergrund",
    "Open Editor": "Editor öffnen",
    "Chart Builder Info": "Verwenden Sie Ihre Basisdaten als Ausgangspunkt für die Erstellung eines benutzerdefinierten Organigramms",
    "enterAttributeEmail": "SAML-Attribut für E-Mail eingeben",
    "Flat File": "Flat-Datei",
    "Please Select Field": "Bitte wählen Sie ein gültiges Feld",
    "About Chart Settings": "Konfigurieren Sie Ihre API-Verbindung und Dateneinstellungen",
    "Load Mapping": "Zuordnung laden",
    "Desired Holders": "Gewünschte Stelleninhaber",
    "lastvalidation": "Zuletzt validiert",
    "Blank Message": "Hier werden die Nachrichten angezeigt",
    "Personal": "Persönlich",
    "Open a chart to begin editing View rules": "Öffnen Sie ein Organigramm, um mit der Bearbeitung der Ansichtsregeln zu beginnen",
    "No profiles defined": "Keine Profile definiert",
    "Older": "Ältere",
    "Compensation": "Vergütung",
    "Employee PositionID": "Mitarbeiter PositionID",
    "Map positions from source data": "Positionen aus Quelldaten zuordnen",
    "Synthesize positional data from employees": "Synthetisieren Sie Positionsdaten von Mitarbeitern",
    "mfaVerify": "Code verifizieren und aktivieren",
    "wrongextension": "Ungültiger Dateityp für den aktuellen Modus ausgewählt.",
    "step2": "Schritt 2",
    "IWizHeadsUp2": "Klicken Sie hier, um zu konfigurieren Masterorganigramme",
    "View successfully imported. Be sure to save the changes to your shared views and box styles libraries.": "Die Ansicht wurde erfolgreich importiert. Stellen Sie sicher, dass Sie die Änderungen in Ihren Bibliotheken für gemeinsame Ansichten und Boxstile speichern.",
    "No Date Found": "Kein Datum gefunden",
    "directoryHotLink": "Verzeichnisschlüssel/Einstellungen ändern",
    "RenamedBreak": "Unterorganigramm umbenannt in",
    "View Unsaved Charts": "Wir haben eine oder mehrere ungespeicherte Charts wiederhergestellt. Möchten Sie sie jetzt ansehen?",
    "Valid Email Address Required": "Gültigen E-Mail Adresse erforderlich",
    "clicktoconfigure": "Klicken Sie hier, um zu konfigurieren",
    "resetAuth": "Authentifikator zurücksetzen",
    "Child": "Datensatz",
    "Specify Top of Chart": "Anfang des Organigramms festlegen",
    "invalidConfirmationCode": "Ungültiger Bestätigungscode.",
    "Chart Document Linked To Master Chart": "Dieses Organigrammdokument ist mit einem Masterorganigramm verknüpft.",
    "Disable MFA Requirement": "MFA-Anforderung deaktivieren",
    "Top of chart": "Anfang des Organigramms",
    "Value Mismatch": "Wert nicht übereinstimmend",
    "Children": "Datensätze",
    "Record Not Found": "Datensatz nicht gefunden",
    "API Timeout": "API-Zeitüberschreitung",
    "Levels Below Topbox": "Ebenen unterhalb der Topbox",
    "groupnamemsg": "Sie benötigen mindestens 3 Zeichen für den Gruppennamen.",
    "GroupNameError": "Gruppenname Fehler",
    "Page Size & Margins": "Seitengröße & Ränder",
    "selectmapping": "Helfen Sie uns, Ihre Daten zu verstehen",
    "Not Configured": "Nicht konfiguriert",
    "switch views": "Ansicht-Sets wechseln",
    "Page properties": "Seiteneigenschaften",
    "mfaStep1Short": "Laden Sie die App herunter",
    "Review Unsaved Charts": "Nicht gespeicherte Organigramme überprüfen",
    "Append Remove Duplicates": "Es wurden doppelte Einträge gefunden. Möchten Sie Ihre Einträge konsolidieren? Hinweis: Diese Aktion ist nicht umkehrbar.",
    "Images": "Bilder",
    "My Highlights": "Meine Highlights",
    "Plan Open Failure": "Sie können den Plan nicht öffnen. Ihre Berechtigungen gewähren Ihnen keinen Zugriff auf diesen Plan oder die erforderlichen Felder innerhalb des Plans. Wenden Sie sich an Ihren Systemadministrator.",
    "RemovedBreak": "Pause entfernt unter",
    "Review Later": "Später überprüfen",
    "mfaInactivePost": "Benutzer haben keine MFA konfiguriert und können sich nicht anmelden. Möchten Sie trotzdem eine Multi-Faktor-Autorisierung verlangen?",
    "QRCodeGen": "Authenticator QR-Code erfolgreich generiert.",
    "mfaConfirmCode": "Bestätigungscode eingeben",
    "Confirm Resolve Conflict": "Bestätigen Sie Änderungen und lösen Sie den",
    "MFA Enabled": "MFA ist derzeit aktiv und bei der Anmeldung erforderlich. Um diese Sicherheitsmaßnahme zu deaktivieren oder mit einem neuen Code neu zu konfigurieren, können Sie unten auf die Schaltfläche Zurücksetzen klicken.",
    "switch view prompt": "Klicken Sie hier, um die Ansicht zu wechseln",
    "Create Group": "Gruppe erstellen",
    "Advanced": "Erweitert",
    "Reports": "Berichte",
    "invalidemail": "Ungültige E-Mail Adresse.",
    "mfaAuthenticator": "Authentikator aktiv",
    "mfaAdminPreReq": "Sie müssen MFA für Ihren Benutzer konfigurieren, bevor Sie die MFA-Anmeldung für Ihr Konto verlangen können. Klicken Sie auf Konfigurieren, um MFA jetzt einzurichten.",
    "ManyExistingAppends": "Es gibt bereits viele Einträge, die hinzugefügt werden können. Klicken Sie auf JA, um zur Liste der vorhandenen Anhänge weitergeleitet zu werden.",
    "Doc Settings No Source": "Dieses Dokument hat keine Datenquelle. Verwenden Sie die Werkzeuge der Werkbank, um Ihre Organigrammdaten zu verwalten.",
    "Select File": "Datei auswählen",
    "invalidCode": "Ungültiger Bestätigungscode.",
    "viewsets": "Ansicht Sets",
    "Presentation Support": "Diese Darstellungsoption wird noch nicht angeboten.",
    "Presentation Support Link": "Wenn Sie so schnell wie möglich Zugang zu dieser Funktion haben möchten, wenden Sie sich bitte an den Support.",
    "Code": "Code",
    "Preexistingid": "Diese ID existiert bereits in Ihrem Plan:",
    "See More Fields": "Weitere Felder anzeigen",
    "reqMFAWarning": "Alle Ihre Benutzer haben MFA aktiviert und können sich weiterhin anmelden, nachdem Sie MFA verlangt haben. Klicken Sie auf Ja, um zukünftige Benutzer zur Einrichtung von MFA zu verpflichten.",
    "Resolve Conflict Later": "Konflikt später lösen",
    "ExistingAppend": "Ein bestehender Anhangseintrag existiert bereits. Klicken Sie auf JA, um zu dem vorhandenen Anhangseintrag weitergeleitet zu werden.",
    "Group Name Exists": "Bitte verwenden Sie einen eindeutigen Namen für Ihre Filtergruppe.",
    "Configured": "Konfiguriert",
    "disableMFAWarning": "Sie haben MFA erfolgreich deaktiviert.",
    "Import From": "Importieren von",
    "Doc Inherits from Master Chart": "Dieses Dokument erbt die Einstellungen von einem Master Chart.",
    "Assistants": "Assistenten",
    "Enabled": "Aktiviert",
    "Bypassed": "Umgangen",
    "mfaStep3Long": "Sobald Sie den obigen QR-Code gescannt haben, geben Sie den von der App generierten 6-stelligen Verifizierungscode ein.",
    "mfaValidateFirst": "MFA wird erst nach einer Überprüfung aktiviert. 1. Bitte laden Sie eine Authentifizierungsanwendung herunter, falls Sie dies noch nicht getan haben. 2. Scannen Sie den QR-Code. 3. Bestätigen Sie den QR-Code.",
    "Resolve": "Lösen",
    "mfaStep2Short": "Scannen Sie diesen Barcode",
    "Point In Time Chart": "Punkt in Zeitorganigramm",
    "mfaNotRequired": "\"Die Deaktivierung der erforderlichen MFA ermöglicht es Benutzern, auf Ihr Unternehmen zuzugreifen, ohne eine MFA-Methode aktivieren und verwenden zu müssen. Benutzer, die MFA bereits aktiviert haben, werden diese weiterhin nutzen, obwohl sie diese nun auch deaktivieren können.\n\nSind Sie sicher, dass Sie fortfahren möchten?\"",
    "Recover Charts": "Organigramme wiederherstellen",
    "Plan Load Record Failure": "Dieser Datensatz existiert nicht mehr in Ihrer Plandatenquelle.",
    "mfaStep2Long": "Öffnen Sie die Authentifizierungs-App und tippen Sie dann auf das '+'-Symbol.\n\nScannen Sie das Bild auf der rechten Seite mit der Kamera Ihres Geräts.",
    "Setting Controlled by Master Chart": "Diese Dokumenteinstellung wird von Ihrem Masterorganigramm gesteuert. Änderungen in diesem Bereich müssen in den Organigrammeinstellungen im Quell-Masterorganigramm vorgenommen werden.",
    "mfaStatus": "MFA-Status",
    "agupdatedbody": "Benutzer mit dieser angewendeten Gruppe werden ihre Rolle erst bei der nächsten Anmeldung ändern",
    "backgroundHotLink": "Hintergründe ändern",
    "selecttopofchart": "Wählen Sie einen Top-Mitarbeiter aus der folgenden Liste",
    "Chart Document": "Organigramm-Dokument",
    "No Changes Detected": "Keine Änderungen erkannt.",
    "step1": "Schritt 1",
    "navtorec": "Zu Datensatz navigieren",
    "Plan Access Denied": "Plan Zugriff verweigert",
    "Picklist": "Auswahlliste",
    "Flat Files": "Flache Dateien",
    "Revert Change and Resolve": "Änderung rückgängig machen und auflösen",
    "mfaSetting": "MFA-Einstellung",
    "Keep MFA Requirement On": "MFA-Anforderung einschalten",
    "Invalid File Type": "Ungültiger Dateityp",
    "Disconnect": "Verbindung zur Hierarchie aufheben",
    "multifactorauth": "Multi-Faktor-Autorisierung",
    "step3": "Schritt 3",
    "recnavprompt": "Möchten Sie zu dem neu hinzugefügten Datensatz navigieren?",
    "mfaStep1LongPre": "Laden Sie eine Authentifizierungs-App herunter und installieren Sie sie auf Ihrem Telefon oder Tablet. Unterstützte Apps sind",
    "Levels Below Top of Chart": "Ebenen unter dem oberen Rand des Organigramms",
    "Conflict": "Konflikte erkannt",
    "Column Mapping": "Spalten-Zuordnung",
    "nofilefiltermatches": "Datei(en) derzeit ausgeblendet. Um diese Dateien zu sehen, ändern Sie den Dateifilter unten rechts.",
    "Unsaved Charts": "Nicht gespeicherte Organigramme",
    "Select Top of Chart": "Anfang des Organigramms wählen",
    "Required & Not Configured": "Erforderlich & nicht konfiguriert",
    "uploaddatafile": "Laden Sie Ihre Datendatei hoch",
    "confirmationCode": "Bitte geben Sie den Bestätigungscode aus Ihrer Authentikator-App ein.",
    "See Less Fields": "Weniger Felder anzeigen",
    "overrideMFA": "Multi-Faktor-Autorisierung außer Kraft setzen",
    "mfaRequired": "Multi-Faktor-Autorisierung ist für die Anmeldung erforderlich",
    "Chain of Command Levels": "Befehlskettenebenen über dem oberen Rand des Organigramms",
    "Presentation Not Available": "Präsentation nicht verfügbar",
    "My Filters": "Meine Filter",
    "Standard Field": "Standard-Feld",
    "wrongextension2": "Bitte wählen Sie einen gültigen",
    "MFA Required": "Die Multi-Faktor-Authentifizierung wird von Ihrem Konto-Administrator verlangt. Wenn Sie Hilfe bei dieser Funktion benötigen, wenden Sie sich bitte an Ihren Kontoverwalter, um Unterstützung zu erhalten.",
    "validCode": "Sie haben die MFA erfolgreich aktiviert.",
    "Show All": "Alle anzeigen",
    "API Timeout Message": "Aufgrund der Art Ihrer API-Integration wird diese Aktualisierung viel länger dauern als üblich. Sie können in der App zwar keine On-Demand-Aktualisierungen vornehmen, aber wir können Ihre Daten während der geplanten automatischen Aktualisierung aktualisieren. Die Details zu Ihrer Aktualisierung finden Sie unter Organigrammeinstellungen > Aktualisieren",
    "Authenticator": "Authentifikator",
    "InsertedBreak": "Pause eingefügt unter",
    "Resolve conflict": "Konflikt lösen",
    "Record Info": "Datensatz-Infos",
    "ReplaceOrAdd": "Die Append-Tabelle enthält bereits Datensätze. Möchten Sie alle Datensätze ersetzen oder Daten an bestehende Datensätze anhängen? Wenn Sie den Upload abbrechen möchten, schließen Sie bitte dieses Fenster.",
    "Changes": "Änderungen",
    "Configure link user": "Link-Benutzer konfigurieren",
    "Edit View": "Ansicht bearbeiten",
    "No Changed Fields": "Es wurden noch keine Felder geändert. Bearbeiten Sie ein Feld im Datensatz, um eine neue Änderung vorzunehmen.",
    "Edit Table": "Tabelle bearbeiten",
    "Formula name cannot contain a period": "Formelname darf keinen Punkt enthalten",
    "Create filters that can be shared with other users": "Filter, die mit anderen Benutzern geteilt werden",
    "Create rule condition": "Regelbedingung erstellen",
    "Search for": "Suchen nach",
    "Add folder": "Ordner hinzufügen",
    "Confirm password": "Bestätigen Sie das Passwort",
    "Create new record": "Neuen Datensatz erstellen",
    "aTitle": "Alternativer Titel",
    "Include clickable navigation arrows connecting pages of the chart. May not be useful when physically printing": "Fügen Sie klickbare Navigationspfeile ein, um die Seiten des Organigramms zu verbinden. Ist möglicherweise nicht nützlich, wenn Sie physisch ausdrucken",
    "Source chart": "Quellenorganigramm",
    "What data fields will be used in this plan?": "Welche Datenfelder werden in diesem Plan verwendet?",
    "Save now": "Jetzt speichern",
    "No background": "Kein Hintergrund",
    "InvalidName": "Ungültiger Name",
    "Auto-sync": "Auto-Synchronisation",
    "Please check the following fields": "Bitte überprüfen Sie die folgenden Felder",
    "Modify UI Profile": "UI-Profil ändern",
    "Enter email address(es) for notification": "E-Mail-Adresse(n) für Benachrichtigung eingeben",
    "Conditional Definition": "Bedingte Definition",
    "Unsaved": "Ungespeichert",
    "Pagination changes": "Seitenumbruch ändern",
    "Show search fields": "Suchfelder anzeigen",
    "Toggle fields to include": "Einzuschließende Felder umschalten",
    "viewnotfound": "Ansicht nicht gefunden",
    "Chart information": "Organigramm-Informationen",
    "Click add rule to start conditionally formatting your chart": "Klicken Sie auf Regel hinzufügen, um mit der bedingten Formatierung Ihres Organigramms zu beginnen",
    "Turn off MFA": "MFA ausschalten",
    "Reports filter": "Filtern Sie Berichte nach dem Basisorganigramm, mit dem sie verknüpft sind.",
    "replacefilesnonew": "Klicken Sie auf \"Vorhandene Dateien ersetzen\", um vorhandene Dateien in diesem Verzeichnis zu aktualisieren oder auf \"Abbrechen\", um den Upload abzubrechen.",
    "Update the automated rules driving chart presentation.": "Aktualisieren Sie die automatischen Regeln für die Darstellung des Organigramms.",
    "Enter formula rule": "Geben Sie hier die Formelregel ein:",
    "Plan changes": "Planänderungen",
    "Do you want to resume work in your last open report?": "Möchten Sie die Arbeit in Ihrem zuletzt geöffneten Bericht fortführen?",
    "Picklist options": "Optionen für Auswahllisten",
    "Picklist type": "Art der Auswahlliste",
    "Enter email address(es) for auto-export": "E-Mail-Adresse(n) für den Autoexport eingeben",
    "Delete Table": "Tabelle löschen",
    "Create group mapping": "Gruppenzuordnung erstellen",
    "Hierarchy": "Hierarchie",
    "Select Build Chart Level Directions": "Wählen Sie die Anzahl der Ebenen, um die Tiefe Ihres Organigramms zu ändern",
    "deleterows": "Zeilen löschen",
    "Box layout editor": "Box-Layout-Editor",
    "Include a page at the end of the export with name and number": "Fügen Sie am Ende des Exports eine Seite mit dem Namen jedes Mitarbeiters und der entsprechenden Seitenzahl ein",
    "autoassignwarningmessage": "Warnung: Diese Funktion gilt global für Ihr Konto. Wenn Sie diese Funktion ohne die richtige Konfiguration aktivieren, können Sie sich selbst und alle Ihre Benutzer für den Zugriff auf OrgChart sperren.\n\nSind Sie sicher, dass Sie fortfahren möchten?",
    "Use 24 hour clock": "24-Stunden-Uhr benutzen",
    "Open Last Report": "Letzten Bericht öffnen",
    "Custom Chart": "Benutzerdefiniertes Organigramm",
    "Discard": "Verwerfen",
    "Align Objects Top": "Objekte oben ausrichten",
    "Enter confirmation code": "Bestätigungscode eingeben",
    "Reset Charts": "Organigramme zurücksetzen",
    "Date Time Format": "Datum-Zeit-Format",
    "You must select a UI profile": "Sie müssen ein UI-Profil auswählen",
    "This plan has changes that are no longer valid": "Dieser Plan enthält Änderungen, die nicht mehr gültig sind",
    "Level up": "Ebene nach oben",
    "Saved": "Gespeichert",
    "Invalid Date": "Ungültiges Datum",
    "insertcolleft": "1 Spalte links einfügen",
    "Position file": "Datei positionieren",
    "Basic info": "Grundlegende Informationen",
    "Level down": "Ebene nach unten",
    "Rule comparison": "Regel-Vergleich",
    "Create new reports of your organization, or run saved reports": "Erstellen Sie neue Berichte Ihrer Organisation, oder führen Sie gespeicherte Berichte aus",
    "Custom SLO Endpoint": "Benutzerdefinierter SLO-Endpunkt",
    "Username": "Benutzername",
    "Choose file": "Datei auswählen",
    "Create checkpoint": "Kontrollpunkt erstellen",
    "Finish editing your view to update these rules": "Beenden Sie die Bearbeitung Ihrer Ansicht, um diese Regeln zu aktualisieren",
    "Add highlights": "Highlights hinzufügen",
    "Resolve later": "Später lösen",
    "Select sort field": "Sortierfeld auswählen",
    "Remove value from field": "Wert aus Feld entfernen",
    "minsubbreaksinfo": "Geben Sie die Mindestanzahl der Felder an, die für das Einfügen eines Unterorganigramms erforderlich sind. Mit dieser Option können Sie die Anzahl der Seiten im generierten Organigramm reduzieren.",
    "Allowed views": "Erlaubte Ansichten",
    "Enter prefix": "Präfix eingeben",
    "Add field": "Feld hinzufügen",
    "Chart details": "Organigramm-Details",
    "Show plans not shared with me": "Nicht mit mir geteilte Pläne anzeigen",
    "topRight": "Oben rechts",
    "Notifications": "Benachrichtigungen",
    "Edit Record": "Datensatz bearbeiten",
    "Would you like to apply layout changes": "Möchten Sie die Änderungen am Box-Layout übernehmen?",
    "Delete formula": "Formel löschen",
    "Approved positions file": "Datei für genehmigte Positionen",
    "Automatically save changes": "Änderungen automatisch speichern",
    "Layout Editor": "Layout-Editor",
    "Show conflicts only": "Nur Konflikte anzeigen",
    "Invalid name": "Ungültiger Name. Darf nicht enthalten",
    "Minimum length is 2 characters": "Mindestlänge ist 2 Zeichen",
    "passcommon": "Das Passwort ist zu häufig. Bitte verwenden Sie ein anderes Passwort",
    "Save background alert": "Möchten Sie eine Kopie Ihres aktuellen Hintergrunds speichern, damit er für andere Organigramme verwendet werden kann?",
    "Background changes will be saved as a new background": "Hintergrundänderungen werden als neuer Hintergrund gespeichert",
    "Add more": "Mehr hinzufügen",
    "Find changes": "Änderungen finden",
    "Cannot edit rule background": "Der Hintergrund kann nicht geändert werden, während er von einer aktiven Ansicht verwendet wird.",
    "Finish editing layout": "Bearbeitung des Layouts beenden",
    "Filter by status": "Nach Status filtern",
    "Name cannot be blank": "Name darf nicht leer sein",
    "Insert break": "Umbruch einfügen",
    "Language": "Sprache",
    "Specify endpoint": "Endpunkt spezifizieren",
    "Treat UTC 0 as Local Browser Time": "UTC 0 als lokale Browserzeit betrachten",
    "View library": "Bibliothek anzeigen",
    "sourcenotfound": "Quelle nicht gefunden",
    "Copy link": "Link kopieren",
    "Include elements on the background, such as logos, legends, tables, and page numbers": "Elemente auf dem Hintergrund einbeziehen, wie Logos, Legenden, Tabellen und Seitenzahlen",
    "Click here to select data source": "Klicken Sie hier, um die Datenquelle auszuwählen",
    "Manage available views": "Verfügbare Ansichten verwalten",
    "Configure a flag and label for the selected boxes": "Konfigurieren Sie eine Markierung und Beschriftung für die ausgewählten Felder",
    "Create report": "Bericht erstellen",
    "Record": "Aufzeichnen",
    "Dynamic formula": "Dynamische Formel",
    "Reset view": "Ansicht zurücksetzen",
    "Save copy": "Kopie speichern",
    "automaticarchive": "Automatisches Archiv",
    "No top box specified": "Keine Topbox angegeben",
    "Destination": "Ziel",
    "Find branches": "Filialen finden",
    "Default levels": "Standard-Ebenen",
    "Configure group field mapping": "Gruppenfeldzuordnung konfigurieren",
    "Specify page size": "Seitengröße festlegen",
    "No highlights have been added": "Es wurden keine Markierungen hinzugefügt",
    "Maps to": "Zuordnen zu",
    "Background Settings": "Hintergrund-Einstellungen",
    "No plan description": "Keine Planbeschreibung",
    "Save and run": "Speichern und ausführen",
    "Select organization": "Organisation auswählen",
    "There are no reference tables": "Es gibt keine Referenztabellen",
    "Open report explorer": "Berichtsexplorer öffnen",
    "Site": "Website",
    "Add data source": "Datenquelle hinzufügen",
    "Self level info": "Verwendeter Wert ist der Organigrammdatensatz des aktuellen Benutzers",
    "Inserted subchart break": "Unterorganigrammunterbrechung einfügen",
    "Resume last open report": "Zuletzt geöffneten Bericht fortsetzen?",
    "Powerpoint document": "Powerpoint-Dokument",
    "Create rule comparison": "Regelvergleich erstellen",
    "Apply filter": "Filter anwenden",
    "Main data": "Hauptdaten",
    "Which boxes should this rule apply to?": "Auf welche Felder soll diese Regel angewendet werden?",
    "Your chart has an automatic sort configuration applied": "Auf Ihr Organigramm wurde eine automatische Sortierkonfiguration angewendet. Um Ihre Felder manuell zu sortieren, entfernen Sie die automatische Sortierkonfiguration auf der Registerkarte Sortieren in Ihrer Seitenleiste",
    "Selected field label": "Beschriftung des ausgewählten Feldes",
    "Select chart to configure": "Wählen Sie das zu konfigurierende Organigramm",
    "OR": "ODER",
    "Deselect All": "Alle abwählen",
    "reqFieldNotMapped": "Erforderliches Feld bitte zuordnen.",
    "Field value criteria": "Kriterien für Feldwert",
    "Remove data source": "Datenquelle entfernen",
    "Use OAuth2.0 Authentication": "OAuth2.0-Authentifizierung verwenden",
    "Edit formula": "Formel bearbeiten",
    "Chart Explorer": "Organigramm-Explorer",
    "Loading archive": "Archiv laden",
    "Subchart name field": "Namensfeld des Unterorganigramms",
    "LinkUserNotSelectedError": "Bitte wählen Sie einen Link-Benutzer",
    "Notify people": "Personen benachrichtigen",
    "Creating Archive": "Archiv erstellen",
    "Unable to find topbox": "Topbox kann nicht gefunden werden",
    "Select a new topbox": "Neue Topbox auswählen",
    "recordField": "Aufzeichnungsfeld",
    "Privacy policy": "Datenschutz",
    "Selected background": "Ausgewählter Hintergrund",
    "Saved filters": "Gespeicherte Filter",
    "Delete element": "Element löschen",
    "Create New Table": "Neue Tabelle erstellen",
    "CreateFieldMap": "Feldübersicht erstellen",
    "Show less information": "Weniger Informationen anzeigen",
    "Return using": "Zurückkehren mit",
    "Branch level security": "Sicherheit auf Zweigebene",
    "Create Override": "Überschreibung erstellen",
    "clearformat": "Formatierung löschen",
    "ChangeAppendInfo": "Datensatzinformationen aktualisieren",
    "ComplexRule": "Komplexe Regel",
    "Create new conditional rule": "Erstellen Sie Ihre eigenen Bedingungen, um komplexe Regelkriterien zu definieren",
    "Enter formula name": "Formelnamen eingeben",
    "Add field value to rule criteria": "Feldwert zu Regelkriterien hinzufügen",
    "Refresh from source": "Von Quelle aktualisieren",
    "passincnum": "Enthält mindestens eine Zahl",
    "Select which charts should use this background by default": "Wählen Sie aus, welche Organigramme diesen Hintergrund standardmäßig verwenden sollen",
    "datagroupmapping": "Datengruppen-Zuordnung",
    "Value mismatches": "Unstimmige Werte",
    "Duplicate view": "Ansicht duplizieren",
    "Choose which fields to include in the order in which they will appear. Drag fields from one column to the other.": "Wählen Sie, welche Felder in der Reihenfolge, in der sie erscheinen sollen, aufgenommen werden sollen. Ziehen Sie Felder von einer Spalte in die andere.",
    "Create custom chart": "Benutzerdefiniertes Organigramm erstellen",
    "Start breaks at": "Umbrüche beginnen bei",
    "View rules": "Regeln für die Ansicht",
    "OptFieldMap": "Optionale Feldzuordnung",
    "Label and value": "Beschriftung und Wert",
    "Default background": "Standard-Hintergrund",
    "Changes will be applied next data refresh": "Änderungen werden nach der nächsten Datenaktualisierung übernommen",
    "Margin": "Randbereich",
    "Edit Whitelist Domain": "Whitelist-Bereich bearbeiten",
    "Save layout changes": "Layoutänderungen speichern",
    "Report owner": "Besitzer des Berichts",
    "Saving": "Speichern von",
    "Download this screen": "Diesen Bildschirm herunterladen",
    "Clear search filters": "Suchfilter löschen",
    "Some sources require additional photo configuration in order to pull photos": "Einige Quellen erfordern eine zusätzliche Fotokonfiguration, um Fotos abrufen zu können",
    "nosubchartupdate": "Das Unterorganigramm-Panel wird nicht aktualisiert, bis eine Aktualisierung erfolgt.",
    "Set picklist": "Auswahlliste festlegen",
    "Choose which boxes (some boxes or all boxes) for this rule to target": "Wählen Sie, auf welche Felder (einige oder alle Felder) diese Regel angewendet werden soll",
    "Select formula field": "Formelfeld auswählen",
    "No Name": "Kein Name",
    "Click + to add an operation": "Klicken Sie auf +, um eine Operation hinzuzufügen",
    "Configure field mapping": "Konfigurieren Sie die Feldzuordnung",
    "Display Name": "Name anzeigen",
    "No rule conditions": "Keine Regelbedingungen. Klicken Sie hier, um hinzuzufügen.",
    "Currently used seats": "Derzeit verwendete Plätze",
    "Create new user": "Neuen Benutzer erstellen",
    "record": "aufnehmen",
    "Create highlights that can be shared with other users": "Hervorhebungen, die mit anderen Benutzern geteilt werden",
    "Report explorer": "Bericht-Explorer",
    "Create formula": "Formel erstellen",
    "Function": "Funktion",
    "Report Blank": "Der Name des Berichts kann nicht leer sein.",
    "Mouse controls": "Maussteuerung",
    "Fields and formulas": "Felder und Formeln",
    "Create new group": "Neue Gruppe erstellen",
    "Report information": "Informationen zum Bericht",
    "Subchart sorting": "Sortierung von Unterorganigrammen",
    "Export a higher quality image to embed into a Word document or PowerPoint presentation": "Exportieren eines Bildes in höherer Qualität zum Einbetten in ein Word-Dokument oder eine PowerPoint-Präsentation",
    "Data Source Details Unavailable": "Einige Organigrammdetails sind bei älteren Organigrammdokumenten möglicherweise nicht verfügbar.",
    "AutoPopulateViewsFailure": "Maximale Anzahl von Ansichten (10) für dieses Organigramm erreicht. Bitte entfernen Sie eine Ansicht, bevor Sie eine weitere hinzufügen.",
    "Distribute Space Vertical": "Platz vertikal verteilen",
    "deletefield": "Feld",
    "Validate": "Validieren",
    "Reports to": "Berichtet an",
    "LoadMap": "Feldzuordnung laden",
    "Enable automatic clean-up": "Automatische Bereinigung aktivieren",
    "Create new filter": "Neuen Filter erstellen",
    "bypasstemplatelistwarning": "Benutzer mit der Berechtigung, Ansichten und Boxstile zu bearbeiten, können alle gemeinsamen Ansichten im Konto sehen und bearbeiten.",
    "Apply to all subcharts": "Auf alle Unterorganigramme anwenden",
    "Apply to chart": "Auf Organigramm anwenden",
    "Look up using": "Nachschlagen mit",
    "Filter by chart": "Nach Organigramm filtern",
    "Requirement": "Anforderung",
    "Value only": "Nur Wert",
    "Revert All Changes": "Alle Änderungen rückgängig machen?",
    "Run": "ausführen",
    "Line weight": "Strichstärke",
    "More options view": "Ansicht der weiteren Optionen",
    "Application details": "Details zur Anwendung",
    "Select frequency": "Frequenz auswählen",
    "mergeall": "Alle zusammenführen",
    "Match using": "Abgleichen mit",
    "Set which formatting or style properties should apply to boxes that meet the criteria above": "Legen Sie fest, welche Formatierungs- oder Stileigenschaften auf Felder angewendet werden sollen, die die oben genannten Kriterien erfüllen",
    "Edit this chart to adjust the filter": "Dieses Organigramm bearbeiten, um den Filter anzupassen",
    "Wrap text": "Text umbrechen",
    "Edit this custom chart": "Dieses benutzerdefinierte Organigramm bearbeiten",
    "Reporting": "Berichte",
    "Append Tables": "Tabellen anhängen",
    "Exclude all": "Alle ausschließen",
    "passincupp": "Enthält mindestens einen Großbuchstaben",
    "lastarchive": "Letztes Archiv",
    "maxboxlimiterr": "Sie haben die maximal zulässige Anzahl von Feldern auf einer Seite überschritten. Administratoren können dieses Limit aktualisieren",
    "Filter behavior": "Verhalten filtern",
    "Manage access": "Zugang verwalten",
    "bottomLeft": "Unten links",
    "insertrowbelow": "1 Zeile unten einfügen",
    "Cell formatting": "Zelle formatieren",
    "Conflict detected": "Konflikt festgestellt",
    "Add value to field": "Wert zum Feld hinzufügen",
    "autoassignwarningheader": "Automatische Gruppenzuordnung einschalten?",
    "Box height": "Höhe des Feldes",
    "Tenant ID": "Mieter-ID",
    "Allowed highlights": "Erlaubte Highlights",
    "Don't have an account?": "Sie haben kein Konto?",
    "fieldFormatWarning": "Regeln können jeweils nur eine Feldformatänderung anwenden. Erstellen Sie zusätzliche Organigrammregeln, um weitere Feldformatänderungen auf Ihr Organigramm anzuwenden",
    "Plans": "Pläne",
    "Target field": "Zielfeld",
    "Chart background": "Organigramm Hintergrund",
    "Field lookup": "Feldsuche",
    "Rule definition": "Regel-Definition",
    "Ensure all boxes on each page are identically sized. This generally means boxes will be smaller than usual to accomodate large pages": "Stellen Sie sicher, dass alle Felder auf jeder Seite die gleiche Größe haben. Das bedeutet im Allgemeinen, dass die Felder kleiner als üblich sind, um große Seiten unterzubringen.",
    "topLeft": "Oben links",
    "Available views": "Verfügbare Ansichten",
    "Elements": "Elemente",
    "App preferences": "App-Einstellungen",
    "Select fields included in delta report": "Felder für den Delta-Bericht auswählen",
    "Photos": "Fotos",
    "Top box of chart": "Top Box des Organigramms",
    "Use approved positions table": "Tabelle der genehmigten Positionen verwenden",
    "Schedule Chart Refresh": "Aktualisierung des Organigramms einplanen",
    "Open chart explorer": "Organigramm-Explorer öffnen",
    "Please wait": "Bitte warten",
    "Shared users": "Gemeinsame Benutzer",
    "Revert to source": "Zur Quelle zurückkehren",
    "Basic math operation": "Grundlegende mathematische Operation",
    "Date from": "Datum von",
    "Choose date": "Datum auswählen",
    "Unable to sort": "Sortieren nicht möglich",
    "Create metrics": "Metriken erstellen",
    "Use existing background": "Vorhandenen Hintergrund verwenden",
    "Select value": "Wert auswählen",
    "Separator": "Trennzeichen",
    "Enter Target Value": "Zielwert eingeben",
    "Move element": "Element verschieben",
    "Revert to": "Zurückkehren zu",
    "Formatting changes": "Änderungen der Formatierung",
    "after": "nach",
    "Date to": "Datum auf",
    "Cannot change background. This view is applying a rule driven background.": "Hintergrund kann nicht geändert werden. Diese Ansicht wendet einen regelgesteuerten Hintergrund an.",
    "Use tree style for singles": "Verwenden Sie den Baumstil für Einzelpersonen",
    "Treat value as": "Wert behandeln als",
    "Value comparison": "Wertevergleich",
    "Branch level info": "Filialebene prüft, ob ein Datensatz in der Filiale des aktuellen Benutzers vorhanden ist",
    "Sign up": "Anmelden",
    "Titles": "Titel",
    "New plan": "Neuer Plan",
    "Disable MFA requirement": "MFA-Anforderung deaktivieren",
    "Create custom rule": "Benutzerdefinierte Regel erstellen",
    "Contact plan owner to add additional fields": "Planbesitzer kontaktieren, um zusätzliche Felder hinzuzufügen",
    "Use (Legacy) API Key": "(Veralteten) API-Schlüssel verwenden",
    "White": "Weiß",
    "Enable MFA requirement": "MFA-Anforderung einschalten",
    "Target value": "Zielwert",
    "Recalculating": "Neuberechnen",
    "Link copied": "Link in die Zwischenablage kopiert",
    "See Reports": "Siehe Berichte",
    "Aux details": "Hinzufügen von zusätzlichen Berichtsbeziehungen, die in Ihren Daten vorhanden sind",
    "Vertical align": "Vertikal ausrichten",
    "What would you like to do with this record": "Was möchten Sie mit diesem Datensatz tun?",
    "Field Label": "Feldbezeichnung",
    "Use Table": "Tabelle verwenden",
    "bottomRight": "Unten rechts",
    "Set the top box and add co-heads": "Den oberen Rahmen festlegen und Co-Heads hinzufügen",
    "Preferred Last": "Zuletzt ausgewählt",
    "Default mode": "Standardmodus",
    "Add custom gradient": "Benutzerdefinierten Farbverlauf hinzufügen",
    "Seat limit": "Sitzplatzbegrenzung",
    "Make a copy": "Eine Kopie erstellen",
    "Download report": "Bericht herunterladen",
    "Max box limit for single page": "Maximale Boxbegrenzung für eine Seite",
    "disconnected record": "getrennter Datensatz",
    "Disconnected": "Getrennt",
    "Delimiter": "Begrenzer",
    "Save changes to filter": "Änderungen am Filter speichern",
    "Constrained": "Eingeschränkt",
    "Upload file": "Datei hochladen",
    "Continue Reporting": "Bericht fortsetzen",
    "Log in to your": "Melden Sie sich bei Ihrem",
    "OrgChart account": "{gAppName}-Konto an",
    "Edit import filter": "Importfilter bearbeiten",
    "disconnected records": "Getrennte Datensätze",
    "Enter break character": "Unterbrechungszeichen eingeben",
    "Conditions": "Bedingungen",
    "Create dynamic formula": "Dynamische Formel erstellen",
    "Refine your search": "Verfeinern Sie Ihre Suche",
    "IAT endpoint": "IAT-Endpunkt",
    "Enter postfix": "Postfix eingeben",
    "mergeField": "Feld zusammenführen",
    "deletevalues": "Werte",
    "Choose operation": "Operation auswählen",
    "reqFieldsNotMapped": "Die Aktualisierung ist erst möglich, wenn alle erforderlichen Felder zugeordnet sind.",
    "Data sync automatic": "Daten werden automatisch synchronisiert",
    "Branch pruning": "Zweigbeschneidung",
    "Clear all": "Alles löschen",
    "Time": "Zeit",
    "Revert all changes to": "Alle Änderungen rückgängig machen in",
    "Confirm field revert": "Sind Sie sicher, dass Sie dieses Feld auf den Ausgangswert zurücksetzen möchten?",
    "No values have been added": "Es wurden keine Werte hinzugefügt",
    "Model, filter, and build your own custom chart off the shared base chart": "Modellieren, filtern und erstellen Sie Ihr eigenes benutzerdefiniertes Organigramm auf der Grundlage des gemeinsamen Basisorganigramms.",
    "Edit user": "Benutzer bearbeiten",
    "Email MFA setup link": "MFA-Einrichtungslink per E-Mail",
    "Welcome back. Please enter your credentials.": "Willkommen zurück. Bitte geben Sie Ihre Anmeldedaten ein.",
    "Advanced search fields": "Erweiterte Suchfelder",
    "Delete criteria": "Kriterien löschen",
    "No Tables Exist": "Es sind keine Tabellen vorhanden. Klicken Sie hier, um alle Tabellen zu verwalten.",
    "What should be done to those boxes?": "Was soll mit diesen Feldern gemacht werden?",
    "Applied by": "Angewendet von",
    "Application Security": "Anwendungssicherheit",
    "Append data": "Daten anhängen",
    "Merge data": "Daten zusammenführen",
    "Would you like to save layout changes": "Möchten Sie die Layoutänderungen speichern? Alle Ansichten, die diesen Boxstil verwenden, werden aktualisiert.",
    "Would you like to save layout changes plural": "Möchten Sie die Layoutänderungen speichern? Alle Ansichten, die diese Boxstile verwenden, werden aktualisiert.",
    "exportusers": "Benutzer exportieren",
    "Finish editing your chart to update these rules": "Beenden Sie die Bearbeitung Ihres Organigramms, um diese Regeln zu aktualisieren",
    "Include terminated employees": "Beendete Mitarbeiter einbeziehen",
    "mfaActive": "Multi-Faktor-Authentifizierung ist aktiv",
    "Select format": "Format auswählen",
    "Included fields": "Eingeschlossene Felder",
    "Allowed filters": "Erlaubte Filter",
    "Renamed Subchart": "Unterorganigramm umbenennen",
    "Add sort key": "Sortierschlüssel hinzufügen",
    "All changes will be lost": "Alle Änderungen gehen verloren",
    "This chart only": "Nur dieses Organigramm",
    "Last run": "Letzter Durchlauf",
    "Active on leave": "Aktiv bei Verlassen",
    "Currently used boxes": "Aktuell verwendete Felder",
    "List options": "Optionen auflisten",
    "Removed subchart break": "Unterorganigrammunterbrechung entfernt",
    "level": "Ebene",
    "Please choose how you want background changes to be saved": "Bitte wählen Sie, wie Hintergrundänderungen gespeichert werden sollen",
    "deltareportconfiguration": "Konfiguration des Delta-Berichts",
    "No chart name": "Kein Organigrammname",
    "Name your background": "Benennen Sie Ihren Hintergrund",
    "fullaccess1": "Voller Zugriff + Lese-/Schreibrolle",
    "Only existing OrgChart users can access this link": "Nur bestehende OrgChart-Benutzer können auf diesen Link zugreifen",
    "You must select a role": "Sie müssen eine Rolle auswählen",
    "Allowed folders": "Erlaubte Ordner",
    "MFA Setup": "MFA-Einrichtung",
    "Link user": "Link-Benutzer",
    "Invalid input": "Ungültige Eingabe",
    "selectchart": "Organigramm auswählen",
    "Data sync not automatic": "Daten werden nicht automatisch synchronisiert",
    "AuxRepMapping": "Zuordnung von Hilfsberichten",
    "Rename failure": "Umbenennen fehlgeschlagen",
    "Enumerated Table": "Aufgezählte Tabelle",
    "MFA status": "MFA-Status",
    "DPR": "DPR",
    "No import filters have been added": "Es wurden keine Importfilter hinzugefügt",
    "People with access": "Personen mit Zugriff",
    "Include all": "Alle einbeziehen",
    "insertrowabove": "1 Zeile oben einfügen",
    "Applied by view": "Nach Ansicht angewendet",
    "topMiddle": "Oben in der Mitte",
    "Enable auto-export": "Automatischen Export aktivieren",
    "Password must": "Passwort erforderlich",
    "Profile fields": "Profil-Felder",
    "Background changes will apply to all charts using this background": "Hintergrundänderungen werden auf alle Organigramme angewendet, die diesen Hintergrund verwenden",
    "Background right spacing": "Abstand vom rechten Rand anpassen",
    "is invalid value": "ist ein ungültiger Wert",
    "Label only": "Nur Etikett",
    "Create rule": "Regel erstellen",
    "Client ID": "Kunden-ID",
    "Append data sources": "Datenquellen anhängen",
    "Enter description": "Beschreibung eingeben",
    "rowsecconditional": "Felder sind zu sehen, wenn alle Bedingungen erfüllt sind",
    "Changes will appear here": "Änderungen werden hier angezeigt",
    "Currently Viewing": "Derzeit angezeigt",
    "Terms of service": "Bedingungen für den Dienst",
    "Enter name here": "Geben Sie hier Ihren Namen ein",
    "Dates": "Termine",
    "Notify on": "Benachrichtigen am",
    "Automatically sync with source": "Automatisch mit Quelle synchronisieren",
    "Employee data updates hourly.":
      "Mitarbeiterdaten werden stündlich aktualisiert. Eine manuelle Aktualisierung ist nicht verfügbar. Nur Zusatz- und Zusammenführungsquellen können bei Bedarf aktualisiert werden.",
    "Delete filter": "Filter löschen",
    "Delete filter?": "Filter löschen?",
    "Select background": "Hintergrund auswählen",
    "Show Direct Reports": "Direkte Berichte anzeigen",
    "Revert to prior value": "Auf vorherigen Wert zurücksetzen",
    "Multi-Factor Authentication Settings": "Einstellungen für die Multi-Faktor-Authentifizierung",
    "List": "Liste",
    "Open Report Explorer": "Berichtsexplorer öffnen",
    "View manager": "Manager anzeigen",
    "DeleteAppendInfo": "Datensatz aus dem Organigramm entfernen",
    "Update existing record": "Vorhandenen Datensatz aktualisieren",
    "Levels up": "Ebenen aufwärts",
    "Editing linked background": "Dieser Hintergrund kann mit anderen Organigrammen verknüpft werden.",
    "Custom chart filter": "Benutzerdefinierter Organigrammfilter",
    "MoveAppendInfo": "Berichtsbeziehung ändern",
    "Deleted under": "Gelöscht unter",
    "Rows": "Zeilen",
    "Add field value": "Feldwert hinzufügen",
    "No background applied": "Kein Hintergrund angewendet",
    "Create new import filter": "Neuen Importfilter erstellen",
    "Include pre-defined system formulas, such as headcount and span of control": "Vordefinierte Systemformeln einbeziehen, z.B. Headcount und Kontrollspanne",
    "Accessibility Report": "Barrierefreiheitsbericht",
    "accessibilityReportHelper": "Eine flache, Section-508- und screenreaderfreundliche Excel-Arbeitsmappe erstellen",
    "Maximum 3 additional fields": "Maximal 3 zusätzliche Felder",
    "accessibilityFieldCapReached": "Maximal 3 zusätzliche Felder erreicht. Entfernen Sie ein Feld, um ein anderes aufzunehmen.",
    "exportuserstip": "Benutzer in eine Excel-Datei exportieren",
    "at": "bei",
    "Add rule": "Regel hinzufügen",
    "fullaccess2": "Voller Zugriff + Admin-Rolle",
    "Save View Changes": "Möchten Sie Ihre aktuelle Ansicht speichern, bevor Sie sie mit einem Master-Organigramm verknüpfen?",
    "docMappingChanged": "Die von Ihnen gewählte Datei hat möglicherweise eine andere Zuordnung. Wählen Sie Speichern & Weiter, um Ihre aktuellen Änderungen zu speichern und die Zuordnung zu konfigurieren.",
    "ResetMap": "Feldzuordnung zurücksetzen",
    "Area under construction": "Bereich im Aufbau",
    "Border dash": "Umrandungsstrich",
    "Use fields from a base chart within this background": "Felder aus einem Basisorganigramm in diesem Hintergrund verwenden",
    "AutoPopulateFailure": "Inhalt konnte nicht mit dem Master-Organigramm verknüpft werden. Bitte überprüfen Sie die Grenzen der Organigramm-Konfiguration und versuchen Sie es erneut.",
    "Select fields": "Felder auswählen",
    "No reports": "Keine Berichte",
    "Recents": "Neueste",
    "Find report": "Bericht suchen",
    "Field change history": "Feldänderungshistorie",
    "Show more information": "Weitere Informationen anzeigen",
    "changed to": "geändert in",
    "changed from": "geändert von",
    "multiple values": "mehrere Werte",
    "Reassigned from": "Neu zugewiesen von",
    "Created date": "Datum der Erstellung",
    "No comments": "Keine Kommentare",
    "Your user is not permitted to access this instance of OrgChart": "Ihr Benutzer ist nicht berechtigt, auf diese Instanz von OrgChart zuzugreifen",
    "Name your chart before turning on auto save": "Bitte benennen Sie Ihr benutzerdefiniertes Organigramm, bevor Sie die automatische Speicherung aktivieren",
    "Filter out by type": "Nach Typ herausfiltern",
    "replacefiles": "Klicken Sie auf \"Vorhandene Dateien ersetzen\", um vorhandene Dateien in diesem Verzeichnis zu aktualisieren oder auf \"Duplikate überspringen\", um nur neue Dateien hinzuzufügen.",
    "On leave": "Zum Verlassen",
    "Automatic delta report notifications": "Automatische Delta-Bericht-Benachrichtigungen",
    "Click here to add additional fields": "Klicken Sie hier, um weitere Felder hinzuzufügen",
    "No results found": "Keine Ergebnisse gefunden",
    "Add filters": "Filter hinzufügen",
    "Border type": "Art der Umrandung",
    "Moved under": "Verschoben unter",
    "This is not normally required": "Dies ist normalerweise nicht erforderlich",
    "before": "vor",
    "Download entire chart": "Gesamtes Organigramm herunterladen",
    "Base Charts": "Basis-Organigramme",
    "Client secret": "Geheimnis des Kunden",
    "Build Employees Chart Directions": "Wählen Sie eine Schlüsselperson, die die Spitze Ihres Organigramms darstellt",
    "Enable anyways": "Trotzdem aktivieren",
    "Enter full URL here": "Geben Sie hier die vollständige URL ein",
    "Resort boxes to save space": "Boxen neu sortieren, um Platz zu sparen",
    "Create folder": "Ordner erstellen",
    "Source data changes": "Quelldaten ändern",
    "No description": "Keine Beschreibung",
    "beforeequal": "vor oder auf",
    "levels": "Ebenen",
    "Edit configuration": "Konfiguration bearbeiten",
    "Conflicting field format changes": "Widersprüchliche Feldformatänderungen",
    "Merge data sources": "Datenquellen zusammenführen",
    "No additional fields": "Keine zusätzlichen Felder",
    "Save background": "Hintergrund speichern",
    "Directory result fields": "Verzeichnis der Ergebnisfelder",
    "Edit group": "Gruppe bearbeiten",
    "Configure Data Source": "Datenquelle konfigurieren",
    "Custom Sign-Out URL": "Abmelden von der Website, anstatt zur Anmeldeseite zurückzukehren",
    "Box shadow": "Box-Schatten",
    "Select formula span": "Formelspanne auswählen",
    "Knowledge base": "Wissensdatenbank",
    "Background left spacing": "Abstand vom linken Rand anpassen",
    "No disconnected records": "Keine unverbundenen Datensätze",
    "Share plan": "Plan freigeben",
    "Support portal": "Support-Portal",
    "Find users": "Benutzer finden",
    "Search plans": "Pläne suchen",
    "Create security profile": "Sicherheitsprofil erstellen",
    "Index": "Index",
    "customPlacement": "Benutzerdefinierte Platzierung",
    "Finish editing": "Bearbeitung beenden",
    "Name your chart": "Benennen Sie Ihr Organigramm",
    "Unable to save additional fields": "Zusätzliche Felder können nicht gespeichert werden",
    "Remove filtered records": "Gefilterte Datensätze entfernen",
    "Edit security profile": "Sicherheitsprofil bearbeiten",
    "Viewing Chart": "Organigramm anzeigen",
    "Success and failure": "Erfolg und Misserfolg",
    "Set list": "Liste einstellen",
    "Additional info": "Zusätzliche Informationen",
    "Chart Builder Filter": "Möchten Sie Filter anwenden, um den Fokus Ihres Organigramms einzugrenzen?",
    "Enter name": "Name eingeben",
    "Revert to checkpoint": "Zum Kontrollpunkt zurückkehren",
    "Line subgroup style": "Linienuntergruppenstil",
    "Overlay a region of color over boxes that match the criteria": "Überlagern Sie einen Farbbereich über Boxen, die den Kriterien entsprechen.",
    "More Details": "Mehr Details",
    "passinclow": "Enthält mindestens einen Kleinbuchstaben",
    "Text formatting": "Textformatierung",
    "Launch Settings": "Einstellungen starten",
    "OrgChart LLC. All rights reserved": "OrgChart LLC. Alle Rechte vorbehalten",
    "Create from existing": "Aus vorhandenem Text erstellen",
    "bottomMiddle": "Unten Mitte",
    "Chart type": "Organigrammtyp",
    "No conditional formatting rules": "Keine bedingten Formatierungsregeln",
    "Save Background": "Hintergrund speichern",
    "Download this branch": "Diesen Zweig herunterladen",
    "Page Number": "Seitenzahl",
    "Document status": "Dokument-Status",
    "Create highlight": "Hervorhebung erstellen",
    "Allowed values": "Erlaubte Werte",
    "No box style selected": "Kein Boxstil ausgewählt",
    "Background changes will only be applied to this chart": "Hintergrundänderungen werden nur auf dieses Organigramm angewendet",
    "Anyone with access to the web page on which you embed this link can access OrgChart": "Jeder, der Zugriff auf die Webseite hat, auf der Sie diesen Link einbetten, kann auf OrgChart zugreifen.",
    "Border Weight": "Stärke der Umrandung",
    "Select an operation to configure": "Wählen Sie eine Operation zum Konfigurieren",
    "Save as new": "Als neu speichern",
    "replacefilenonew": "Klicken Sie auf \"Vorhandene Datei ersetzen\", um die vorhandene Datei in diesem Verzeichnis zu aktualisieren oder auf \"Abbrechen\", um den Upload abzubrechen.",
    "Choose field value": "Feldwert wählen",
    "Filter by role": "Nach Rolle filtern",
    "Choose an archive to build off of or create a delta report between two dates": "Wählen Sie ein Archiv, auf dem Sie aufbauen möchten, oder erstellen Sie einen Delta-Bericht zwischen zwei Daten",
    "Select data source": "Datenquelle auswählen",
    "Update existing": "Vorhandenes aktualisieren",
    "Download activity report": "Aktivitätsbericht herunterladen",
    "fullaccess0": "Voller Zugriff + Nur-Lese-Rolle",
    "Import fields from": "Felder importieren aus",
    "Open file explorer": "Datei-Explorer öffnen",
    "Moved from": "Verschoben von",
    "boxlimitwar": "Beachten Sie, dass eine Erhöhung des Limits die Leistung der Anwendung beeinträchtigen kann.",
    "insertcolright": "1 Spalte rechts einfügen",
    "DynFormWarn": "Diese Formeln funktionieren nicht wie erwartet für Basisorganigramme oder Pläne. Bitte verwenden Sie stattdessen reguläre Formeln.",
    "Select a new value to resolve the conflict": "Wählen Sie einen neuen Wert, um den Konflikt zu lösen",
    "All fields restricted": "Alle Felder eingeschränkt",
    "Select comparison": "Vergleich auswählen",
    "afterequal": "nach oder bei",
    "Anyone with this link can access OrgChart": "Jeder mit diesem Link kann auf OrgChart zugreifen",
    "Levels down": "Ebenen abwärts",
    "Level 2": "Ebene 2",
    "Edit filter": "Filter bearbeiten",
    "New value": "Neuer Wert",
    "Mute filtered records": "Gefilterte Datensätze stummschalten",
    "Apply layout changes": "Layoutänderungen anwenden",
    "Last ran report": "Zuletzt ausgeführter Bericht",
    "Changes effective": "Änderungen wirksam",
    "Include system calculations": "Systemberechnungen einbeziehen",
    "Launch chart": "Organigramm starten",
    "Org unit file": "Datei der Organisationseinheit",
    "Branch rule": "Verzweigungsregel",
    "switch to shared views to create new views": "Zu gemeinsamen Ansichten wechseln, um neue Ansichten zu erstellen",
    "BasicRule": "Grundregel",
    "Chart view": "Organigramm-Ansicht",
    "Chart Builder Chart": "Chart Builder Chart",
    "Level 4": "Stufe 4",
    "Users with access": "Benutzer mit Zugriff",
    "Export format": "Format exportieren",
    "Create filter": "Filter erstellen",
    "Remove access": "Zugriff entfernen",
    "UpdatingSC": "Namen von Unterorganigrammen aktualisieren",
    "mergecells": "Zellen zusammenführen",
    "No filters have been added": "Es wurden keine Filter hinzugefügt",
    "Edit field format": "Feldformat bearbeiten",
    "Create metric": "Metrik erstellen",
    "Delete plan": "Plan löschen",
    "Choose to configure your report from today or select a date range": "Konfigurieren Sie Ihren Bericht ab heute oder wählen Sie einen Datumsbereich",
    "Preferred First": "Zuerst bevorzugt",
    "View controls background": "Die Hintergründe werden über eine Ansicht gesteuert.",
    "Delete view": "Ansicht löschen",
    "Enter custom value": "Benutzerdefinierten Wert eingeben",
    "Chart Builder Filter Directions": "Filtern Sie Ihr Organigramm, um sich auf bestimmte Positionen, Abteilungen oder andere Kriterien zu konzentrieren.",
    "Download plan": "Plan herunterladen",
    "Level 3": "Ebene 3",
    "What would you like to call this plan?": "Wie möchten Sie diesen Plan nennen?",
    "Choose field": "Feld auswählen",
    "Add people or groups": "Personen oder Gruppen hinzufügen",
    "Conflicts detected": "Konflikte erkannt",
    "Text align": "Text ausrichten",
    "Saved highlights": "Gespeicherte Markierungen",
    "Line style": "Linienstil",
    "Reset your": "Zurücksetzen Ihrer",
    "Favorites": "Favoriten",
    "Enter person id of top box": "Personen-ID der oberen Box eingeben",
    "Status is current": "Status ist aktuell",
    "confirmViewRemove1": "Sie haben eine oder mehrere Ansichten gelöscht, die derzeit von",
    "Changes not saved automatically": "Die Änderungen werden nicht automatisch gespeichert",
    "passincspc": "Enthält mindestens ein Sonderzeichen",
    "No files or folders here": "Keine Dateien oder Ordner hier",
    "IWizHeadsUp1": "Informativ: Diese Methode zum Importieren von Daten wurde ersetzt.",
    "Add SSO Configuration": "SSO-Konfiguration hinzufügen",
    "Must have a valid profile name": "Muss einen gültigen Profilnamen haben",
    "First Name": "Erster Name",
    "account": "Konto",
    "bypasstemplatelist": "Vorlagen-Whitelist umgehen",
    "Edit highlight": "Markierung bearbeiten",
    "Formula name": "Name der Formel",
    "Can access chart": "Zugriff auf Organigramm möglich",
    "Select Custom Chart": "Benutzerdefiniertes Organigramm auswählen",
    "Automatic refresh notifications": "Automatische Aktualisierungsbenachrichtigungen",
    "Unconstrained": "Unbeschränkte",
    "Save Report": "Bericht speichern",
    "Add group mapping": "Gruppenzuordnung hinzufügen",
    "Branch preferences": "Verzweigungseinstellungen",
    "Edit dynamic formula": "Dynamische Formel bearbeiten",
    "to": "zu",
    "Use preset query": "Voreingestellte Abfrage verwenden",
    "Create import filter": "Importfilter erstellen",
    "Rule driven background": "Regelgesteuerter Hintergrund",
    "Failure only": "Nur Fehlschläge",
    "Choose entry type": "Eintragstyp wählen",
    "Change password": "Passwort ändern",
    "Continue editing this custom chart": "Fahren Sie mit der Bearbeitung dieses benutzerdefinierten Organigramms fort.",
    "Include a field that contains the reporting hierarchy for each employee": "Fügen Sie ein Feld ein, das die Berichtshierarchie für jeden Mitarbeiter enthält",
    "Rule criteria": "Regel-Kriterien",
    "No record selected": "Kein Datensatz ausgewählt",
    "duplicateuiprofile": "UI Profil existiert bereits",
    "Delete metric": "Metrik löschen",
    "findfield": "Feld suchen",
    "Remove break": "Unterbrechung entfernen",
    "Choose fields": "Felder auswählen",
    "Show and hide fields": "Felder ein- und ausblenden",
    "Subchart breaks": "Unterorganigrammumbrüche",
    "Name your custom chart": "Benennen Sie Ihr benutzerdefiniertes Organigramm",
    "Chart archives": "Organigramm-Archive",
    "Impersonate user": "Benutzer verkörpern",
    "Person ID required": "Personen-ID erforderlich",
    "Pin": "Anheften",
    "Configure metrics": "Metriken konfigurieren",
    "changed": "geändert",
    "Report name": "Name des Berichts",
    "Untitled Report": "Unbenannter Bericht",
    "Default users as collaborators": "Standardbenutzer als Mitwirkende",
    "Basic Table": "Einfache Tabelle",
    "Customize your search with various criteria to find the perfect match": "Passen Sie Ihre Suche mit verschiedenen Kriterien an, um die perfekte Übereinstimmung zu finden",
    "confirmViewRemove2": "vorhandene Organigramme. Sobald Sie Ihre Änderungen gespeichert haben, sind die Ansichten nicht mehr verfügbar. Sind Sie sicher, dass Sie Ihre Änderungen speichern möchten?",
    "deletecols": "Spalten löschen",
    "Dynamic formulas": "Dynamische Formeln",
    "SAP OrgUnit Chart Options": "SAP OrgUnit-Organigramm Optionen",
    "No values added. Click here to add a value": "Keine Werte hinzugefügt. Klicken Sie hier, um einen Wert hinzuzufügen",
    "Revert all field changes": "Alle Feldänderungen rückgängig machen",
    "SEARCH": "SUCHEN",
    "Customer email": "Kunden-E-Mail",
    "Chart Security": "Organigramm-Sicherheit",
    "No additional fields added": "Es wurden noch keine zusätzlichen Felder hinzugefügt",
    "Base Chart": "Basis-Organigramm",
    "Save changes to": "Änderungen speichern in",
    "Detailed data query": "Detaillierte Datenabfrage",
    "Choose views": "Ansichten auswählen",
    "Branch pruning info": "Die Benutzer sehen nur Datensätze, die den angegebenen Regelkriterien entsprechen. (Empfohlen für die Zweigregel 'Auf eigene Filiale beschränken'.)",
    "importfiltersdesc": "Geben Sie die Daten (Datensätze und Felder) an, die bei der Aktualisierung in Ihr Organigramm aufgenommen oder ausgeschlossen werden sollen. Daten, die mit Importfiltern herausgefiltert werden, sind nicht durchsuchbar und haben keinen Einfluss auf die Anzahl der Mitarbeiter oder andere Formeln.",
    "Last Name": "Nachname",
    "Add new value": "Neuen Wert hinzufügen",
    "Add custom solid color": "Benutzerdefinierte Volltonfarbe hinzufügen",
    "Account details": "Konto-Details",
    "No chart description": "Keine Organigrammbeschreibung",
    "Invalid photo credentials": "Ungültige Foto-Anmeldedaten",
    "Keep me signed in": "Angemeldet bleiben",
    "Select formula type": "Formeltyp auswählen",
    "selectcdoc": "Organigramm-Dokument auswählen",
    "New SupervisorID Required": "Neuer Vorgesetzter für die Verschiebung erforderlich",
    "Revert All Confirm": "Sind Sie sicher, dass Sie alle mit diesem Eintrag verbundenen Änderungen rückgängig machen möchten?",
    "Excluded fields": "Ausgeschlossene Felder",
    "Status is active": "Status ist aktiv",
    "unmergecells": "Zusammenführen aufheben",
    "Create new highlight": "Neue Markierung erstellen",
    "Edit Append Table": "Anhangstabelle bearbeiten",
    "Black": "Schwarz",
    "Background top spacing": "Abstand vom oberen Rand anpassen",
    "Add element": "Element hinzufügen",
    "Remove box": "Box entfernen",
    "Enable sort": "Sortierung einschalten",
    "EmpFieldMap": "Mitarbeiterfeld-Zuordnung",
    "Advanced search": "Erweiterte Suche",
    "Select field": "Feld auswählen",
    "Add Whitelist Domain": "Whitelist-Domäne hinzufügen",
    "Must have a valid chart name": "Muss einen gültigen Organigrammnamen haben",
    "Pagination wizard": "Paginierungs-Assistent",
    "No refresh history": "Keine Aktualisierungshistorie",
    "Data changes": "Datenänderungen",
    "Manage Tables": "Tabellen verwalten",
    "Send Back": "Zurücksenden",
    "Add criteria": "Kriterien hinzufügen",
    "Basic math has no configurable settings": "Basic Mathe hat keine konfigurierbaren Einstellungen",
    "Manually archive": "Manuelles Archivieren",
    "Export to Excel": "Nach Excel exportieren",
    "Exporting archive": "Archiv wird exportiert",
    "Added under": "Hinzugefügt unter",
    "Reset password": "Passwort zurücksetzen",
    "Changes saved automatically": "Änderungen werden automatisch gespeichert",
    "Use a white background instead of a color. This option is helpful if you plan to print this file": "Verwenden Sie einen weißen Hintergrund anstelle einer Farbe. Diese Option ist hilfreich, wenn Sie die Datei ausdrucken möchten.",
    "Remove field value from rule criteria": "Feldwert aus den Regelkriterien entfernen",
    "collabplanalert": "Der Zugriff auf die kollaborative Planung erfordert einen Lese-/Schreib- oder Administratorplatz. Wenden Sie sich an Ihren Administrator, um den Sitztyp zu ändern.",
    "Page density": "Seitendichte",
    "Disabled": "Deaktiviert",
    "New password must": "Neues Passwort erforderlich",
    "Modified date": "Geändertes Datum",
    "selectplan": "Plan auswählen",
    "Domain": "Bereich",
    "Linked View will be applied when the top box of the subchart matches the rule criteria": "Die verknüpfte Ansicht wird angewendet, wenn das obere Feld des Unterorganigramms den Kriterien der Regel entspricht",
    "Download this page": "Diese Seite herunterladen",
    "Background bottom spacing": "Abstand vom unteren Rand anpassen",
    "Applying filter": "Filter wird angewendet...",
    "Loading chart": "Organigramm wird geladen...",
    "Update sharing": "Freigabe aktualisieren",
    "Entity sharing access saved": "Freigabezugriff für {entity} gespeichert.",
    "Failed to share": "Freigabe fehlgeschlagen",
    "Shared filter banner": "Dies ist ein geteilter Filter. Änderungen werden für alle Benutzer übernommen, die Zugriff darauf haben.",
    "Shared highlight banner": "Dies ist eine geteilte Hervorhebung. Änderungen werden für alle Benutzer übernommen, die Zugriff darauf haben.",
    "Delete shared filter?": "Geteilten Filter löschen?",
    "Delete shared highlight?": "Geteilte Hervorhebung löschen?",
    "Delete shared filter confirm": "Das Löschen dieses geteilten Filters entfernt ihn für alle Benutzer, mit denen er geteilt wurde.",
    "Delete shared highlight confirm": "Das Löschen dieser geteilten Hervorhebung entfernt sie für alle Benutzer, mit denen sie geteilt wurde.",
    "Delete filter confirm": "Das Löschen dieses Filters entfernt ihn aus Ihrer Filterliste.",
    "Delete highlight confirm": "Das Löschen dieser Hervorhebung entfernt sie aus Ihrer Hervorhebungsliste.",
    "Shared filter copied": "{entity} in 'Meine Filter' kopiert.",
    "Shared highlight copied": "{entity} in 'Meine Hervorhebungen' kopiert.",
    "Entity copy created": "{entity} kopiert.",
    "importfiltercharterr": "Bei dem angewendeten Importfilter wurden ein oder mehrere Probleme gefunden. Ändern oder entfernen Sie den Importfilter.",
    "chartScopeFilterCharterr": "Bei dem angewendeten Diagrammbereichsfilter wurden ein oder mehrere Probleme gefunden. Ändern oder entfernen Sie den Diagrammbereichsfilter.",
    "Chart scope": "Diagrammbereich",
    "Chart scope description": "Zeigen Sie den Diagrammbereich an und wenden Sie eine Regel auf dieses benutzerdefinierte Diagramm an.",
    "Levels under top box": "Ebenen unter der obersten Box",
    "Chart scope edit cc to edit": "Bearbeiten Sie das Diagramm, um den Diagrammbereich anzupassen.",
    "To remedy this issue: reduce the number of levels shown, adjust subchart break criteria, or apply a filter": "Um dieses Problem zu beheben: Reduzieren Sie die Anzahl der angezeigten Ebenen, passen Sie die Umbruchkriterien des Unterorganigramms an oder wenden Sie einen Filter an.",
    "Interactive filters": "Interaktive Filter",
    "Shared filters": "Geteilte Filter",
    "Shared highlights": "Geteilte Hervorhebungen",
    "No filter applied": "Kein Filter angewendet",
    "My filters": "Meine Filter",
    "My highlights": "Meine Hervorhebungen",
    "Share filter": "Filter teilen",
    "Share highlight": "Hervorhebung teilen",
    "Copy filter": "Filter kopieren",
    "Copy highlight": "Hervorhebung kopieren",
    "Filter details": "Filterdetails",
    "Highlight details": "Details der Hervorhebung",
    "Back to filters": "Zurück zu den Filtern",
    "Back to highlights": "Zurück zu den Hervorhebungen",
    "shared": "geteilt",
    "No shared filters yet": "Es wurden noch keine Filter mit Ihnen geteilt.",
    "No shared highlights yet": "Es wurden noch keine Hervorhebungen mit Ihnen geteilt.",
    "A shared filter with this name already exists": "In diesem Organigramm ist bereits ein geteilter Filter mit diesem Namen vorhanden.",
    "A shared highlight with this name already exists": "In diesem Organigramm ist bereits eine geteilte Hervorhebung mit diesem Namen vorhanden.",
    "Share filter info text": "Wenn ein Filter geteilt wird, kann nur der Eigentümer den Freigabezugriff verwalten und den Filter löschen.",
    "Share highlight info text": "Wenn eine Hervorhebung geteilt wird, kann nur der Eigentümer den Freigabezugriff verwalten und die Hervorhebung löschen.",
    "Share this entity with": "Dieses {entity} teilen mit:",
    "Show highlight": "Hervorhebung anzeigen",
    "Hide highlight": "Hervorhebung ausblenden",
    "Show filter": "Filter anzeigen",
    "Hide filter": "Filter ausblenden",
    "boxes for a custom chart. Try building the chart from a smaller section of your organization or apply filters to reduce the number of boxes.": "Felder für ein benutzerdefiniertes Organigramm. Versuchen Sie, das Organigramm aus einem kleineren Bereich Ihrer Organisation zu erstellen, oder wenden Sie Filter an, um die Anzahl der Felder zu reduzieren.",
    "Do you want to save changes to Filters": "Möchten Sie die Änderungen an den Filtern speichern?",
    "back to filter list": "Zurück zur Filterliste",
    "back to highlight list": "Zurück zur Liste der Hervorhebungen",
    "Share this plan with": "Optional: Diesen Plan jetzt teilen",
    "Share Filters & Highlights": "Filter und Hervorhebungen teilen",
    "Filters applied tooltip": "Anzahl der Filter, die auf das aktuell geöffnete {document} angewendet werden.",
    "Employee filter": "Mitarbeiterfilter",
    "Show filter fields": "Filterfelder anzeigen",
    "No filter fields selected": "Keine Filterfelder ausgewählt. Verwenden Sie die Schaltfläche 'Felder', um Felder hinzuzufügen.",
    "includefilteredhelper": "Aktivieren Sie diese Option, um Manager einzuschließen, deren Untergebene den definierten Filterkriterien entsprechen, auch wenn die Manager selbst nicht den Kriterien entsprechen.",
    "share historical": "Historisch teilen",
    "My filters info": "Filter für alle Organigrammtypen erstellen, verwalten und anwenden.",
    "My highlights info": "Hervorhebungen für alle Organigrammtypen erstellen, verwalten und anwenden.",
    "Saved highlights info": "Legacy-Hervorhebungen werden von Administratoren in den Organigrammeinstellungen verwaltet: Registerkarte Filter und Hervorhebungen.",
    "No highlights created yet": "Noch keine Hervorhebungen erstellt",
    "Search filters": "Filter suchen",
    "Search highlights": "Hervorhebungen suchen",
    "Shared filters info": "Diese Filter wurden mit Ihnen geteilt und können auf alle Organigrammtypen angewendet werden. Die Möglichkeit, bestimmte Filter zu bearbeiten, hängt von Ihrem Freigabezugriff ab.",
    "Shared highlights info": "Diese Hervorhebungen wurden mit Ihnen geteilt und können auf alle Organigrammtypen angewendet werden. Die Möglichkeit, bestimmte Hervorhebungen zu bearbeiten, hängt von Ihrem Freigabezugriff ab.",
    "Interactive highlights": "Interaktive Hervorhebungen",
    "Interactive filters & highlights": "Interaktive Filter und Hervorhebungen",
    "Delete highlight": "Hervorhebung löschen",
    "Delete highlight?": "Hervorhebung löschen?",
    "Legacy filters": "Legacy-Filter",
    "Legacy highlights": "Legacy-Hervorhebungen",
    "Applies to": "Gilt für",
    "Restricted": "Eingeschränkt",
    "Budgeted Headcount": "Geplante Stellenanzahl",
    "Salary Rollup": "Gehaltsübersicht",
    "Position Budget Rollup": "Positionsbudget-Zusammenfassung",
    "Assigned to": "Zugewiesen an",
    "Bi-Weekly": "Zweiwöchentlich",
    "Quarterly": "Vierteljährlich",
    "Annually": "Jährlich",
    "First Day": "Erster Tag",
    "Last Day": "Letzter Tag",
    "Gradient": "Verlauf",
    "Linear Gradient": "Linearer Verlauf",
    "Radial Gradient": "Radialer Verlauf",
    "No results found for the selected criteria. Please adjust your selection and try again": "Keine Ergebnisse für die ausgewählten Kriterien gefunden. Bitte passen Sie Ihre Auswahl an und versuchen Sie es erneut",
    "Results per page": "Ergebnisse pro Seite",
    "Search folder": "Ordner durchsuchen",
    "Create base chart": "Basis-Organigramm erstellen",
    "Charts": "Organigramme",
    "Pages": "Seiten",
    "Access groups": "Zugriffsgruppen",
    "Manage users": "Benutzer verwalten",
    "UI profiles": "UI-Profile",
    "Chart management": "Organigramm-Verwaltung",
    "Could not load page": "Seite konnte nicht geladen werden",
    "The number of records on the page exceeds the single page limit": "Die Anzahl der Datensätze auf der Seite überschreitet das Einzelseitenlimit",
    "canvastoolarge": "Diese Seite ist zu groß für die Darstellung im Browser.",
    "Maximum": "Maximum",
    "No preview": "Keine Vorschau",
    "Select a preview": "Vorschau auswählen",
    "Set Aspect Ratio": "Seitenverhältnis festlegen",
    "Additional parameters": "Zusätzliche Parameter",
    "Plan settings": "Planeinstellungen",
    "Current view applied": "Aktuelle Ansicht angewendet",
    "Chart description": "Organigramm-Beschreibung",
    "Point in time": "Zeitpunkt",
    "Data Source": "Datenquelle",
    "Data sources": "Datenquellen",
    "Fields shown": "Angezeigte Felder",
    "Minimum group size": "Mindestgruppengröße",
    "Allow groups with managers": "Gruppen mit Vorgesetzten zulassen",
    "Co-manager": "Co-Manager",
    "Manager group box style": "Gruppenbox-Stil für Vorgesetzte",
    "Fields that can be chosen for Excel export": "Felder, die für den Excel-Export ausgewählt werden können",
    "Fields that cannot be chosen for Excel export": "Felder, die nicht für den Excel-Export ausgewählt werden können",
    "Fields allowed for Excel export": "Für den Excel-Export zugelassene Felder",
    "By default, users can choose any fields permitted by their security overlay to export to excel. This feature allows you to optionally customize the list of fields your users will have access to downloading in their excel file": "Standardmäßig können Benutzer alle Felder, die durch ihre Sicherheitsebene erlaubt sind, nach Excel exportieren. Mit dieser Funktion können Sie optional die Liste der Felder anpassen, die Ihren Benutzern beim Excel-Download zur Verfügung stehen",
    "Footer": "Fußzeile",
    "Years": "Jahre",
    "(No people)": "(Keine Personen)",
    "Rename profile": "Profil umbenennen",
    "Restore plan": "Plan wiederherstellen",
    "Locking plan": "Plan wird gesperrt",
    "Unlocking plan": "Plan wird entsperrt",
    "Deleting plan": "Plan wird gelöscht",
    "Duplicating plan": "Plan wird dupliziert",
    "Archiving plan": "Plan wird archiviert",
    "Renaming plan": "Plan wird umbenannt",
    "This field is read-only and cannot be edited": "Dieses Feld ist schreibgeschützt und kann nicht bearbeitet werden",
    "Edit employee record": "Mitarbeiterdatensatz bearbeiten",
    "Archived": "Archiviert",
    "formulas": "Formeln",
    "Add metric": "Kennzahl hinzufügen",
    "Phases": "Phasen",
    "Conflicted record": "Konflikt-Datensatz",
    "Active append table": "Aktive Zusatztabelle",
    "Find record to add to talent pool…": "Datensatz suchen, um ihn zum Talentpool hinzuzufügen…",
    "Copy to My filters": "In Meine Filter kopieren",
    "Copy to My highlights": "In Meine Hervorhebungen kopieren",
    "copy": "kopieren",
    "This user cannot be a collaborator because of their read-only role": "Dieser Benutzer kann aufgrund seiner schreibgeschützten Rolle kein Mitarbeiter sein",
    "Revert changes": "Änderungen rückgängig machen",
    "Legacy Chart": "Altes Organigramm",
    "Excel Data": "Excel-Daten",
    "Move to Staging": "In den Staging-Bereich verschieben",
    "Edit rule criteria": "Regelkriterien bearbeiten",
    "Duplicate rule criteria": "Regelkriterien duplizieren",
    "Remove rule criteria": "Regelkriterien entfernen",
    "EmployeeID": "EmployeeID",
    "Data field": "Datenfeld",
    "Create group": "Gruppe erstellen",
    "Position view library": "Bibliothek der Positionsansichten",
    "Employee view library": "Bibliothek der Mitarbeiteransichten",
    "Record is disconnected from hierarchy": "Datensatz ist von der Hierarchie getrennt",
    "No field": "Kein Feld",
    "Position field mapping": "Positionsfeldzuordnung",
    "Conflict auto-resolved": "Konflikt automatisch gelöst",
    "Apply this formula to": "Diese Formel anwenden auf",
    "Turn on by default": "Standardmäßig aktivieren",
    "Turn off by default": "Standardmäßig deaktivieren",
    "Select a date range for your report": "Wählen Sie einen Datumsbereich für Ihren Bericht",
    "Page sort order": "Seitensortierung",
    "Keep order as-is": "Reihenfolge beibehalten",
    "Keep pagination as-is": "Paginierung beibehalten",
    "A single page export will not need to re-paginate your chart": "Ein einseitiger Export erfordert keine Neupaginierung Ihres Organigramms",
    "Sort by field": "Nach Feld sortieren",
    "Closed under": "Geschlossen unter",
    "Reopened under": "Wieder geöffnet unter",
    "Released from": "Freigegeben von",
    "You’ve exceeded the max number of boxes allowed for export. Please reduce the scope of your export, or attempt an export from a different part of your organization, so that the number of boxes will not exceed your limit": "Sie haben die maximale Anzahl an Boxen für den Export überschritten. Bitte reduzieren Sie den Umfang Ihres Exports oder starten Sie einen Export aus einem anderen Bereich Ihrer Organisation, sodass die Anzahl der Boxen Ihr Limit nicht überschreitet",
    "Administrators can update this limit in the Chart Settings: Presentation panel, though OrgChart does not recommend exporting charts with more than 20,000 records": "Administratoren können dieses Limit in den Organigramm-Einstellungen unter „Darstellung“ anpassen. OrgChart empfiehlt jedoch nicht, Organigramme mit mehr als 20.000 Datensätzen zu exportieren",
    "You’ve reached the maximum limit of": "Sie haben das maximale Limit erreicht von",
    "Admins can adjust this limit in Chart Settings > Presentation Panel, but OrgChart recommends keeping charts under 20,000 records for best performance.": "Administratoren können dieses Limit unter Organigramm-Einstellungen > Darstellung anpassen. OrgChart empfiehlt jedoch, Organigramme unter 20.000 Datensätzen zu halten.",
    "Show more chart details": "Weitere Organigramm-Details anzeigen",
    "Use advanced Entra Query": "Erweiterte Entra-Abfrage verwenden",
    "Microsoft account type": "Microsoft-Kontotyp",
    "Standard (.com)": "Standard (.com)",
    "US government (.us)": "US-Regierung (.us)",
    "Source info": "Quellinformation",
    "Record details": "Datensatzdetails",
    "Show source": "Quelle anzeigen",
    "Search record": "Datensatz suchen",
    "Changes pending": "Änderungen ausstehend",
    "Change data source": "Datenquelle ändern",
    "Created by": "Erstellt von",
    "Manually added": "Manuell hinzugefügt",
    "Source information not available": "Quellinformationen nicht verfügbar",
    "Enter field name": "Feldnamen eingeben",
    "Over source limit": "Quellenlimit überschritten",
    "Could not refresh custom chart": "Benutzerdefiniertes Organigramm konnte nicht aktualisiert werden",
    "Could not open custom chart": "Benutzerdefiniertes Organigramm konnte nicht geöffnet werden",
    "Failed to reorder talent": "Talente konnten nicht neu sortiert werden",
    "Could not locate employee to add to talent pool": "Mitarbeiter konnte nicht gefunden werden, um ihn zum Talentpool hinzuzufügen",
    "Back to all groups": "Zurück zu allen Gruppen",
    "Group name": "Gruppenname",
    "Group by field": "Nach Feld gruppieren",
    "Group style": "Gruppenstil",
    "Return to base chart": "Zum Basis-Organigramm zurückkehren",
    "Rename custom chart": "Benutzerdefiniertes Organigramm umbenennen",
    "Rename base chart": "Basis-Organigramm umbenennen",
    "Rename plan": "Plan umbenennen",
    "Rename report": "Bericht umbenennen",
    "Auto-save": "Automatisch speichern",
    "Configure chart": "Organigramm konfigurieren",
    "Chart settings": "Organigramm-Einstellungen",
    "Save your current changes to this record": "Aktuelle Änderungen an diesem Datensatz speichern",
    "Show grouping": "Gruppierung anzeigen",
    "Invalid email": "Ungültige E-Mail",
    "Fix email": "E-Mail korrigieren",
    "Reset integration": "Integration zurücksetzen",
    "Reset data integration": "Datenintegration zurücksetzen",
    "One or more fields contain errors": "Ein oder mehrere Felder enthalten Fehler",
    "Confirm delete": "Löschen bestätigen",
    "Cannot re-use previous password": "Vorheriges Passwort kann nicht wiederverwendet werden",
    "Unable to build preview": "Vorschau konnte nicht erstellt werden",
    "An error prevented the preview from being generated. Please try again": "Ein Fehler hat die Erstellung der Vorschau verhindert. Bitte versuchen Sie es erneut",
    "Rebuild preview": "Vorschau neu erstellen",
    "Record removed": "Datensatz entfernt",
    "Select a valid reports to": "Gültige Berichtslinie auswählen",
    "Undo plan change": "Planänderung rückgängig machen",
    "Create custom charts": "Benutzerdefinierte Organigramme erstellen",
    "Application, Account, User, and Chart information": "Anwendungs-, Konto-, Benutzer- und Organigramminformationen",
    "Refresh base charts (Read/Write users)": "Basis-Organigramme aktualisieren (Lesen/Schreiben-Benutzer)",
    "Allow language change": "Sprachwechsel zulassen",
    "Apply pagination settings?": "Paginierungseinstellungen anwenden?",
    "Applying these settings will remove any manual subchart breaks": "Das Anwenden dieser Einstellungen entfernt alle manuellen Unterorganigramm-Umbrüche",
    "Permission denied": "Zugriff verweigert",
    "Delete background": "Hintergrund löschen",
    "Move background": "Hintergrund verschieben",
    "Replace Existing File": "Vorhandene Datei ersetzen",
    "Replace Existing Files": "Vorhandene Dateien ersetzen",
    "Skip Duplicate": "Duplikat überspringen",
    "Skip Duplicates": "Duplikate überspringen",
    "Existing": "Vorhanden",
    "Replace or Discard Files": "Dateien ersetzen oder verwerfen",
    "File manager": "Dateimanager",
    "Rules from chart": "Regeln vom Organigramm",
    "Rules from view": "Regeln von Ansicht",
    "Modify backgrounds": "Hintergründe bearbeiten",
    "Delete open chart": "Geöffnetes Organigramm löschen",
    "Not now": "Nicht jetzt",
    "Load now": "Jetzt laden",
    "Update mapping": "Zuordnung aktualisieren",
    "Keep mapping": "Zuordnung beibehalten",
    "photoviewnophotos": "Keiner Ihrer Mitarbeiter hat Fotos. Fügen Sie Fotos in Ihrem HR-System hinzu, damit sie hier angezeigt werden.",
    "Unable to delete rule": "Regel kann nicht gelöscht werden",
    "accounts": "Konten",
    "Move to trash": "In den Papierkorb verschieben",
    "Delete all": "Alle löschen",
    "Move all to trash": "Alle in den Papierkorb verschieben",
    "Empty trash": "Papierkorb leeren",
    "Save and exit": "Speichern und beenden",
    "Box style name in use": "Box-Stilname bereits in Verwendung",
    "Enter a field name": "Einen Feldnamen eingeben",
    "No more changes to show": "Keine weiteren Änderungen anzuzeigen",
    "Show all": "Alle anzeigen",
    "Show less": "Weniger anzeigen",
    "Show more": "Mehr anzeigen",
    "This custom chart is currently open. Are you sure you want to delete this custom chart": "Dieses benutzerdefinierte Organigramm ist derzeit geöffnet. Möchten Sie es wirklich löschen",
    "Any unsaved work will be lost.": "Alle nicht gespeicherten Änderungen gehen verloren.",
    "Trash": "Papierkorb",
    "Samples": "Beispiele",
    "12 AM": "12 AM",
    "1 AM": "1 AM",
    "2 AM": "2 AM",
    "3 AM": "3 AM",
    "4 AM": "4 AM",
    "5 AM": "5 AM",
    "6 AM": "6 AM",
    "7 AM": "7 AM",
    "8 AM": "8 AM",
    "9 AM": "9 AM",
    "10 AM": "10 AM",
    "11 AM": "11 AM",
    "12 PM": "12 PM",
    "1 PM": "1 PM",
    "2 PM": "2 PM",
    "3 PM": "3 PM",
    "4 PM": "4 PM",
    "5 PM": "5 PM",
    "6 PM": "6 PM",
    "7 PM": "7 PM",
    "8 PM": "8 PM",
    "9 PM": "9 PM",
    "10 PM": "10 PM",
    "11 PM": "11 PM",
    "Copy file": "Datei kopieren",
    "Download file": "Datei herunterladen",
    "Delete file": "Datei löschen",
    "Select a table": "Tabelle auswählen",
    "New Base Chart": "Neues Basis-Organigramm",
    "Table Name": "Tabellenname",
    "Table name cannot be empty": "Tabellenname darf nicht leer sein",
    "Table name must be at least 4 characters": "Tabellenname muss mindestens 4 Zeichen lang sein",
    "Table name already exists": "Tabellenname existiert bereits",
    "Create table": "Tabelle erstellen",
    "Search for table name": "Nach Tabellenname suchen",
    "Search by name or title": "Nach Name oder Titel suchen",
    "Modifications": "Änderungen",
    "Add record": "Datensatz hinzufügen",
    "Unsaved changes detected": "Nicht gespeicherte Änderungen erkannt",
    "Position fields": "Positionsfelder",
    "Employee fields": "Mitarbeiterfelder",
    "The system only allows you to add up to three additional co-heads": "Das System erlaubt nur das Hinzufügen von bis zu drei zusätzlichen Co-Leitungen",
    "Add co-head": "Co-Leitung hinzufügen",
    "Box selected": "Box ausgewählt",
    "Position box": "Positionsbox",
    "Employee box": "Mitarbeiterbox",
    "Chart styles": "Organigramm-Stile",
    "Additional reports": "Zusätzliche Berichte",
    "Additional reports to": "Zusätzliche Berichtslinien an",
    "Add assignment": "Zuordnung hinzufügen",
    "Duplicate additional reports are not allowed": "Doppelte zusätzliche Berichtslinien sind nicht zulässig",
    "This supervisor is already selected": "Dieser Vorgesetzte ist bereits ausgewählt",
    "Chart fields changed": "Organigramm-Felder geändert",
    "Invalid reporting structure": "Ungültige Berichtsstruktur",
    "Manage fields": "Felder verwalten",
    "custom charts": "benutzerdefinierte Organigramme",
    "Choose data source": "Datenquelle auswählen",
    "Employee Chart": "Mitarbeiter-Organigramm",
    "Position Chart": "Positions-Organigramm",
    "Allocation Ratio": "Zuordnungsverhältnis",
    "Position field categories": "Positionsfeld-Kategorien",
    "Data field categories": "Datenfeld-Kategorien",
    "Assign as": "Zuweisen als",
    "Both": "Beide",
    "Create plan from": "Plan erstellen von",
    "Create custom chart from": "Benutzerdefiniertes Organigramm erstellen von",
    "custom chart created": "Benutzerdefiniertes Organigramm {name} erstellt.",
    "No rule": "Keine Regel",
    "Add a description": "Beschreibung hinzufügen",
    "this can be done later": "Dies kann später erfolgen",
    "Cost reduction": "Kostenreduzierung",
    "Headcount reduction": "Stellenreduzierung",
    "Relocation": "Standortverlagerung",
    "General organization design": "Allgemeine Organisationsgestaltung",
    "Select objective": "Ziel auswählen",
    "Objective": "Ziel",
    "Employees": "Mitarbeiter",
    "Modify fields": "Felder bearbeiten",
    "Upload checkpoint": "Prüfpunkt hochladen",
    "Select a chart type to configure data source": "Organigrammtyp auswählen, um die Datenquelle zu konfigurieren",
    "Employee List": "Mitarbeiterliste",
    "Unassigned": "Nicht zugewiesen",
    "Assigned": "Zugewiesen",
    "Released": "Freigegeben",
    "Unassigned from": "Zuordnung aufgehoben von",
    "Assign": "Zuweisen",
    "Assign to position": "Der Position zuweisen",
    "Clone position": "Position klonen",
    "Unassign employee": "Mitarbeiter-Zuordnung aufheben",
    "Unassign employees": "Mitarbeiter-Zuordnungen aufheben",
    "Assign employee": "Mitarbeiter zuweisen",
    "Release employee": "Mitarbeiter freigeben",
    "Release employees": "Mitarbeiter freigeben",
    "Set as default chart": "Als Standard-Organigramm festlegen",
    "Open in chart settings": "In den Organigramm-Einstellungen öffnen",
    "Create copy": "Kopie erstellen",
    "Delete chart": "Organigramm löschen",
    "Delete chart disabled isolved": "Sie können dieses Organigramm derzeit nicht löschen. Bitte kontaktieren Sie den isolved-Support für weitere Informationen.",
    "Add additional report field": "Zusätzliches Berichtsfeld hinzufügen",
    "General field mapping": "Allgemeine Feldzuordnung",
    "Reset to default": "Auf Standard zurücksetzen",
    "This option is disabled due to role assignment restrictions": "Diese Option ist aufgrund von Rollenzuweisungsbeschränkungen deaktiviert",
    "Position dataset": "Positionsdatensatz",
    "Employee dataset": "Mitarbeiterdatensatz",
    "I have a single source with employee data": "Ich habe eine einzelne Quelle mit Mitarbeiterdaten",
    "I have multiple sources with employee and position data": "Ich habe mehrere Quellen mit Mitarbeiter- und Positionsdaten",
    "I have a single source with employee and position data": "Ich habe eine einzelne Quelle mit Mitarbeiter- und Positionsdaten",
    "Budget field mapping": "Budget-Feldzuordnung",
    "Employee details field mapping": "Mitarbeiterdetails-Feldzuordnung",
    "Position details": "Positionsdetails",
    "Start date": "Startdatum",
    "End date": "Enddatum",
    "Vacant": "Vakant",
    "Assignment status": "Zuordnungsstatus",
    "Assignees": "Zugewiesene",
    "System generated": "Systemgeneriert",
    "Upgrade to add more": "Upgrade, um mehr hinzuzufügen",
    "Learn more": "Mehr erfahren",
    "Get started": "Erste Schritte",
    "Access groups remaining": "Verbleibende Zugriffsgruppen",
    "Access groups used": "Verwendete Zugriffsgruppen",
    "Source base chart": "Quell-Basis-Organigramm",
    "Auto-sync enabled": "Auto-Synchronisierung aktiviert",
    "Auto-save enabled": "Automatisches Speichern aktiviert",
    "All staged records": "Alle bereitgestellten Datensätze",
    "Unassign": "Zuordnung aufheben",
    "Release": "Freigeben",
    "Reopen": "Wieder öffnen",
    "Assignment": "Zuweisung",
    "all employees": "alle Mitarbeiter",
    "Reopen position": "Position wieder öffnen",
    "Close position": "Position schließen",
    "Close and release": "Schließen und freigeben",
    "Close and unassign": "Schließen und Zuweisung aufheben",
    "Closed": "Geschlossen",
    "Search name": "Name suchen",
    "Type and press enter": "Eingeben und Enter drücken",
    "Cost bands": "Kostenbänder",
    "Use cost band data": "Gehaltsbandaten verwenden",
    "System calculate for me": "Vom System berechnen lassen",
    "Remove assignment": "Zuordnung entfernen",
    "Search for an employee": "Mitarbeiter suchen",
    "Reassign employee": "Mitarbeiter neu zuweisen",
    "Budget details": "Budgetdetails",
    "Position budget summary": "Positionsbudget-Übersicht",
    "remaining": "verbleibend",
    "total budget": "Gesamtbudget",
    "Utilization": "Auslastung",
    "Total cost": "Gesamtkosten",
    "Employee cost breakdown": "Kostenaufschlüsselung Mitarbeiter",
    "Cost band max": "Gehaltsband-Maximum",
    "Current position cost": "Aktuelle Positionskosten",
    "Create position": "Position erstellen",
    "Custom count": "Benutzerdefinierte Anzahl",
    "Copy position": "Position kopieren",
    "Employee changes": "Mitarbeiteränderungen",
    "Position changes": "Positionsänderungen",
    "Custom formulas remaining": "Verbleibende benutzerdefinierte Formeln",
    "Custom formulas used": "Verwendete benutzerdefinierte Formeln",
    "Enter comment": "Kommentar eingeben",
    "Assigned position": "Zugewiesene Position",
    "Search for a position": "Position suchen",
    "budget": "Budget",
    "View budget information": "Budgetinformationen anzeigen",
    "Hide details": "Details ausblenden",
    "Confirm assignments": "Zuordnungen bestätigen",
    "Employee {employee} assigned to {position}": "Mitarbeiter {employee} wurde {position} zugewiesen",
    "{employee} is unassigned from {position}": "{employee} wurde von {position} entfernt",
    "{employee} is released from {position}": "{employee} wurde von {position} freigegeben",
    "Selections": "Auswahl",
    "Upgrade to create": "Upgrade zum Erstellen",
    "conditional row level": "bedingte Zeilenebene",
    "Upgrade to group": "Upgrade zum Gruppieren",
    "compact and concise": "kompakt und übersichtlich",
    "multiple": "mehrere",
    "Current values": "Aktuelle Werte",
    "Reports to (position)": "Berichtet an (Position)",
    "Work Location": "Arbeitsort",
    "Position Title is required": "Positionsbezeichnung ist erforderlich",
    "Parent PositionID is required": "Übergeordnete Positions-ID ist erforderlich",
    "Reports To is required": "Berichtet an ist erforderlich",
    "Allocation must be a positive number": "Zuweisung muss eine positive Zahl sein",
    "Cost Band Minimum must be a number": "Gehaltsband-Minimum muss eine Zahl sein",
    "Cost Band Maximum must be a number": "Gehaltsband-Maximum muss eine Zahl sein",
    "Cost Band Minimum cannot be greater than Cost Band Maximum": "Gehaltsband-Minimum darf nicht größer sein als Gehaltsband-Maximum",
    "End Date must be on or after Start Date": "Enddatum muss am oder nach dem Startdatum liegen",
    "Copy count must be a positive number": "Kopieranzahl muss eine positive Zahl sein",
    "Position ID is required": "Positions-ID ist erforderlich",
    "and {count} more": "und {count} weitere",
    "Base charts": "Basis-Organigramme",
    "View and select chart export options": "Exportoptionen des Organigramms anzeigen und auswählen",
    "User preferences menu": "Benutzereinstellungen-Menü",
    "Help Center": "Hilfecenter",
    "Data source refresh failures": "Fehler bei der Datenquellenaktualisierung",
    "Data Load Failure": "Fehler beim Laden der Daten",
    "Append Data Failure": "Fehler beim Anhängen der Daten",
    "Merge Data Failure": "Fehler beim Zusammenführen der Daten",
    "Main data source": "Hauptdatenquelle",
    "Append data source": "Zusatzdatenquelle",
    "Merge data source": "Zusammenführungs-Datenquelle",
    "Photo data source": "Fotodatenquelle",
    "Data source": "Datenquelle",
    "Unknown": "Unbekannt",
    "Plan no longer exists": "Plan existiert nicht mehr",
    "Error loading plan": "Fehler beim Laden des Plans",
    "Permission denied to access planning module": "Zugriff auf das Planungsmodul verweigert",
    "Permission denied to access plan": "Zugriff auf den Plan verweigert",
    "Insufficient role to access planning module": "Unzureichende Rolle für den Zugriff auf das Planungsmodul",
    "Core fields cannot be hidden in the table": "Kernfelder können in der Tabelle nicht ausgeblendet werden",
    "branch level": "Abteilungsebene",
    "Enable approvals": "Genehmigungen aktivieren",
    "plan approval system": "Plangenehmigungssystem",
    "granular control": "detaillierte Steuerung",
    "calculate metrics": "Kennzahlen berechnen",
    "accurate depiction": "genaue Darstellung",
    "automatically assign": "automatisch zuweisen",
    "Clone": "Klonen",
    "Edit position": "Position bearbeiten",
    "Multiple positions": "Mehrere Positionen",
    "Multiple employees": "Mehrere Mitarbeiter",
    "Automatically archive charts": "Organigramme automatisch archivieren",
    "Org structures": "Organisationsstrukturen",
    "Stay audit ready": "Immer auditbereit",
    "securely captured": "sicher erfasst",
    "identify patterns": "Muster erkennen",
    "Assignments": "Zuweisungen",
    "Additional data sources remaining": "Verbleibende zusätzliche Datenquellen",
    "Upgrade to add": "Upgrade zum Hinzufügen",
    "additional HR systems": "zusätzliche HR-Systeme",
    "vacancies or contractors": "Vakanzen oder Auftragnehmer",
    "secondary managers": "sekundäre Vorgesetzte",
    "Upgrade to plan": "Upgrade zur Planung",
    "Plan with Position Data": "Planung mit Positionsdaten",
    "Track KPIs": "KPIs verfolgen",
    "Collaborate in Real Time": "In Echtzeit zusammenarbeiten",
    "positions and vacancies": "Positionen und Vakanzen",
    "insight": "Einblick",
    "impact": "Auswirkung",
    "setting and tracking": "Einstellung und Verfolgung",
    "drag and drop": "Drag-and-Drop",
    "move groups": "Gruppen verschieben",
    "team is aware": "Team ist informiert",
    "This option is disabled due to package restrictions": "Diese Option ist aufgrund von Paketbeschränkungen deaktiviert",
    "Core mapped fields must always show to build your base chart": "Kern-zugeordnete Felder müssen immer angezeigt werden, um Ihr Basis-Organigramm aufzubauen",
    "This field cannot be {status1} as it has already been selected as {status2}": "Dieses Feld kann nicht als {status1} festgelegt werden, da es bereits als {status2} ausgewählt wurde",
    "Upgrade": "Upgrade",
    "Employees in deleted position will be unassigned in the Employee List.": "Mitarbeiter in gelöschter Position werden in der Mitarbeiterliste nicht zugewiesen.",
    "Would you like to rollup or delete the subordinates for {position}?": "Möchten Sie die Untergeordneten von {position} zusammenfassen oder löschen?",
    "Rollup or delete subordinate positions": "Untergeordnete Positionen zusammenfassen oder löschen",
    "Rollup subordinates": "Untergebene zusammenfassen",
    "Delete subordinates": "Untergebene löschen",
    "Position field": "Positionsfeld",
    "Allocation": "Zuordnung",
    "Holder Count": "Inhaberanzahl",
    "Add subordinate position": "Untergeordnete Position hinzufügen",
    "Add subordinate position(s)": "Untergeordnete Position(en) hinzufügen",
    "Add employee(s) to position": "Mitarbeiter zur Position hinzufügen",
    "Add assistant position": "Assistenzposition hinzufügen",
    "Created and assigned to": "Erstellt und zugewiesen an",
    "Position profile": "Positionsprofil",
    "Employee profile": "Mitarbeiterprofil",
    "Edit position details": "Positionsdetails bearbeiten",
    "Edit employee details": "Mitarbeiterdetails bearbeiten",
    "Employee details": "Mitarbeiterdetails",
    "Create new chart": "Neues Organigramm erstellen",
    "range": "Bereich",
    "Starting value": "Startwert",
    "Ending value": "Endwert",
    "Choose a color": "Farbe auswählen",
    "last [n] days": "letzte [n] Tage",
    "last [n] weeks": "letzte [n] Wochen",
    "last [n] months": "letzte [n] Monate",
    "last [n] years": "letzte [n] Jahre",
    "next [n] days": "nächste [n] Tage",
    "next [n] weeks": "nächste [n] Wochen",
    "next [n] months": "nächste [n] Monate",
    "next [n] years": "nächste [n] Jahre",
    "yesterday": "gestern",
    "tomorrow": "morgen",
    "To (optional)": "Bis (optional)",
    "specific date": "bestimmtes Datum",
    "removed from your data set": "aus Ihrem Datensatz entfernt",
    "created positions for you to maintain": "erstellte Positionen zur Pflege",
    "append table": "Zusatztabelle",
    "Minimum subordinate threshold": "Mindestanzahl Untergeordneter",
    "Include": "Einschließen",
    "Exclude": "Ausschließen",
    "Favorite field {i}": "Favoritenfeld {i}",
    "Profile picture": "Profilbild",
    "Employee profile card": "Mitarbeiter-Profilkarte",
    "Position profile card": "Positions-Profilkarte",
    "Additional {type} information": "Zusätzliche {type}-Informationen",
    "Heading information": "Kopfzeileninformation",
    "Fields to": "Felder für",
    "Position start date": "Positionsstartdatum",
    "Position end date": "Positionsenddatum",
    "Full name": "Vollständiger Name",
    "Employee ID": "Mitarbeiter-ID",
    "Position ID": "Positions-ID",
    "Record type": "Datensatztyp",
    "Record name": "Datensatzname",
    "Modification type": "Änderungstyp",
    "Replace all": "Alle ersetzen",
    "Add to existing": "Zu vorhandenen hinzufügen",
    "Append table has existing records": "Zusatztabelle enthält vorhandene Datensätze",
    "Information unavailable": "Information nicht verfügbar",
    "Clear vacant positions": "Vakante Positionen löschen",
    "Clear vacant positions after": "Vakante Positionen löschen nach",
    "1 assignee": "1 Zugewiesener",
    "{n} assignees": "{n} Zugewiesene",
    "Field name": "Feldname",
    "No fields added yet": "Noch keine Felder hinzugefügt",
    "Data sources below are not yet supported for this chart type. For assistance, please reach out to ": "Die folgenden Datenquellen werden für diesen Organigrammtyp noch nicht unterstützt. Für Unterstützung wenden Sie sich bitte an",
    "What type of dataset do you want to ": "Welchen Datensatztyp möchten Sie",
    "Force queue refresh": "Warteschlangen-Aktualisierung erzwingen",
    "Force queue": "Warteschlange erzwingen",
    "Use Auth V1": "Auth V1 verwenden",
    "Plan state": "Planstatus",
    "Approval Status": "Genehmigungsstatus",
    "Approval status": "Genehmigungsstatus",
    "This plan has the following approver(s) and their approval status:": "Dieser Plan hat die folgenden Genehmiger und deren Genehmigungsstatus:",
    "Draft": "Entwurf",
    "Submitted": "Eingereicht",
    "Approved": "Genehmigt",
    "Rejected": "Abgelehnt",
    "Withdrawn": "Zurückgezogen",
    "Pending": "Ausstehend",
    "Submit Plan for Approval": "Plan zur Genehmigung einreichen",
    "Plan details": "Plandetails",
    "Owner": "Besitzer",
    "Add approvers": "Genehmiger hinzufügen",
    "Search for approvers": "Genehmiger suchen",
    "Message": "Nachricht",
    "Add a message for approvers": "Nachricht für Genehmiger hinzufügen",
    "Submit for approval": "Zur Genehmigung einreichen",
    "Submit Plan": "Plan einreichen",
    "Plan Submitted": "Plan eingereicht",
    "Approve Plan": "Plan genehmigen",
    "Approve plan": "Plan genehmigen",
    "Reject plan": "Plan ablehnen",
    "Submit plan": "Plan einreichen",
    "Withdraw plan": "Plan zurückziehen",
    "No plan approvals have been made yet.": "Es wurden noch keine Plangenehmigungen erteilt.",
    "Approvals": "Genehmigungen",
    "Reject Plan": "Plan ablehnen",
    "Approval message": "Genehmigungsnachricht",
    "Rejection message": "Ablehnungsnachricht",
    "Approve": "Genehmigen",
    "Reject": "Ablehnen",
    "Submission Info": "Einreichungsinformation",
    "Submitted by": "Eingereicht von",
    "Submitted on": "Eingereicht am",
    "Submission message": "Einreichungsnachricht",
    "Approvers": "Genehmiger",
    "Add a message": "Nachricht hinzufügen",
    "Grant access": "Zugriff gewähren",
    "Withdraw": "Zurückziehen",
    "Withdrawal message": "Rückzugsnachricht",
    "Optional message": "Optionale Nachricht",
    "Withdrawn by": "Zurückgezogen von",
    "Withdrawn on": "Zurückgezogen am",
    "Force calculate": "Berechnung erzwingen",
    "Force calculate formulas": "Formelberechnung erzwingen",
    "Table view": "Tabellenansicht",
    "Default editable fields": "Standardmäßig bearbeitbare Felder",
    "Choose the default editable fields that you want to show in the {entity} modals.": "Wählen Sie die standardmäßig bearbeitbaren Felder aus, die in den {entity}-Dialogen angezeigt werden sollen.",
    "Plan settings apply to plans created from the selected base chart.": "Planeinstellungen gelten für Pläne, die vom ausgewählten Basis-Organigramm erstellt werden.",
    "Approval settings": "Genehmigungseinstellungen",
    "Enable plan approvals": "Plangenehmigungen aktivieren",
    "Disable plan approval?": "Plangenehmigung deaktivieren?",
    "Disabling plan approval will hide plan approval flows for all plans created from this base chart. Are you sure you want to disable plan approval for this base chart?": "Das Deaktivieren der Plangenehmigung blendet Genehmigungsabläufe für alle Pläne aus, die von diesem Basis-Organigramm erstellt wurden. Möchten Sie die Plangenehmigung für dieses Basis-Organigramm wirklich deaktivieren?",
    "When enabled, plans can be submitted for approval and e-mail notifications are sent for status updates.": "Wenn aktiviert, können Pläne zur Genehmigung eingereicht werden und E-Mail-Benachrichtigungen werden bei Statusänderungen gesendet.",
    "Disable": "Deaktivieren",
    "Show only plans needing my approval": "Nur Pläne anzeigen, die meine Genehmigung benötigen",
    "Plan requires approval": "Plan erfordert Genehmigung",
    "you": "Sie",
    "Review changes": "Änderungen überprüfen",
    "In Review": "In Überprüfung",
    "Manage plan fields": "Planfelder verwalten",
    "Review plan": "Plan überprüfen",
    "This plan is in draft and has no approver information available until it is submitted for approval.": "Dieser Plan ist ein Entwurf und enthält keine Genehmiger-Informationen, bis er zur Genehmigung eingereicht wird.",
    "Add language": "Sprache hinzufügen",
    "Data localization": "Datenlokalisierung",
    "Include field?": "Feld einschließen?",
    "Include field": "Feld einschließen",
    "Are you sure you want to include this field?": "Möchten Sie dieses Feld wirklich einschließen?",
    "Search for field": "Feld suchen",
    "Delete language": "Sprache löschen",
    "Are you sure you want to delete this language? All mapped field configurations for this language will be lost.": "Möchten Sie diese Sprache wirklich löschen? Alle zugeordneten Feldkonfigurationen für diese Sprache gehen verloren.",
    "Layout type": "Layout-Typ",
    "Standard box": "Standardbox",
    "Group box": "Gruppenbox",
    "Group box style": "Gruppenbox-Stil",
    "Save changes": "Änderungen speichern",
    "Display settings": "Anzeigeeinstellungen",
    "Limit text to a single row": "Text auf eine einzelne Zeile beschränken",
    "columns used in the group box": "Spalten in der Gruppenbox verwendet",
    "Default to view's box style": "Standard auf Box-Stil der Ansicht",
    "Group box layouts cannot have columns": "Gruppenbox-Layouts können keine Spalten haben",
    "This box layout type is applied to employee boxes.": "Dieser Box-Layouttyp wird auf Mitarbeiterboxen angewendet.",
    "This box layout type is applied to the grouped box that groups the employee records.": "Dieser Box-Layouttyp wird auf die Gruppenbox angewendet, die die Mitarbeiterdatensätze gruppiert.",
    "You do not have any custom group styles created. Create a custom group style in the 'Box styles' panel and apply it to a conditional grouping.": "Sie haben noch keine benutzerdefinierten Gruppenstile erstellt. Erstellen Sie einen benutzerdefinierten Gruppenstil im Bereich „Box-Stile“ und wenden Sie ihn auf eine bedingte Gruppierung an.",
    "Framed": "Eingerahmt",
    "Condensed": "Komprimiert",
    "Grouped employee records appear in a list. The ‘Group by field’ value for those grouped records is displayed at the top of the group.": "Gruppierte Mitarbeiterdatensätze werden in einer Liste angezeigt. Der Wert „Nach Feld gruppieren“ für diese gruppierten Datensätze wird oben in der Gruppe angezeigt.",
    "A frame is placed around grouped records. Conditional formatting targeting framed grouped records still appear.": "Ein Rahmen wird um gruppierte Datensätze platziert. Bedingte Formatierungen für gerahmte gruppierte Datensätze werden weiterhin angezeigt.",
    "Employee box style": "Mitarbeiter-Box-Stil",
    "Default to last used or only created": "Standard auf zuletzt verwendet oder einzig erstellten",
    "View name": "Ansichtsname",
    "BudgetedHeadcount": "Budgetierte Mitarbeiterzahl",
    "SalaryRollup": "Gehaltsübersicht",
    "CurrentPositionCost": "Aktuelle Stellenkosten",
    "PositionBudgetRollup": "Positionsbudget-Übersicht",
    "PositionCount": "Anzahl der Positionen",
    "SubordinatePositions": "Untergeordnete Positionen",
    "DirectSubordinatePositions": "Direkt untergeordnete Positionen",
    "PeerPositions": "Gleichrangige Positionen",
    "overtarget": "{delta} über dem Ziel",
    "undertarget": "{delta} unter dem Ziel",
    "Metric trend tooltip": "Start: {starting} | Differenz: {delta}",
    "Duplicate file or files": "Datei(en) duplizieren",
    "foldermoveddeleted": "Der Ordner wurde nicht gefunden. Er wurde möglicherweise umbenannt oder existiert nicht mehr.",
    "foldernotfound": "Ordner nicht gefunden",
    "deleteuser2": "aus Ihrem Konto",
    "connectionerr": "Verbindungsfehler. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    "planconfigupdated": "Die Plankonfiguration wurde aktualisiert.",
    "planupdatedlatest": "Planänderungen synchronisiert.",
    "talentpoolupdated": "Der Talentpool wurde aktualisiert.",
    "functionalchartoption": "Funktion {index}",
    "rowsecallowedfieldsimplicit": "Alle uneingeschränkten Felder sind sichtbar.",
    "formulaerrnooperations": "Fügen Sie mindestens eine Operation hinzu.",
    "formulaerrnorule": "Die Regeldefinition ist erforderlich.",
    "This field is required": "Dieses Feld ist erforderlich.",
    "Both fields are required": "Beide Felder sind erforderlich.",
    "Add at least one value to the operation": "Fügen Sie der Operation mindestens einen Wert hinzu.",
    "There are required fields missing": "Es fehlen erforderliche Felder.",
    "Maximum number of metrics reached alert": "Sie können bis zu {MAX_METRICS} {metrics} gleichzeitig verfolgen. Um eine neue Metrik hinzuzufügen, müssen Sie eine vorhandene entfernen.",
    "No more formulas available to add alert": "Keine Formeln zum Verfolgen verfügbar. Administratoren können Formeln in {chartSettingsFieldsFormulasPath} erstellen.",
    "No metrics available to add": "Keine Metriken zum Hinzufügen verfügbar.",
    "Remove a metric to add a new one": "Entfernen Sie eine Metrik, um eine neue hinzuzufügen.",
    "Add metrics info": "Fügen Sie Metriken hinzu, um Planziele festzulegen und Änderungen zu verfolgen.",
    "chartSettingsFieldsFormulasPath": "Organigrammeinstellungen: Felder und Formeln",
    "Create Table": "Tabelle erstellen",
    "Entity details": "{entity}-Details",
    "planNoChartAccess": "Sie benötigen Zugriff auf das Quellorganigramm, um diesen Plan anzuzeigen. Wenden Sie sich an Ihren Administrator.",
    "Position Location": "Standort der Position",
    "Employee SupervisorID": "Vorgesetzten-ID des Mitarbeiters",
    "Employee Location": "Standort des Mitarbeiters",
    "Position Title": "Positionsbezeichnung",
    "Position Division": "Abteilung der Position",
    "Employee Title": "Mitarbeiterbezeichnung",
    "Position Budgeted Salary": "Budgetiertes Positionsgehalt",
    "Position Cost Center": "Kostenstelle der Position",
    "Position Cost Band Minimum": "Gehaltsband-Minimum der Position",
    "Position Cost Band Midpoint": "Gehaltsband-Mitte der Position",
    "Position Cost Band Maximum": "Gehaltsband-Maximum der Position",
    "Employee Salary": "Mitarbeitervergütung",
    "Employee Pay": "Mitarbeitervergütung kumuliert",
    "Employee Cost Center": "Kostenstelle des Mitarbeiters",
    "DesiredHolders": "Soll-Besetzung",
    "Build Position Doc": "Welche Position möchten Sie an die Spitze dieses {document} setzen?",
    "levelcharthelp": "Wählen Sie ein Feld für das Ebenen-Organigramm. Alle Zweige verwenden den Baumstil.",
    "Select up to 3 fields": "Wählen Sie bis zu 3 Felder, die oben auf der Profilkarte angezeigt werden.",
    "Enable profile starring": "Profil-Favoritenfelder (benutzerdefiniert)",
    "Enterprise source limit": "Enterprise-Konten können bis zu 10 Datenquellen aggregieren.",
    "livechartnotfound": "Das zugehörige Basis-Organigramm wurde nicht gefunden und kann nicht synchronisiert werden. Sie können neue benutzerdefinierte Organigramme aus vorhandenen Basis-Organigrammen erstellen.",
    "chartnotfound": "Das zugehörige Basis-Organigramm wurde nicht gefunden und kann nicht synchronisiert werden. Sie können neue benutzerdefinierte Organigramme erstellen. Dieses Organigramm bleibt für die Bearbeitung oder den Export verfügbar.",
    "changePaylocity": "Bei Problemen mit Ihrer Paylocity-Integration oder zum Einrichten einer neuen Integration wenden Sie sich an",
    "changeSage300za": "Der API-Endpunkt dieser Integration muss vom Support konfiguriert werden. Wenden Sie sich zum Einrichten an ",
    "Cannot add plan top box to talent pool": "Die oberste Box des Plans kann nicht zum Talentpool hinzugefügt werden.",
    "Failed to remove talent": "Talent konnte nicht entfernt werden.",
    "refreshemail": "Geben Sie die E-Mail-Adressen der Benutzer ein, die Benachrichtigungen erhalten sollen.",
    "autoexportemail": "Geben Sie die E-Mail-Adressen der Benutzer ein, die automatische Exporte erhalten sollen.",
    "invalidcharwarn": "Bestimmte Zeichen sind für Feldnamen nicht verfügbar. Sie können die Feldbezeichnungsfunktion verwenden, um Zeichen wie '$' hinzuzufügen.",
    "The scope of the export exceeds your account's box limit": "Der Exportumfang überschreitet das Box-Limit Ihres Kontos. Bitte reduzieren Sie den Umfang oder kontaktieren Sie clientsuccess@theorgchart.com.",
    "One or more scope options is disabled because they exceed the maximum box limit for custom charts": "Eine oder mehrere Umfangsoptionen sind deaktiviert, da sie das Box-Limit für benutzerdefinierte Organigramme überschreiten. Dies kann von einem Administrator konfiguriert werden.",
    "invalidemailmessage": "Bitte geben Sie eine gültige E-Mail-Adresse in der Konfiguration der geplanten Aktualisierung ein, um die Änderungen speichern zu können.",
    "autoemailmessage": "Bitte geben Sie eine gültige E-Mail-Adresse in der Konfiguration des automatischen Exports ein, um die Änderungen speichern zu können.",
    "Dayforce reset info": "Die Dayforce-API erkennt Änderungen nur zwischen der letzten und der aktuellen Datenaktualisierung. Wenn Sie wesentliche Änderungen an Ihrer Integration vorgenommen haben, klicken Sie auf {resetLabel}, um eine neue Datenbasis zu erstellen. Nach dem Zurücksetzen kann die Aktualisierung länger dauern.",
    "Confirm reset integration": "Möchten Sie Ihre aktuelle Integration wirklich zurücksetzen? Diese Aktion kann nicht rückgängig gemacht werden. Warnung: Die nächste Datenaktualisierung kann länger dauern.",
    "You are over your seat limit": "Sie haben Ihr Lizenzlimit für Lese-/Schreibzugriff erreicht. Sie können Lizenzen freigeben, indem Sie vorhandene Benutzer in Nur-Lesen-Lizenzen umwandeln. Um zusätzliche Lizenzen zu erwerben, kontaktieren Sie",
    "deletesingleuser": "Benutzer löschen",
    "enableFields": "Interaktives Umschalten von Feldern zulassen",
    "Reports to removed": "Der Datensatz existiert nicht mehr. Suchen Sie einen neuen 'Berichtet an' oder machen Sie die Planänderung rückgängig.",
    "createWebLink": "Weblinks erstellen",
    "recordDetails": "Datensatzdetails",
    "chartExplorerWarn": "Sie haben aufgrund Ihres UI-Profils keinen Zugriff auf den Organigramm-Explorer.",
    "contactAdmin": "Wenden Sie sich an Ihren Administrator.",
    "Are you sure you want to delete background": "Möchten Sie diesen Hintergrund wirklich löschen? Organigramme, die mit diesem Hintergrund verknüpft sind, können ihn nicht mehr laden.",
    "Are you sure you want to move background": "Möchten Sie diesen Hintergrund wirklich verschieben? Verknüpfte Organigramme können ihn möglicherweise nicht mehr laden.",
    "transferAttributesInfoText": "Übertragen Sie Benutzerattribute vom Identitätsanbieter (IDP) an die Anwendung für eine verbesserte Profilverwaltung.",
    "transferAttributeLabel": "Benutzerattribute übertragen",
    "Set default background": "Klicken Sie hier, um den Standard-Hintergrund festzulegen",
    "Load field mapping now": "Feldzuordnung jetzt laden?",
    "Load field mapping info": "Eine gültige Feldzuordnung ist erforderlich, um Organigramme zu erstellen. OrgChart versucht, eine geeignete Zuordnung zu bestimmen, manuelle Anpassungen können jedoch erforderlich sein.",
    "lastrulemessage": "Die letzte Regel einer Ansicht kann nicht gelöscht werden. Um diese Regel zu löschen, fügen Sie zuerst eine weitere Regel hinzu.",
    "duplicatedrop": "Aktivieren, um zu verhindern, dass doppelte Datensätze zum Organigramm hinzugefügt werden",
    "deleteuserdelegate1": "Dieser Benutzer ist mit mindestens einem sekundären Benutzer in anderen",
    "deleteuserdelegate2": "Wenn Sie diesen Benutzer löschen, werden auch alle sekundären Benutzer mit derselben E-Mail in anderen Konten gelöscht. Möchten Sie diese Benutzer wirklich löschen?",
    "confirmdeletedelegate": "Primäre und sekundäre Benutzer löschen",
    "denydeletedelegate": "Nicht löschen",
    "Send all files to trash": "Möchten Sie wirklich {fileCount} Dateien aus dem Ordner '{folder}' in den Papierkorb verschieben?",
    "Delete all files trash": "Möchten Sie wirklich {fileCount} Dateien aus dem Papierkorb löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "Permanently delete file": "Datei dauerhaft löschen?",
    "Move files to trash": "In den Papierkorb verschieben",
    "Move all files to trash": "Dateien in den Papierkorb verschieben?",
    "Delete all files": "Alle Dateien löschen?",
    "Choose unique name": "Bitte wählen Sie einen eindeutigen Namen.",
    "disableIndexSwitch": "Die Indexseitenoption ist nur für vollständige Organigramm-Exporte verfügbar. Wählen Sie auf der Registerkarte Allgemein den Umfang 'Gesamtes Organigramm'.",
    "Generic insufficient permissions": "Sie haben aufgrund Ihrer Zugriffsgruppe oder Rolle keine Berechtigung für diese Aktion. Bitte wenden Sie sich an Ihren Systemadministrator.",
    "Folder locked": "Dieser Ordner ist gesperrt. Sie können den Inhalt gesperrter Ordner nicht ändern.",
    "No append tables (long)": "Es sind noch keine Tabellen eingerichtet. Erstellen Sie eine Tabelle, um Datensätze zu verwalten und zu ändern.",
    "New Table (name)": "Neue Tabelle",
    "Modifications shown here (long)": "Alle Arten von Änderungen werden hier in einer Tabellenansicht aufgezeichnet.",
    "Manage tables info (long)": "Verwalten Sie Ihre vorhandenen Tabellen oder erstellen Sie eine neue für Ihr Basis-Organigramm.",
    "Additional field in use (long)": "Ein Feldname wird mehrfach verwendet. Bitte stellen Sie sicher, dass alle Feldnamen eindeutig sind, bevor Sie speichern.",
    "Additional field is reserved (long)": "Ein oder mehrere Feldnamen sind reserviert. Bitte stellen Sie sicher, dass alle Feldnamen eindeutig sind, bevor Sie speichern.",
    "Name is reserved": "Name ist reserviert.",
    "Name already in use": "Name wird bereits verwendet.",
    "Errors in form": "Sie haben nicht gespeicherte Änderungen, aber es gibt Fehler, die vor dem Speichern behoben werden müssen. Möchten Sie die Probleme beheben oder Ihre Änderungen verwerfen?",
    "About append table (long)": "Die Zusatztabelle ermöglicht es Ihnen, Datensätze in vorhandenen Organigrammen zu verwalten. Suchen Sie nach einem vorhandenen Mitarbeiter oder einer Position, um Änderungen vorzunehmen. Sie können auch Datensätze hinzufügen oder die Upload-/Download-Schaltflächen verwenden.",
    "About additional fields (long)": "Verwenden Sie Ihre Zusatztabelle, um neue Felder hinzuzufügen. Zusätzliche Felder können nach der Erstellung nicht mehr umbenannt werden.",
    "No Table Selected": "Keine Tabelle ausgewählt",
    "Modification history": "Änderungsverlauf",
    "Modification history tip": "Alle Änderungen werden automatisch gespeichert.",
    "Number of modifications": "Anzahl der Änderungen an dieser Tabelle",
    "Number of additional fields": "Anzahl der zu dieser Tabelle hinzugefügten Felder",
    "Changes have been saved": "Änderungen wurden gespeichert.",
    "An error occurred while saving": "Beim Speichern ist ein Fehler aufgetreten.",
    "Active table set": "{tableName} als aktive Tabelle festgelegt.",
    "Entity not found": "{entity} nicht gefunden",
    "Entity created": "{tableName} erstellt.",
    "Entity changes saved": "Änderungen an {entity} gespeichert.",
    "Are you sure you want to delete entity": "Möchten Sie {entity} wirklich löschen?",
    "Entity deleted": "{entity} gelöscht.",
    "Entity copied": "Kopie von {entity} erstellt",
    "Entity renamed": "{oldEntity} umbenannt in {newEntity}",
    "Entity set as default": "{entity} als Standard festgelegt",
    "Entity i": "{entity} {i}",
    "Entity name": "Name von {entity}",
    "Add entity": "{entity} hinzufügen",
    "Create entity": "{entity} erstellen",
    "Edit entity": "{entity} bearbeiten",
    "Copy entity": "{entity} kopieren",
    "Entity saved": "{entity} gespeichert.",
    "Edit entity details": "{entity}-Details bearbeiten",
    "Entity name cannot be empty": "Der Name von {entity} darf nicht leer sein.",
    "Number of entity applied to the chart": "Anzahl der auf das Organigramm angewendeten {entity}.",
    "Fill all fields {entity}": "Alle erforderlichen Felder müssen ausgefüllt werden, bevor Sie {entity} speichern können.",
    "Invalid date range": "Datumsbereich ungültig. Das Datum \"Von\" muss vor dem Datum \"Bis\" liegen.",
    "Invalid numeric range": "Numerischer Bereich ungültig. Der Startwert muss kleiner als der Endwert sein.",
    "Invalid range on criteria {n}": "Ungültiger Bereich bei Kriterium {n}. Der Startwert muss kleiner als der Endwert sein.",
    "Invalid date range on criteria {n}": "Ungültiger Datumsbereich bei Kriterium {n}. Das Datum \"Von\" muss vor dem Datum \"Bis\" liegen.",
    "Missing required field": "Pflichtfeld fehlt.",
    "Missing required field on criteria {n}": "Pflichtfeld fehlt bei Kriterium {n}.",
    "Criteria {n} {msg}": "Kriterium {n}: {msg}",
    "Generic default error": "Ein Fehler wurde erkannt.",
    "Generic toast error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    "Table name must be at least 4 characters and unique": "Der Tabellenname muss mindestens 4 Zeichen lang und eindeutig sein.",
    "Chart fields changed (long)": "Die Organigrammfelder haben sich geändert. Bitte aktualisieren Sie Ihr Organigramm.",
    "Update Base Chart Mapping": "Basis-Organigramm-Zuordnung aktualisieren?",
    "Update Base Chart Mapping (long)": "Möchten Sie, dass OrgChart die Zuordnung Ihres Basis-Organigramms aktualisiert, um Ihr neues zusätzliches Berichtsfeld zu verwenden?",
    "Update Base Chart Mapping (info)": "Die Berichtszuordnung kann in {mappingPath} im Abschnitt {AuxRepMapping} angepasst werden.",
    "Delete additional field": "Zusätzliches Feld löschen?",
    "Delete additional field (long)": "Möchten Sie das Feld {name} wirklich löschen?",
    "Broken field references warning": "Verweise auf dieses Feld (Box-Stile, Profil und andere Formatierungsoptionen) werden nicht mehr korrekt angezeigt.",
    "Additional reports limit": "Das System ermöglicht es Ihnen, bis zu vier zusätzliche Vorgesetztenzuweisungen hinzuzufügen.",
    "Additional reports info": "Zusätzliche Berichte können hier schnell hinzugefügt und in {mappingPath} verwaltet werden.",
    "mappingPath": "Organigrammeinstellungen: Zuordnung",
    "You cannot rename the additional fields once they have been created": "Zusätzliche Felder können nach der Erstellung nicht mehr umbenannt werden.",
    "Refresh chart notice": "Aktualisieren Sie Ihr Organigramm, um die neuesten Änderungen anzuzeigen.",
    "Confirm copy base chart": "Ein Basis-Organigramm ist Ihr Fundament und Sie benötigen in der Regel nur eines. Sie können mehrere {customCharts} aus einem einzigen Basis-Organigramm erstellen, um Formatierung, Berichtslinien und andere Einstellungen zu ändern.",
    "Are you sure you want to copy base chart": "Möchten Sie dieses Basis-Organigramm wirklich kopieren?",
    "Copy base chart": "Basis-Organigramm kopieren?",
    "Delete base chart": "Basis-Organigramm löschen?",
    "What type of chart are you creating": "Welche Art von Organigramm erstellen Sie?",
    "Confirm delete base chart": "Durch das Löschen eines Basis-Organigramms wird es dauerhaft entfernt. Pläne und benutzerdefinierte Organigramme, die dieses Basis-Organigramm verwenden, können nicht mehr auf die Daten zugreifen. Diese Aktion kann nicht rückgängig gemacht werden.",
    "Base Employee Chart": "Basis-Mitarbeiter-Organigramm",
    "Base Position Chart": "Basis-Positions-Organigramm",
    "Custom Employee Chart": "Benutzerdefiniertes Mitarbeiter-Organigramm",
    "Custom Position Chart": "Benutzerdefiniertes Positions-Organigramm",
    "Employee Chart Plan": "Mitarbeiter-Organigrammplan",
    "Position Chart Plan": "Positions-Organigrammplan",
    "Employee Chart Details": "Ein personenzentriertes Organigramm, das die Beziehungen zwischen einzelnen Mitarbeitern visualisiert und direkte Verbindungen unabhängig von der formalen Positionsstruktur zeigt.",
    "Position Chart Details": "Ein positionszentriertes Organigramm, das die formale Hierarchie Ihrer Organisation basierend auf Rollen und Positionen anzeigt, anstatt auf den Personen, die sie besetzen.",
    "Position Chart Disabled": "Um diese Funktion zu aktivieren, wenden Sie sich bitte an den Kundensupport.",
    "Position Chart Coming Soon": "Das Positions-Organigramm ist in Kürze verfügbar.",
    "Select employee chart type": "Zu einem Mitarbeiter-Organigrammtyp wechseln",
    "Select position chart type": "Zu einem Positions-Organigrammtyp wechseln",
    "characters remaining": "{count} Zeichen verbleibend",
    "Switch chart types": "Organigrammtyp wechseln?",
    "Switch chart type (long)": "Beim Wechsel des Organigrammtyps müssen Sie eine Datenquelle erneut auswählen.",
    "Select fields and assign them as either holder fields, position fields, or both": "Wählen Sie Felder aus und weisen Sie sie mit den Schaltflächen unten als Inhaberfelder, Positionsfelder oder beides zu.",
    "Chart plan": "{chart}-Plan",
    "Plan Objective": "Was ist das Ziel bei der Erstellung dieses Plans?",
    "planobjective": "Planziel",
    "Plan Objective Help": "Erfahren Sie mehr über Planziele in unserem",
    "Plan Objective Help Link": "Hilfecenter",
    "Assigned Out Of Scope": "Zugewiesen*",
    "Assigned Out Of Scope Info": "Außerhalb des Planumfangs zugewiesen",
    "Choose what type of position data": "Wählen Sie aus, welche Art von Daten Sie verwenden möchten, um Ihr Positions-Organigramm zu erstellen",
    "costband": "Kostenband (pro Mitarbeiter)",
    "costbandinfo": "Legen Sie einen minimalen und maximalen Kostenbereich pro Mitarbeiter fest, um die Budgetauswirkung zu überwachen.",
    "Multi position editor changes info": "Alle Änderungen, die Sie an den folgenden Feldern vornehmen, gelten für die {count} {positions}, die Sie ausgewählt haben.",
    "Reopen position editor changes info": "Sie können {__reopenTheCountPosition__}, aber Mitarbeiter, die zum Zeitpunkt der Schließung zugewiesen waren, {__wontBeAutomaticallyReassigned__} der Position.",
    "Successfully updated positions": "{count} {positions} erfolgreich aktualisiert",
    "Failed to update positions": "Positionen konnten nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
    "costbanderror": "Das Kostenband-Minimum muss kleiner als das Kostenband-Maximum sein",
    "startenddateerror": "Das Startdatum muss vor dem Enddatum liegen",
    "staffingtargeterror": "Das Besetzungsziel muss größer als 0 sein",
    "Show more entity": "Mehr {entity} anzeigen",
    "Show less entity": "Weniger {entity} anzeigen",
    "staffingtargetinfo": "Stellt die gewünschte maximale Anzahl von Mitarbeitern dar, die dieser Position zugewiesen sind. Sie können trotzdem so viele Mitarbeiter zuweisen, wie Sie es für richtig halten.",
    "System generated positions": "Dieses Feld wird automatisch anhand der Mitarbeiter-zu-Mitarbeiter-Berichtsstruktur generiert.",
    "System generated item": "{item} (Systemgeneriert)",
    "Pricing and Packaging": "Preise und Pakete",
    "accessGroupLimit": "Sie haben das Limit für das Hinzufügen von Zugriffsgruppen erreicht. Bitte kontaktieren Sie den Support unter support@theorgchart.com für Hilfe",
    "Box count tooltip": "Gesamtanzahl der Boxen im aktuell geöffneten {document}.",
    "Boxes shown tooltip": "Die Anzahl der angezeigten Boxen im aktuell geöffneten {document}.",
    "All staged records tooltip": "Gesamtzahl der Datensätze im Staging-Bereich des aktuell geöffneten benutzerdefinierten Organigramms. Datensätze können im Staging-Bereich landen, wenn ihr Vorgesetzter aus dem Organigramm gefiltert wurde oder wenn Sie sie manuell dorthin verschoben haben.",
    "Levels tooltip": "Anzahl der angezeigten Organisationsebenen im aktuell geöffneten {document}.",
    "Disconnected records tooltip": "Gesamtzahl der getrennten Boxen im aktuell geöffneten Organigramm. Getrennte Boxen können fehlende oder ungültige Vorgesetzten-IDs haben oder nicht an andere Datensätze im Hauptberichtsbaum des Basis-Organigramms berichten.",
    "Employee is unassigned from position": "{employee} wurde von {position} entfernt.",
    "Employee is assigned to position": "{employee} wurde {position} zugewiesen.",
    "{count} {employees} are assigned to {position}": "{count} {employees} wurden {position} zugewiesen.",
    "{count} {employees} are unassigned from {position}": "{count} {employees} wurden von {position} entfernt.",
    "totalHoldersCount employees are unassigned from entity": "{totalHoldersCountEmployees} wurden von {entity} entfernt.",
    "totalHoldersCount employees are unassigned from their positions": "{totalHoldersCountEmployees} wurden von ihren Positionen entfernt.",
    "totalHoldersCount employees are released from entity": "{totalHoldersCountEmployees} wurden von {entity} freigegeben.",
    "totalHoldersCount employees are released from their positions": "{totalHoldersCountEmployees} wurden von ihren Positionen freigegeben.",
    "Subordinate moved to parent": "{subordinate} wurde zu {parent} verschoben.",
    "Subordinate moved from position to position": "{fromPosition} wurde zu {toPosition} verschoben.",
    "Unassigned employees can be found in the Employee List": "Nicht zugewiesene Mitarbeiter finden Sie in der Mitarbeiterliste.",
    "Are you sure you want to unassign employee from the position position?": "Möchten Sie {employee} wirklich von der Position {position} entfernen?",
    "Are you sure you want to unassign totalHoldersCount employees from the position position?": "Möchten Sie {totalHoldersCountEmployees} wirklich von der Position {position} entfernen?",
    "Are you sure you want to unassign totalHoldersCount employees from the following positions?": "Möchten Sie {totalHoldersCountEmployees} wirklich von den folgenden Positionen entfernen?",
    "Released employees can be found in the Employee List": "Freigegebene Mitarbeiter finden Sie in der Mitarbeiterliste.",
    "Are you sure you want to release employee from the position position?": "Möchten Sie {employee} wirklich von der Position {position} freigeben?",
    "Are you sure you want to release totalHoldersCount employees from the position position?": "Möchten Sie {totalHoldersCountEmployees} wirklich von der Position {position} freigeben?",
    "Are you sure you want to release totalHoldersCount employees from the following positions?": "Möchten Sie {totalHoldersCountEmployees} wirklich von den folgenden Positionen freigeben?",
    "Reopen position multi": "Position(en) wiedereröffnen",
    "Are you sure you want to close the following position?": "Möchten Sie die folgende {__position__} wirklich schließen?",
    "The entity is closed": "Die {entity} ist geschlossen.",
    "Entities are closed": "{__entities__} sind geschlossen.",
    "The entity is reopened": "Die {entity} ist wiedereröffnet.",
    "Entities are reopened": "{__entities__} sind wiedereröffnet.",
    "Entity has been reopened": "{entity} wurde wiedereröffnet.",
    "Entity has been updated": "{entity} wurde aktualisiert.",
    "eymappingerror": "Keine Zuordnung für das EY-Organigramm festgelegt. Konfigurieren Sie die Zuordnung manuell, um das Laden der Organigrammdaten abzuschließen.",
    "Confirm remove assignment": "Möchten Sie diesen Mitarbeiter wirklich von dieser Position entfernen?",
    "Confirm reassign employee": "Möchten Sie diesen Mitarbeiter wirklich neu zuweisen?",
    "Employee reassignment": "Dieser Mitarbeiter ist derzeit {title}: {id} zugewiesen. Er wird verschoben, wenn Sie Ihre Änderungen speichern.",
    "Employee unassignment": "Dieser Mitarbeiter wird von {title}: {id} entfernt, wenn Sie Ihre Änderungen speichern",
    "autogenerated": "automatisch generiert",
    "How many position copies": "Wie viele Kopien von {title}: {id} möchten Sie erstellen?",
    "formulasLimit": "Sie haben das Limit für das Hinzufügen benutzerdefinierter Formeln erreicht. Bitte kontaktieren Sie den Support unter support@theorgchart.com für Hilfe",
    "overbudget": "über dem Budget",
    "underbudget": "unter dem Budget",
    "Enable cost band info": "Um zu sehen, wie sich die Zuweisung von Mitarbeitern auf das Positionsbudget auswirkt, aktivieren Sie die Einstellung für Kostenbanddaten in Organigrammeinstellungen: Zuordnung.",
    "Unable to create positions": "Position(en) konnten nicht erstellt werden. Bitte versuchen Sie es erneut.",
    "Clone position success": "Die {entity} wurde geklont.",
    "How many new position copies": "Wie viele Positionskopien möchten Sie erstellen?",
    "Create position success": "Die {entity}-Position(en) wurden erstellt.",
    "Position selected": "Position ausgewählt: {title}: {id}",
    "There are number assignment issues": "Es gibt {count} {text} mit den Mitarbeitern, die Sie dieser Position zuweisen.",
    "assignment state issues": "Zuweisungsstatus-Problem(e)",
    "is currently status": "ist derzeit {status}",
    "is currently assigned to position": "ist derzeit {title}: {id} zugewiesen.",
    "is currently assigned to position id": "ist derzeit {id} zugewiesen.",
    "assigned and out of scope to": "zugewiesen und außerhalb des Umfangs zu {id}.",
    "assigned and out of scope to position": "zugewiesen und außerhalb des Umfangs zu {title}: {id}.",
    "Are you sure you want to assign them to position": "Möchten Sie sie wirklich {title}: {id} zuweisen?",
    "has an unknown assignment status": "hat einen unbekannten Zuweisungsstatus.",
    "conditional rls message": "Upgraden Sie, um bedingte Sicherheit auf Zeilenebene hinzuzufügen und Benutzer daran zu hindern, nur bestimmte Felder für bestimmte Datensätze zu sehen.",
    "conditional rls template": "Upgraden Sie, um {conditional row level}-Sicherheit hinzuzufügen und Benutzer daran zu hindern, nur bestimmte Felder für bestimmte Datensätze zu sehen.",
    "grouping message": "Upgraden Sie, um die Gruppierung zu verwenden, um Mitarbeiter nach Standort, Abteilung oder Titel für kompaktere und präzisere Visualisierungen zu gruppieren.",
    "grouping template": "Upgraden Sie, um die Gruppierung zu verwenden, um Mitarbeiter nach Standort, Abteilung oder Titel für {compact and concise} Visualisierungen zu gruppieren.",
    "Delete plan message": "Durch das Löschen dieses Plans wird er dauerhaft entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
    "custom chart trash": "Benutzerdefiniertes Organigramm in den Papierkorb verschieben",
    "custom chart trash message": "Durch das Verschieben des benutzerdefinierten Organigramms in den Papierkorb wird es aus diesem Ordner entfernt. Sie können benutzerdefinierte Organigramme aus dem Papierkorb wiederherstellen, indem Sie sie in einen anderen Ordner ziehen.",
    "custom chart delete": "Benutzerdefiniertes Organigramm löschen",
    "custom chart delete message": "Durch das Löschen dieses benutzerdefinierten Organigramms wird es dauerhaft aus Ihrem Konto entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
    "Cost band help": "Verwenden Sie Kostenbänder für Budgetierung, Gehaltsvergleich und Abweichungsanalysen. Wenn nicht alle Felder zugeordnet sind, kann das System die fehlenden Werte mithilfe vordefinierter Formeln generieren. Weitere Informationen finden Sie in unserem {Help Center}",
    "Position budget help": "Die Positionsbudgetberechnung verwendet dieses Feld, wenn es zugeordnet ist, oder berechnet es aus den Kostenbanddaten, wenn es nicht zugeordnet ist.",
    "Plan no longer exists (long)": "Der aktuell geöffnete Plan wurde von einem anderen Benutzer gelöscht. Bitte wählen Sie einen bestehenden Plan oder erstellen Sie einen neuen, um mit der Planung fortzufahren.",
    "bls upgrade message": "Upgraden Sie, um Sicherheit auf Zweigebene hinzuzufügen, um Benutzer darauf zu beschränken, nur bestimmte Teile des Organigramms zu sehen, wie z. B. ihre Abteilung.",
    "bls upgrade template": "Upgraden Sie, um {branch level}-Sicherheit hinzuzufügen, um Benutzer darauf zu beschränken, nur bestimmte Teile des Organigramms zu sehen, wie z. B. ihre Abteilung.",
    "plan approvals upgrade message": "Ein Plan-Genehmigungssystem, das einen kontrollierten Überprüfungs- und Genehmigungsprozess mit mehreren Genehmigern, Statusverfolgung und E-Mail-Benachrichtigungen ermöglicht.",
    "plan approvals upgrade template": "Ein {plan approval system}, das einen kontrollierten Überprüfungs- und Genehmigungsprozess mit mehreren Genehmigern, Statusverfolgung und E-Mail-Benachrichtigungen ermöglicht.",
    "ag upgrade message": "Upgraden Sie, um zusätzliche Zugriffsgruppen hinzuzufügen, für eine granulare Kontrolle über zukünftige Berechtigungen und Datensicherheit.",
    "ag upgrade template": "Upgraden Sie, um zusätzliche Zugriffsgruppen hinzuzufügen, für {granular control} über zukünftige Berechtigungen und Datensicherheit.",
    "changes message": "Upgraden Sie, um die Daten-, Formatierungs- und Paginierungsänderungen zu verfolgen, die Sie an Ihrem benutzerdefinierten Organigramm vornehmen. Überprüfen Sie, wer jede Änderung vorgenommen hat, und setzen Sie frühere Änderungen einfach zurück.",
    "functional chart message": "Upgraden Sie, um ein funktionales Organigramm zu erstellen, um Ihre Organisation nach Funktion, d. h. Abteilung, zu visualisieren und Ihre funktionale Hierarchie über Ihre Standard-Organisationsstruktur zu legen.",
    "formulas message": "Upgraden Sie, um weitere Formeln hinzuzufügen, um Metriken für benutzerdefinierte Personalzahlen, Kostenrollups und mehr zu berechnen.",
    "formulas template": "Upgraden Sie, um weitere Formeln hinzuzufügen, um {calculate metrics} für benutzerdefinierte Personalzahlen, Kostenrollups und mehr zu berechnen.",
    "ar upgrade message": "Upgraden Sie, um Mitarbeiter zu visualisieren, die an mehr als einen Vorgesetzten berichten, für eine genauere Darstellung geteilter Rollen und Verantwortlichkeiten.",
    "ar upgrade template": "Upgraden Sie, um Mitarbeiter zu visualisieren, die an mehr als einen Vorgesetzten berichten, für eine {accurate depiction} geteilter Rollen und Verantwortlichkeiten.",
    "auto assign upgrade message": "Upgraden Sie, um OrgChart so zu konfigurieren, dass Zugriffsgruppen automatisch basierend auf Ihren Mitarbeiterdaten an Benutzer zugewiesen werden.",
    "auto assign upgrade template": "Upgraden Sie, um OrgChart so zu konfigurieren, dass Zugriffsgruppen {automatically assign} basierend auf Ihren Mitarbeiterdaten an Benutzer zugewiesen werden.",
    "pit archive message": "Stellen Sie sicher, dass Organigramme mit automatischen Archivierungsfunktionen sicher erfasst und gespeichert werden.",
    "pit archive template": "Stellen Sie sicher, dass Organigramme {securely captured} und mit automatischen Archivierungsfunktionen gespeichert werden.",
    "pit org message": "Überprüfen Sie vergangene Organisationsstrukturen, um Muster bei Einstellungen, Fluktuation und Veränderungen zu identifizieren - für fundiertere Entscheidungen.",
    "pit org template": "Überprüfen Sie vergangene Organisationsstrukturen, um {identify patterns} bei Einstellungen, Fluktuation und Veränderungen zu erkennen - für fundiertere Entscheidungen.",
    "pit audit message": "Teilen Sie historische Organigramme einfach für Audits, Compliance und Präsentationen.",
    "pit audit template": "Teilen Sie {share historical} Organigramme einfach für Audits, Compliance und Präsentationen.",
    "addSourcesLimit": "Sie haben das Limit für das Hinzufügen zusätzlicher Datenquellen erreicht. Bitte kontaktieren Sie den Support unter support@theorgchart.com für Hilfe",
    "append message": "Upgraden Sie, um automatisch Daten aus zusätzlichen HR-Systemen oder Tabellenkalkulationsdateien hinzuzufügen, um mehr Informationen wie offene Stellen oder Auftragnehmer zu visualisieren.",
    "append template": "Upgraden Sie, um automatisch Daten aus {additional HR systems} oder Tabellenkalkulationsdateien hinzuzufügen, um mehr Informationen wie {vacancies or contractors} zu visualisieren.",
    "merge message": "Upgraden Sie, um automatisch Daten aus zusätzlichen HR-Systemen oder Tabellenkalkulationsdateien hinzuzufügen, um Ihre Datenvisualisierung mit Informationen wie sekundären Vorgesetzten anzureichern.",
    "merge template": "Upgraden Sie, um automatisch Daten aus {additional HR systems} oder Tabellenkalkulationsdateien hinzuzufügen, um Ihre Datenvisualisierung mit Informationen wie {secondary managers} anzureichern.",
    "planning upgrade message": "Upgraden Sie, um mit genauen Positionsdaten, kollaborativen Tools und Einblicken in Gehalt, Kontrollspanne und Leistung sicher zu planen und strukturelle Entscheidungen zu treffen.",
    "plan position data message": "Planen Sie strategisch für die Zukunft mit genauen Positionsdaten. Analysieren Sie Positionen und offene Stellen nach Gehalt, Kontrollspanne, Leistung und mehr, um den besten Einblick in Ihre Struktur zu erhalten.",
    "plan position data template": "Planen Sie strategisch für die Zukunft mit genauen Positionsdaten. Analysieren Sie {positions and vacancies} nach Gehalt, Kontrollspanne, Leistung und mehr, um den besten {insight} in Ihre Struktur zu erhalten.",
    "track kpis message": "Stellen Sie sicher, dass Ihre Pläne auf Erfolg ausgerichtet sind. Analysieren Sie die Auswirkungen Ihrer vorgeschlagenen Pläne, indem Sie Zielwerte für Budget, Personalzahlen und mehr festlegen und verfolgen.",
    "track kpis template": "Stellen Sie sicher, dass Ihre Pläne auf Erfolg ausgerichtet sind. Analysieren Sie die {impact} Ihrer vorgeschlagenen Pläne, indem Sie {setting and tracking} Zielwerte für Budget, Personalzahlen und mehr festlegen.",
    "collaborate message": "Arbeiten Sie mit Kollegen zusammen, um Positionen per Drag-and-Drop zu verschieben, Mitarbeitergruppen zu bewegen und sicherzustellen, dass Ihr Team über die Auswirkungen vorgeschlagener Änderungen informiert ist.",
    "collaborate template": "Arbeiten Sie mit Kollegen zusammen, um Positionen per {drag and drop} zu verschieben, {move groups} von Mitarbeitern zu bewegen und sicherzustellen, dass Ihr {team is aware} über die Auswirkungen vorgeschlagener Änderungen informiert ist.",
    "System calculation requires both Staffing target and Cost band maximum to be mapped": "Die Systemberechnung erfordert, dass sowohl das Besetzungsziel als auch das Kostenband-Maximum zugeordnet sind.",
    "System generate Position Budget": "Dieses Feld wird berechnet als: Besetzungsziel × Kostenband-Maximum",
    "Cost band max staffing target position budget": "{costBandMax} × {desiredHolders} = Budgetiertes Positionsgehalt",
    "This is driven by the position budget field": "Dies wird durch das Feld {field} gesteuert.",
    "Record out of scope info": "Um die Details dieses Mitarbeiters zu bearbeiten, müssen Sie ihn einer Position in diesem Plan zuweisen.",
    "rlsallowedtoggleinfo": "Aktivierte erlaubte Felder werden angezeigt",
    "rlsrestrictedtoggleinfo": "Aktivierte eingeschränkte Felder werden ausgeblendet",
    "rlsconditionaltoggleinfo": "Aktivierte Felder werden basierend auf bedingten Regeln angezeigt",
    "rlsuserrecordnotfound": "Ihr Sicherheitsprofil erfordert Ihren Datensatz in diesem Organigramm, aber Ihr Datensatz konnte nicht gefunden werden. Bitte wenden Sie sich an Ihren Systemadministrator.",
    "Position Management enables you to visualize your employees and positions separately to gain better insight in your open roles and key position details": "Positionsverwaltung ermöglicht es Ihnen, Ihre Mitarbeiter und Positionen getrennt zu visualisieren, um bessere Einblicke in offene Rollen und wichtige Positionsdetails zu erhalten.",
    "Multiple parent positions rollup alert": "Einige Positionen, die Sie löschen, haben untergeordnete Positionen, die ihnen unterstellt sind. Was möchten Sie mit diesen untergeordneten Positionen tun?",
    "Invalid target value": "Der Zielwert muss eine Zahl sein.",
    "noPositionSelectedTooltipInfo": "Wählen Sie eine Position aus, um diese Aktion zu aktivieren.",
    "onlyActivePositionsSelectedTooltipInfo": "Die ausgewählte(n) Position(en) sind aktiv.",
    "onlyClosedPositionsSelectedTooltipInfo": "Die ausgewählte(n) Position(en) sind geschlossen und müssen wiedereröffnet werden, um Änderungen vorzunehmen.",
    "multiplePositionsSelectedTooltipInfo": "Wählen Sie jeweils nur eine Position zum Klonen aus.",
    "closedOrUnassignedPositionsSelectedTooltipInfo": "Die ausgewählte(n) Position(en) haben keine Zuweisungen.",
    "Revert all position changes info": "Sie können alle mit dieser Position verbundenen Änderungen rückgängig machen, aber Mitarbeiter, die zum Zeitpunkt der Schließung zugewiesen waren, {positionRevertWarning}. Um Mitarbeiter zu ihrer Ursprungsposition zurückzusetzen, gehen Sie bitte zu ihrem Mitarbeiterdetail-Fenster.",
    "Revert all position confirm": "Möchten Sie wirklich alle an dieser Position vorgenommenen Änderungen rückgängig machen?",
    "positionRevertWarning": "werden nicht automatisch neu zugewiesen",
    "This action cannot be undone": "Diese Aktion kann nicht rückgängig gemacht werden.",
    "daterange": "Datumsbereich",
    "Retain vacant supervisory positions": "Vakante Positionen beibehalten",
    "Retain vacant supervisory positions info": "OrgChart generiert vakante Positionen in Ihrem Organigramm, wenn Mitarbeiter aus Ihrer Datenquelle entfernt werden. Dies bewahrt Ihre Organisationsstruktur und ermöglicht es Ihnen, diese kritischen Rollen neu zu besetzen oder zu planen. Die Anhängetabelle wird verwendet, um diese systemgenerierten vakanten Positionen zu verwalten.",
    "Retain positions": "Ein oder mehrere Mitarbeiter wurden {removedFromDataSet}. Um ihre Rollen beizubehalten, hat OrgChart {createdPositions} Ihre Organisationsstruktur. Verwenden Sie die {appendTable}, um diese Positionen nach Bedarf anzupassen.",
    "Retain position info": "Behalten Sie Positionen in Ihrem Organigramm bei, wenn die zugewiesenen Mitarbeiter aus Ihrer Datenquelle entfernt werden. Dies bewahrt Ihre Organisationsstruktur und ermöglicht es Ihnen, diese kritischen Rollen neu zu besetzen oder zu planen.",
    "Auto purge vacant positions": "Automatische Bereinigung vakanter Positionen",
    "Auto purge vacant positions info": "Entfernen Sie vakante Positionen nach einem festgelegten Zeitraum automatisch, um Ihr Organigramm aktuell zu halten.",
    "Purge positions after": "Positionen bereinigen nach:",
    "Employee profile desc": "Die Mitarbeiter-Profilkarte zeigt Mitarbeiterdaten an. Wählen Sie unten aus, welche Mitarbeiterdaten Sie in der Mitarbeiter-Profilkarte anzeigen möchten.",
    "Position profile desc": "Die Positions-Profilkarte zeigt Positionsdaten an. Wählen Sie unten aus, welche Daten Sie in der Positions-Profilkarte anzeigen möchten.",
    "Additional {type} information desc": "Zusätzliche {type}-Informationen werden unter den markierten Feldern aufgeführt.",
    "Position information unavailable": "Positionsinformationen nicht verfügbar. Bitte wechseln Sie zu einem Positions-Organigramm, um Positionsdatensätze anzuzeigen und zu verwalten.",
    "Retain only vacant with subs": "Nur vakante Positionen mit Untergebenen beibehalten",
    "Clear vacant positions after info": "Löschen Sie die systemgenerierten vakanten Positionen nach einem definierten Zeitraum, die nicht mehr benötigt werden, um Ihre Organisationsstruktur zu bewahren. Wenn Sie diese vakanten Positionen immer in Ihrem Organigramm behalten möchten, deaktivieren Sie diesen Schalter.",
    "__blocked__": "(ausgeblendet)",
    "profile preview": "Profilvorschau",
    "No assignees yet": "Noch keine Zugewiesenen.",
    "blockedmetrictip": "Diese Metrik ist nicht verfügbar, da Sie nicht berechtigt sind, alle für diese Berechnung verwendeten Werte zu sehen. Um diese Zahl zu sehen, geben Sie einen Arbeitswert für die als „ausgeblendet“ markierten Felder ein, die für diese Berechnung verwendet werden.",
    "compensationaccesstip": "Sie haben keinen Zugriff auf die tatsächlichen Vergütungsdaten dieses Mitarbeiters.",
    "recordeditorcompaccesstip": "Sie haben keinen Zugriff auf den tatsächlichen Wert einiger Felder. Sie können einen Platzhalterwert für die ausgeblendeten Werte zu Planungszwecken eingeben.",
    "No holders in preview": "Alle Positionen sind vakant. Keine Zugewiesenen für die Vorschau.",
    "Force queue refresh question": "Aktualisierung der Warteschlange erzwingen?",
    "Refresh Queue Info": "Möchten Sie dieses Organigramm sofort in die Aktualisierungswarteschlange erzwingen? Das Organigramm wird im Hintergrund aktualisiert.",
    "photoRefreshChoice": "Möchten Sie das Neuladen aller Fotos erzwingen, während dieser Prozess stattfindet?",
    "Chart added to the refresh queue": "Organigramm erfolgreich zur Aktualisierungswarteschlange hinzugefügt",
    "Conflict record detected": "Konflikt erkannt",
    "Maximum approvers allowed. Please remove some approvers.": "Maximal {approverLimit} Genehmiger erlaubt. Bitte entfernen Sie einige Genehmiger.",
    "Plan submitted for approval successfully": "Plan erfolgreich zur Genehmigung eingereicht.",
    "Failed to submit plan request": "Plan-Anfrage konnte nicht eingereicht werden.",
    "Plan request withdrawn successfully": "Plan-Anfrage erfolgreich zurückgezogen.",
    "Failed to withdraw plan request": "Plan-Anfrage konnte nicht zurückgezogen werden.",
    "Plan approved successfully": "Plan erfolgreich genehmigt.",
    "Failed to approve plan": "Plan konnte nicht genehmigt werden.",
    "Plan rejected": "Plan abgelehnt.",
    "Failed to reject plan": "Plan konnte nicht abgelehnt werden.",
    "Plan already submitted": "Plan bereits eingereicht.",
    "No active plan request to withdraw": "Keine aktive Plan-Anfrage zum Zurückziehen.",
    "Plan submission withdrawn successfully": "Plan-Einreichung erfolgreich zurückgezogen.",
    "Failed to submit plan submission": "Plan-Einreichung konnte nicht eingereicht werden.",
    "Failed to withdraw plan submission": "Plan-Einreichung konnte nicht zurückgezogen werden.",
    "No active plan submission to withdraw": "Keine aktive Plan-Einreichung zum Zurückziehen.",
    "Approvers label": "Genehmiger",
    "Some approvers need access": "Einige Genehmiger können nicht auf den Plan zugreifen",
    "Some approvers need access info": "{reviewersWithoutPlanAccessCount} von {totalReviewerCount} Genehmigern, die Sie hinzufügen, haben keinen Zugriff auf den Plan. Gewähren Sie ihnen jetzt Lesezugriff, oder Sie können sie später hinzufügen, bevor sie mit ihrer Überprüfung beginnen.",
    "Select approvers for this plan": "Genehmiger für diesen Plan auswählen",
    "Maximum approvers": "Maximal {approverLimit} Genehmiger",
    "Refresh Formula Info": "Möchten Sie die Neuberechnung aller Formeln für dieses Organigramm erzwingen? Dadurch werden die berechneten Werte aktualisiert, ohne das gesamte Organigramm zu aktualisieren.",
    "Force calculate formulas question": "Formelberechnung erzwingen?",
    "This plan is awaiting approval": "Dieser Plan wartet auf Genehmigung von {reviewerNames}.",
    "This plan is locked and cannot be edited.": "Dieser Plan ist {status} und kann nicht bearbeitet werden.",
    "Plan owners can unlock the plan in the Plan Explorer by hovering over the plan": "Planbesitzer können den Plan im Plan-Explorer entsperren, indem sie über den Plan fahren und dann auf das Symbol ⋮ klicken.",
    "You have already approved this plan": "Sie haben diesen Plan bereits genehmigt.",
    "You have already rejected this plan": "Sie haben diesen Plan bereits abgelehnt.",
    "LocalizationSettingsDesc": "Ermöglichen Sie Ihren Benutzern, ihre Organigrammdaten in ihrer bevorzugten Sprache anzuzeigen. Fügen Sie die gewünschten Feldzuordnungen hinzu, die die angezeigten Übersetzungen steuern.",
    "NoLocalizationData": "Noch keine Sprachkonfigurationen hinzugefügt.",
    "Masters": "Hintergründe",
    "Next (short)": "Weiter",
    "Prev (short)": "Zurück",
    "Showing results": "Zeige {firstResult} - {lastResult} von {totalCount} Ergebnissen",
    "Search specific folder": "In {folder} suchen",
    "Search Charts": "Organigramme suchen",
    "Local (time)": "lokal",
    "Insert field": "Feld einfügen",
    "source(s)": "Quelle(n)",
    "change by author": "{changeDatetime} von {author}",
    "Closed positions remain in your chart and table view, but can be filtered out": "Geschlossene Positionen bleiben in Ihrem Organigramm und der Tabellenansicht, können aber herausgefiltert werden.",
    "Cannot move record": "Datensatz kann nicht verschoben werden",
    "You cannot move employees to closed positions.": "Sie können Mitarbeiter nicht in geschlossene Positionen verschieben.",
    "You cannot move this record under a closed position.": "Sie können diesen Datensatz nicht unter eine geschlossene Position verschieben.",
    "supportContactGeneric": "Ihr Support- oder Serviceteam",
    "genericAccessGroupLimit": "Sie haben das Limit für das Hinzufügen von Zugriffsgruppen erreicht. Bitte wenden Sie sich an Ihr Support- oder Serviceteam.",
    "genericFormulasLimit": "Sie haben das Limit für das Hinzufügen benutzerdefinierter Formeln erreicht. Bitte wenden Sie sich an Ihr Support- oder Serviceteam.",
    "genericAddSourcesLimit": "Sie haben das Limit für das Hinzufügen zusätzlicher Datenquellen erreicht. Bitte wenden Sie sich an Ihr Support- oder Serviceteam.",
    "genericBoxLimit": "Der Exportumfang überschreitet das Box-Limit Ihres Kontos. Bitte reduzieren Sie den Umfang oder wenden Sie sich an Ihr Support- oder Serviceteam, um Ihr Limit zu erhöhen.",
    "genericUnknownError": "System nicht konfiguriert. Bitte wenden Sie sich an Ihr Support- oder Serviceteam.",
    "genericSharePointErr": "SharePoint-Konfiguration fehlgeschlagen. Bitte wenden Sie sich an Ihr Support- oder Serviceteam.",
    "genericSupportMsg": "Falls das Problem weiterhin besteht, wenden Sie sich bitte an Ihr Support- oder Serviceteam.",
    "genericSalesMsg": "Für weitere Informationen wenden Sie sich bitte an Ihr Support- oder Serviceteam.",
    "genericSupportDeskHelp": "Falls das Problem weiterhin besteht, können Sie sich an Ihr Support- oder Serviceteam wenden.",
    "Immediate days": "Sofortige Tage",
    "Preview not available": "Vorschau nicht verfügbar. \\n Aktualisieren Sie Ihr Organigramm und versuchen Sie es erneut.",
    "Withdraw plan info message": "Das Zurückziehen dieses Plans entfernt alle Genehmigungen und setzt den Planstatus auf Entwurf zurück. Sie können dann Änderungen vornehmen.",
    "blsNavigationRestricted": "Dieser Datensatz liegt außerhalb Ihres Sicherheitsbereichs auf Zweigstellenebene. Sie können nur zu Datensätzen innerhalb Ihres Zweigs navigieren.",
    "Import Filters": "Importfilter",
    "Allowed legacy filters": "Erlaubte gespeicherte Filter (Legacy)",
    "Allowed legacy highlights": "Erlaubte gespeicherte Hervorhebungen (Legacy)",
    "Now available: IF/IH": "Jetzt verfügbar: Interaktive Filter und Hervorhebungen für alle Diagrammtypen",
    "Now available: IF/IH detail": "Verwenden Sie das rechte Seitenpanel des Diagramms, um interaktive Filter und Hervorhebungen zu erstellen, zu verwalten und freizugeben. Ihre vorhandenen gespeicherten Filter bleiben zugänglich. Erfahren Sie mehr über die Verwendung von {link} in unserer Hilfedokumentation.",
    "Interactive filters and highlights": "interaktive Filter und Hervorhebungen",
    "Choose a base chart:": "Basisdiagramm auswählen:",
    "A to Z": "A bis Z",
    "Applied to views": "Auf Ansichten angewendet",
    "Applied to:": "Angewendet auf:",
    "Apply to new view": "Auf neue Ansicht anwenden",
    "Back to box styles": "Zurück zu Box-Stilen",
    "Box style library": "Box-Stil-Bibliothek",
    "Box style name": "Box-Stil-Name",
    "Box style type": "Box-Stil-Typ",
    "Copy box style": "Box-Stil kopieren",
    "Revert box style": "Box-Stil zurücksetzen",
    "Create and manage box styles for this chart. Apply box styles with a View.": "Erstellen und verwalten Sie Box-Stile für dieses Diagramm. Wenden Sie Box-Stile mit einer Ansicht an.",
    "Create box style": "Box-Stil erstellen",
    "Delete box style": "Box-Stil löschen",
    "Delete box style confirmation": "Dadurch wird der Box-Stil dauerhaft aus Ihrer Bibliothek gelöscht. Alle Ansichten, die diesen Stil aktuell verwenden, werden auf den Systemstandard zurückgesetzt, und Sie müssen den Box-Stil für diese Ansichtsregeln erneut anwenden.",
    "Edit box style": "Box-Stil bearbeiten",
    "Employee box styles first": "Mitarbeiter-Box-Stile zuerst",
    "Go to a view:": "Zu einer Ansicht wechseln:",
    "Group box styles first": "Gruppen-Box-Stile zuerst",
    "Least used": "Am seltensten verwendet",
    "Looking to create a strategic future plan?": "Möchten Sie einen strategischen Zukunftsplan erstellen?",
    "Merge by field": "Nach Feld zusammenführen",
    "Merge duplicates": "Duplikate zusammenführen",
    "Most used": "Am häufigsten verwendet",
    "No view rules reference this box style.": "Keine Ansichtsregeln verweisen auf diesen Box-Stil.",
    "Not applied to views": "Nicht auf Ansichten angewendet",
    "Position box styles first": "Stellen-Box-Stile zuerst",
    "Reset filters": "Filter zurücksetzen",
    "Search box styles": "Box-Stile suchen",
    "Shared box styles first": "Freigegebene Box-Stile zuerst",
    "System box styles first": "System-Box-Stile zuerst",
    "The box style could not be copied": "Der Box-Stil konnte nicht kopiert werden. Bitte versuchen Sie es erneut.",
    "The box style could not be deleted": "Der Box-Stil konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.",
    "The box style is applied to the following views. Click on the view to preview.": "Der Box-Stil wird auf die folgenden Ansichten angewendet. Klicken Sie auf die Ansicht, um eine Vorschau anzuzeigen.",
    "Upgrade to add views": "Upgrade für weitere Ansichten",
    "Z to A": "Z bis A",
    "authorBlockedFieldTip": "Der Benutzer, der diese Änderung vorgenommen hat, hatte keinen Zugriff auf den tatsächlichen Wert von {fieldName}.",
    "box style changes saved": "Änderungen am Box-Stil {box style name} gespeichert.",
    "box style created": "Box-Stil {box style name} erstellt.",
    "edited": "Bearbeitet",
    "box layout editor pending changes banner":
      "Änderungen wie Umbenennen, Kopieren und Löschen im Box-Layout-Editor bleiben ausstehend, bis Sie sie speichern oder verwerfen.",
    "1 box style with unsaved changes": "1 Box-Stil mit nicht gespeicherten Änderungen.",
    "{n} box styles with unsaved changes": "{n} Box-Stile mit nicht gespeicherten Änderungen.",
    "1 box style deleted": "1 Box-Stil gelöscht.",
    "{n} box styles deleted": "{n} Box-Stile gelöscht.",
    "{n} box styles updated": "{n} Box-Stile aktualisiert.",
    "{n} box styles saved": "{n} Box-Stile gespeichert.",
    "Keep editing": "Bearbeitung fortsetzen",
    "box style save failed": "Box-Stile konnten nicht gespeichert werden. Bitte erneut versuchen.",
    "box style deleted": "Box-Stil {box style name} gelöscht.",
    "copied to box style library": "{box style name} wurde in die Box-Stil-Bibliothek kopiert.",
    "interactive filters": "interaktive Filter",
    "interactive highlights": "interaktive Hervorhebungen",
    "views unavailable to access": "{viewCount} Ansichten nicht verfügbar",
    "Box style name must be unique": "Der Box-Stil-Name muss eindeutig sein",
    "Box style name cannot be empty": "Der Box-Stil-Name kann nicht leer sein",
    "Employee is unassigned from entity": "{employee} wurde aus {entity} entfernt.",
    "Employee is released from entity": "{employee} wurde aus {entity} freigegeben.",
    "planning upgrade template": "{Looking to create a strategic future plan?} Fragen Sie uns nach einem Upgrade auf unser {workforce planning module}!",
    "view library upgrade message": "Führen Sie ein Upgrade durch, um eine unbegrenzte Anzahl benutzerdefinierter Organigramm-Ansichten zu erstellen und die Einblicke in Ihre Organisation zu vertiefen. Fügen Sie Felder wie Betriebszugehörigkeit, Gehalt und Leistung zu Ihren Kästchen hinzu, erweitern Sie Ihre Organigramme mit Markenfarben und Farbcodierung von Feldern, und heben Sie sogar freie Stellen hervor.",
    "view library upgrade template": "Führen Sie ein Upgrade durch, um eine {unlimited number of custom org chart views} zu erstellen und die Einblicke in Ihre Organisation zu vertiefen. Fügen Sie Felder wie Betriebszugehörigkeit, Gehalt und Leistung zu Ihren Kästchen hinzu, erweitern Sie Ihre Organigramme mit Markenfarben und Farbcodierung von Feldern, und heben Sie sogar freie Stellen hervor.",
    "unlimited number of custom org chart views": "unbegrenzte Anzahl benutzerdefinierter Organigramm-Ansichten",
    "filters upgrade message": "Führen Sie ein Upgrade durch, um interaktive Filter für Ihr Organigramm zu verwenden und die Übersichtlichkeit zu verbessern. Mit Filtern können Sie auswählen, welche Datensätze in Ihrem Organigramm angezeigt werden, z. B. bestimmte Abteilungen, Standorte und mehr.",
    "filters upgrade template": "Führen Sie ein Upgrade durch, um {interactive filters} für Ihr Organigramm zu verwenden und die Übersichtlichkeit zu verbessern. Mit Filtern können Sie auswählen, welche Datensätze in Ihrem Organigramm angezeigt werden, z. B. bestimmte Abteilungen, Standorte und mehr.",
    "highlights upgrade message": "Führen Sie ein Upgrade durch, um interaktive Hervorhebungen in Ihrem Organigramm zu verwenden und Mitarbeiter in bestimmten Abteilungen, Standorten und mehr sofort hervorzuheben.",
    "highlights upgrade template": "Führen Sie ein Upgrade durch, um {interactive highlights} in Ihrem Organigramm zu verwenden und Mitarbeiter in bestimmten Abteilungen, Standorten und mehr sofort hervorzuheben.",
    "Upgrade to export": "Upgrade zum Exportieren",
    "export upgrade message": "Führen Sie ein Upgrade durch, um Ihr Organigramm in die Formate PDF, PPT, PNG, SVG, JPEG und XLSX zu exportieren. Erstellen Sie sofort präsentationsfertige Organigramme mit Kontrolle über Seitengröße, Ausrichtung, Diagrammbereich und mehr.",
    "export upgrade template": "Führen Sie ein Upgrade durch, um Ihr Organigramm in {PDF, PPT, PNG, SVG, JPEG, and XLSX formats} zu exportieren. Erstellen Sie sofort präsentationsfertige Organigramme mit Kontrolle über Seitengröße, Ausrichtung, Diagrammbereich und mehr.",
    "PDF, PPT, PNG, SVG, JPEG, and XLSX formats": "PDF, PPT, PNG, SVG, JPEG und XLSX-Formate",
    "Group \"Full Access\"": "Gruppe \"Full Access\"",
    "The \"{fieldName}\" field is currently excluded from the profile. If you map this field, it will be included in the profile.": "Das Feld \u201e{fieldName}\u201c ist derzeit vom Profil ausgeschlossen. Wenn Sie dieses Feld zuordnen, wird es in das Profil aufgenommen.",
    "This box layout type is applied to position boxes.": "Dieser Layout-Typ wird auf Positionsfelder angewendet.",
    "Create and manage box styles for your charts. Apply box styles with a View.": "Erstellen und verwalten Sie Feldstile für Ihre Organigramme. Wenden Sie Feldstile mit einer Ansicht an.",
    "Delete box style?": "Box-Stil löschen?",
    "Back to groups": "Zurück zur Gruppierung",
    "Delete group": "Gruppe löschen",
    "Delete group?": "Gruppe löschen?",
    "Delete group confirm": "Das Löschen dieser Gruppe entfernt sie aus Ihrer Gruppierungsliste.",
    "autoExportUpgradeMessage": "Führen Sie ein Upgrade durch, um OrgChart so zu konfigurieren, dass Basisorganigramme automatisch exportiert werden. Lassen Sie OrgChart Basisorganigramme als PDF, PPT oder Excel direkt in die Postfächer der Stakeholder versenden.",
    "autoExportUpgradeTemplate": "Führen Sie ein Upgrade durch, um OrgChart so zu konfigurieren, Basisorganigramme {automatically export} zu lassen. Lassen Sie OrgChart Basisorganigramme als PDF, PPT oder Excel direkt in die Postfächer der Stakeholder versenden.",
    "automatically export": "automatisch exportiert",
    "SharePoint": "SharePoint",
    "Test Connection": "Verbindung testen",
    "sharepoint_test_in_progress": "Test läuft…",
    "sharepoint_test_ok": "Verbindung erfolgreich",
    "sharepoint_test_auth_failed": "Authentifizierung fehlgeschlagen — Tenant ID, Client ID und Client Secret prüfen",
    "sharepoint_test_folder_failed": "Verbindung hergestellt, aber die Bibliothek „Freigegebene Dokumente“ ist nicht zugänglich",
    "sharepoint_test_unreachable": "SharePoint nicht erreichbar — Domain und Netzwerk prüfen",
    "sharepoint_test_unknown": "Verbindungstest fehlgeschlagen",
    "Audit log": "Administrator-Protokoll",
    "admin log upgrade message":
      "Bleiben Sie ganzjährig auditbereit. Das Administrator-Protokoll erfasst Änderungen an Benutzern, Berechtigungen und Zugriffen in einem Datensatz mit Zeitstempel, den Ihre Prüfer jederzeit einsehen können.",
    "admin log upgrade template":
      "Bleiben Sie ganzjährig {auditbereit}. Das Administrator-Protokoll erfasst Änderungen an Benutzern, Berechtigungen und Zugriffen in einem {Datensatz mit Zeitstempel}, den Ihre Prüfer jederzeit einsehen können.",
    "audit-ready": "auditbereit",
    "timestamped record": "Datensatz mit Zeitstempel",
    "auditLog.title": "Administrator-Protokoll",
    "auditLog.totalRecords": "Einträge insgesamt",
    "auditLog.error.loadFailed": "Administrator-Protokoll konnte nicht geladen werden.",
    "auditLog.error.exportFailed": "Export des Administrator-Protokolls fehlgeschlagen.",
    "auditLog.error.snapshotFailed": "Sicherheits-Snapshot konnte nicht erstellt werden.",
    "auditLog.filter.startDate": "Startdatum",
    "auditLog.filter.endDate": "Enddatum",
    "auditLog.filter.eventType": "Ereignistyp",
    "auditLog.filter.source": "Quelle",
    "auditLog.filter.outcome": "Ergebnis",
    "auditLog.filter.actorId": "Benutzer-ID oder E-Mail",
    "auditLog.filter.targetId": "Ziel-ID oder E-Mail",
    "auditLog.action.apply": "Anwenden",
    "auditLog.action.reset": "Zurücksetzen",
    "auditLog.action.exportCsv": "CSV exportieren",
    "auditLog.action.exportXlsx": "Excel-Bericht exportieren",
    "auditLog.action.generateSnapshot": "Snapshot erstellen",
    "auditLog.pagination.previous": "Zurück",
    "auditLog.pagination.next": "Weiter",
    "auditLog.pagination.page": "Seite",
    "auditLog.column.timestamp": "Zeitstempel (GMT)",
    "auditLog.column.eventType": "Ereignis",
    "auditLog.column.outcome": "Ergebnis",
    "auditLog.column.source": "Quelle",
    "auditLog.column.actor": "Akteur",
    "auditLog.column.target": "Ziel",
    "auditLog.column.diffKeys": "Geänderte Felder",
    "auditLog.column.message": "Meldung",
    "auditLog.event.userCreate": "Benutzer erstellt",
    "auditLog.event.userDelete": "Benutzer entfernt",
    "auditLog.event.userDeleteRequest": "Benutzerentfernung angefordert",
    "auditLog.event.userRoleChange": "Benutzerrolle geändert",
    "auditLog.event.userPrivChange": "Zugriffsgruppe oder Organigramm-Zugriff geändert",
    "auditLog.event.userRlsAssign": "RLS-Profil zugewiesen",
    "auditLog.event.securityGroupUpdate": "Konfiguration der Zugriffsgruppe geändert",
    "auditLog.event.securityRlsProfileUpdate": "Zeilenebenen-Sicherheitsprofil geändert",
    "auditLog.event.securityBlsProfileUpdate": "Verzweigungsebenen-Sicherheitsprofil geändert",
    "auditLog.event.securityImpersonationToggle": "Identitätsannahme-Einstellung geändert",
    "auditLog.event.securityDirectSigninToggle": "Einstellung für direkte Anmeldung geändert",
    "auditLog.event.securityAutoAssignmentChange": "Konfiguration der automatischen Zuweisung geändert",
    "auditLog.event.securitySsoConfigChange": "SSO-Konfiguration geändert",
    "auditLog.event.securityAuthorizationDenied": "Autorisierung verweigert",
    "auditLog.event.securityUiProfileUpdate": "UI-Profil geändert",
    "auditLog.event.authLoginImpersonation": "Anmeldung über Identitätsannahme",
    "auditLog.event.auditReportViewed": "Administrator-Protokoll angezeigt",
    "auditLog.event.auditReportExported": "Administrator-Protokoll exportiert",
    "auditLog.event.auditReportExportedXlsx": "Excel-Administrator-Bericht exportiert",
    "auditLog.event.auditSnapshotGenerated": "Sicherheits-Snapshot erstellt",
    "auditLog.outcome.success": "Erfolgreich",
    "auditLog.outcome.denied": "Abgelehnt",
    "auditLog.outcome.failed": "Fehlgeschlagen",
    "auditLog.source.manageUsersUi": "Benutzer verwalten",
    "auditLog.source.authorizationUi": "Autorisierung",
    "auditLog.source.rlsUi": "Zeilenebenen-Sicherheit",
    "auditLog.source.blsUi": "Verzweigungsebenen-Sicherheit",
    "auditLog.source.accessGroupsUi": "Zugriffsgruppen",
    "auditLog.source.uiProfilesUi": "UI-Profile",
    "auditLog.source.ssoConfigUi": "SSO-Konfiguration",
    "auditLog.source.auditLogUi": "Administrator-Protokoll",
    "auditLog.source.bulkImport": "Massen-Import",
    "auditLog.source.api": "API",
    "auditLog.source.system": "System",
    "auditLog.source.unknown": "Unbekannt",
    "Welcome to OrgChart!": "Willkommen bei OrgChart!",
    "In two quick steps, we'll customize your org chart with your logo and brand colors.": "In zwei schnellen Schritten personalisieren wir Ihr Organigramm mit Ihrem Logo und Ihren Markenfarben.",
    "Upload your logo": "1. Logo hochladen",
    "Auto-generates a branded background.": "Erstellt automatisch einen Markenhintergrund.",
    "Set brand colors": "2. Markenfarben festlegen",
    "Applied to all org chart system boxes.": "Auf alle System-Boxen des Organigramms angewendet.",
    "Skip setup": "Einrichtung überspringen",
    "Brand setup": "Marken-Einrichtung",
    "Step {current} of {total}": "Schritt {current} von {total}",
    "help document": "Hilfedokument",
    "Drag and drop your file here, or click to browse": "Datei hier ablegen oder zum Durchsuchen klicken",
    "file formats": "Format {formats} – max. {size} MB",
    "Choose colors for your org chart boxes. They will be applied to all default system boxes and views. You can skip this step and edit later in the Box Layout Editor.": "Wählen Sie Farben für Ihre Organigramm-Boxen. Sie werden auf alle Standard-System-Boxen und Ansichten angewendet. Sie können diesen Schritt überspringen und später im Box-Layout-Editor bearbeiten.",
    "Box fill color:": "Füllfarbe:",
    "Box border color:": "Rahmenfarbe:",
    "Preview employee box styles": "Vorschau der Mitarbeiter-Box-Stile",
    "Finish setup": "Einrichtung abschließen",
    "Go to chart": "Zum Organigramm wechseln",
    "You're all set!": "Alles bereit!",
    "Your brand is applied.": "Ihre Marke wurde angewendet.",
    "Failed to delete file. Please try again.": "Datei konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.",
    "Copy to clipboard": "In die Zwischenablage kopieren",
    "Paste from clipboard": "Aus der Zwischenablage einfügen",
    "Paste views and box styles from clipboard": "Ansichten und Boxstile aus der Zwischenablage einfügen",
    "Use the ctrl/cmd V shortcut key to paste your views and box styles from your clipboard.": "Verwenden Sie die Tastenkombination Strg/Cmd + V, um Ihre Ansichten und Boxstile aus der Zwischenablage einzufügen.",
    "Failed to import views. Please try again.": "Fehler beim Importieren der Ansichten. Bitte versuchen Sie es erneut.",
    "Paste from your clipboard.": "Aus Ihrer Zwischenablage einfügen.",
    "Import views": "Ansichten importieren",
    "Failed to paste views. Please copy views and box styles and try again.": "Fehler beim Einfügen der Ansichten. Bitte kopieren Sie die Ansichten und Boxstile und versuchen Sie es erneut.",
    "Views and box styles pasted from clipboard.": "Ansichten und Boxstile aus der Zwischenablage eingefügt.",
    "Export views and box styles": "Ansichten und Boxstile exportieren",
    "Views and box styles copied to your clipboard.": "Ansichten und Boxstile in Ihre Zwischenablage kopiert.",
    "Views and box styles imported successfully.": "Ansichten und Boxstile erfolgreich importiert.",
    "No filters created yet": "Noch keine Filter erstellt.",
    "Grouping tab description": "Gruppieren Sie Felder nach Kategorie, um das Organigramm übersichtlicher zu gestalten.",
    "No groups created yet": "Noch keine Gruppen erstellt",
    "No sort keys added yet": "Noch keine Sortierschlüssel hinzugefügt",
    "No disconnected records found": "Keine getrennten Datensätze gefunden.",
    "No changes have been made yet.": "Es wurden noch keine Änderungen vorgenommen.",
    "Staging info": "Staging speichert vorübergehend getrennte Datensätze. Ziehen Sie Datensätze aus Staging in das Organigramm, um Berichtsbeziehungen herzustellen. Ziehen Sie Datensätze in Staging, um sie zu trennen (Äste werden gemeinsam verschoben).",
    "exportFilenameInvalidChars": "Der Dateiname darf nicht enthalten: \\ / : * ? \" < > |",
    "Shared filter update error": "Aktualisierung fehlgeschlagen",
    "Shared filter delete error": "Löschen fehlgeschlagen",
    "Dismiss": "Schließen",
    "Got it": "Verstanden",
    "Let's go": "Los geht's",
    "Welcome to Your Charts, Powered by OrgChart!": "Willkommen in Ihren Organigrammen, bereitgestellt von OrgChart!",
    "Take the tour to get started and learn more!": "Machen Sie die Tour, um loszulegen und mehr zu erfahren!",
    "21 days": "21 Tage",
    "premium org chart features": "Premium-Organigramm-Funktionen",
    "isolvedFreeTrialMessage": "In den nächsten 21 Tagen haben Sie kostenlosen Zugang zu Premium-Organigramm-Funktionen, die nur in isolved verfügbar sind, einschließlich Export, Informationshervorhebung und mehrerer Diagrammansichten.",
    "isolvedFreeTrialTemplate": "In den nächsten {21 days} haben Sie kostenlosen Zugang zu {premium org chart features}, die nur in isolved verfügbar sind, einschließlich Export, Informationshervorhebung und mehrerer Diagrammansichten.",
    "Click on the view switcher to change the information that is displayed on the chart. Your chart comes with three pre-installed views.": "Klicken Sie auf die Ansichtsumschaltung, um die im Diagramm angezeigten Informationen zu ändern. Ihr Diagramm enthält drei vorinstallierte Ansichten.",
    "Use the levels control to increase or decrease the amount of organizational levels displayed on a single page.": "Verwenden Sie die Ebenensteuerung, um die Anzahl der auf einer einzelnen Seite angezeigten Organisationsebenen zu erhöhen oder zu verringern.",
    "Create filters to show specific records. For example, filter your chart to just see Full Time employees. Create highlights to illuminate specific records. For example, quickly highlight employees who work in New York.": "Erstellen Sie Filter, um bestimmte Datensätze anzuzeigen. Filtern Sie beispielsweise Ihr Diagramm, um nur Vollzeitbeschäftigte zu sehen. Erstellen Sie Hervorhebungen, um bestimmte Datensätze hervorzuheben. Heben Sie beispielsweise schnell Mitarbeiter hervor, die in New York arbeiten.",
    "Instantly get presentation-ready org charts. Export your chart to PPT, PDF, SVG, and additional formats.": "Erhalten Sie sofort präsentationsfertige Organigramme. Exportieren Sie Ihr Diagramm in PPT, PDF, SVG und weitere Formate.",
    "brandedBackgroundMessage": "Ihr Logo erzeugt einen benutzerdefinierten Hintergrund für Ihr Organigramm. OrgChart unterstützt mehrere Logos. Bitte lesen Sie dieses Hilfedokument, um mehr zu erfahren. Klicken Sie auf „Fortfahren“, um diesen Schritt zu überspringen.",
    "brandedBackgroundTemplate": "Ihr Logo erzeugt einen benutzerdefinierten Hintergrund für Ihr Organigramm. OrgChart unterstützt mehrere Logos. Bitte lesen Sie {help document}, um mehr zu erfahren. Klicken Sie auf „Fortfahren“, um diesen Schritt zu überspringen.",
    "Brand colors could not be saved. Please try again or skip setup.": "Die Markenfarben konnten nicht gespeichert werden. Bitte versuchen Sie es erneut oder überspringen Sie die Einrichtung.",
    "Logo could not be saved. Please try again or skip setup.": "Das Logo konnte nicht gespeichert werden. Bitte versuchen Sie es erneut oder überspringen Sie die Einrichtung.",
    "Resource center": "Ressourcencenter",
    "Help documentation": "Hilfedokumentation",
    "Learn about specific topics": "Mehr zu bestimmten Themen erfahren",
    "Submit a support ticket": "Support-Ticket einreichen",
    "Onboarding": "Einführung",
    "Take a tour of our core features": "Entdecken Sie unsere Kernfunktionen",
    "Entity filter created": "Filter {entity} erstellt.",
    "Entity highlight created": "Hervorhebung {entity} erstellt.",
    "Entity group created": "Gruppe {entity} erstellt.",
    "View rule saved": "Ansichtsregel gespeichert.",
    "Chart scope changes saved": "Änderungen am Diagrammbereich gespeichert.",
    "Entity rule renamed": "{entity} umbenannt.",
    "Enter rule definition": "Regeldefinition eingeben",
    "<blank>": "<blank>",
    "SCIMSectionTitle": "SCIM-Bereitstellung",
    "SCIMUpgradeBody": "Führen Sie ein Upgrade durch, um SCIM zu aktivieren und Benutzerbereitstellung, Gruppenzuweisung und Deaktivierung direkt über Ihren IdP zu verwalten.",
    "SCIMUpgradeTemplate": "Führen Sie ein Upgrade durch, um {bold1} und Benutzerbereitstellung, Gruppenzuweisung und Deaktivierung {bold2} zu verwalten.",
    "SCIMUpgradeBold1": "SCIM zu aktivieren",
    "SCIMUpgradeBold2": "direkt über Ihren IdP",
    "SCIMTokenPanelIntro": "Geben Sie ein Bearer-Token an Ihren Identitätsanbieter (z. B. Okta) aus, damit dieser Benutzer per SCIM 2.0 bereitstellen, aktualisieren und deaktivieren kann. Tokens werden nur bei der Erstellung angezeigt und können danach nicht erneut abgerufen werden.",
    "SCIMTokenGenerate": "Token erstellen",
    "SCIMTokenCopy": "Kopieren",
    "SCIMTokenDismiss": "Schließen",
    "SCIMTokenNewTitle": "Token erstellt",
    "SCIMTokenNewWarning": "Kopieren Sie dieses Token jetzt. Es kann nicht erneut angezeigt werden.",
    "SCIMTokenNoneActive": "Für dieses Konto wurden noch keine SCIM-Tokens ausgegeben.",
    "SCIMTokenCreatedBy": "Erstellt von",
    "SCIMTokenCreatedAt": "Erstellt am",
    "SCIMTokenLastUsed": "Zuletzt verwendet",
    "SCIMTokenListError": "SCIM-Tokens konnten nicht geladen werden.",
    "SCIMTokenCreateError": "SCIM-Token konnte nicht erstellt werden.",
    "SCIMTokenDeleteError": "SCIM-Token konnte nicht gelöscht werden.",
    "SCIMSAMLConflictTitle": "SCIM und automatische SAML-Bereitstellung sind beide aktiviert",
    "SCIMSAMLConflictBody": "Beide Systeme können dieselben Benutzerdatensätze schreiben. SAML-Attribute überschreiben SCIM-Werte bei der Anmeldung. Um Inkonsistenzen zu vermeiden, deaktivieren Sie die automatische Bereitstellung in der SSO-Konfiguration oder löschen Sie das SCIM-Token.",
    "No functional statement": "Keine Funktionsbeschreibung",
    "Functional Statement": "Funktionsbeschreibung",
    "Chart Navigator": "Organigramm-Navigator",
    "Navigator": "Navigator",
    "Point in Time": "Zeitpunkt",
    "No results": "Keine Ergebnisse",
    "PDF Export Only": "Nur PDF-Export",
    "Include Functional Statements": "Funktionsbeschreibungen einschließen",
    "includeFunctionalStatementsHelper": "Am Ende des Exports eine Seite mit der Funktionsbeschreibung jeder Einheit anhängen",
    "disableFunctionalStatementsSwitch": "Funktionsbeschreibungen sind nur für vollständige Organigramm-Exporte verfügbar. Wählen Sie auf der Registerkarte Allgemein den Umfang 'Gesamtes Organigramm'.",
    "includeExcelFunctionalStatementsHelper": "Eine Spalte mit der Funktionsbeschreibung jeder Einheit hinzufügen",
    "isolvedMissingJobDataErrTitle": "Unvollständige oder fehlende Stellendaten",
    "isolvedMissingJobDataErrAdmin": "Die Stellendaten sind unvollständig oder fehlen. Stellen Sie sicher, dass den Mitarbeitern Vorgesetzte und Positionsbezeichnungen zugewiesen sind. Das Organigramm wird dann innerhalb einer Stunde aktualisiert.",
    "isolvedMissingJobDataErrUser": "Die Stellendaten sind unvollständig oder fehlen. Wenden Sie sich an Ihren isolved-Administrator, um zu überprüfen, ob den Mitarbeitern Vorgesetzte und Positionsbezeichnungen zugewiesen sind.",
    "isolvedMappingMissingManagerTitle": "Fehlende Vorgesetzten-Beziehungen (Manager) erkannt",
    "isolvedMappingMissingManagerAdmin": "Wir haben in Ihrer aktuellen Vorgesetzten-Zuordnung keine Berichtsbeziehungen erkannt. Mit assigned supervisor ID bestehen Berichtsbeziehungen. Möchten Sie Ihre Vorgesetzten-Zuordnung stattdessen auf assigned supervisor ID umstellen?",
    "isolvedMappingMissingManagerUser": "Für die aktuelle Vorgesetzten-Zuordnung Ihres Organigramms wurden in isolved keine Berichtsbeziehungen gefunden. Wenden Sie sich an Ihren isolved-Administrator, um die Vorgesetzten-Zuordnung zu aktualisieren.",
    "isolvedMappingIncompleteManagerTitle": "Unvollständige Vorgesetzten-Beziehungen (Manager) erkannt",
    "isolvedMappingIncompleteManagerAdmin": "Bei einigen Mitarbeitern fehlt eine Berichtsbeziehung in Ihrer aktuellen Vorgesetzten-Zuordnung. Wir haben festgestellt, dass Berichtsbeziehungen auf Basis von assigned supervisor ID vollständiger sind. Möchten Sie Ihre Vorgesetzten-Zuordnung auf assigned supervisor ID umstellen? Wenn Sie Ihre aktuelle Zuordnung beibehalten möchten, stellen Sie sicher, dass alle Mitarbeiter in isolved einen Wert dafür haben.",
    "isolvedMappingIncompleteManagerUser": "Bei einigen Mitarbeitern fehlt in isolved eine Berichtsbeziehung für die aktuelle Vorgesetzten-Zuordnung Ihres Organigramms. Wenden Sie sich an Ihren isolved-Administrator, um die Vorgesetzten-Zuordnung zu überprüfen.",
    "isolvedMappingMissingSupervisorTitle": "Fehlende Vorgesetzten-Beziehungen (Supervisor) erkannt",
    "isolvedMappingMissingSupervisorAdmin": "Wir haben in Ihrer aktuellen Vorgesetzten-Zuordnung keine Berichtsbeziehungen erkannt. Mit assigned manager ID bestehen Berichtsbeziehungen. Möchten Sie Ihre Vorgesetzten-Zuordnung stattdessen auf assigned manager ID umstellen?",
    "isolvedMappingMissingSupervisorUser": "Für die aktuelle Vorgesetzten-Zuordnung Ihres Organigramms wurden in isolved keine Berichtsbeziehungen gefunden. Wenden Sie sich an Ihren isolved-Administrator, um die Vorgesetzten-Zuordnung zu aktualisieren.",
    "isolvedMappingIncompleteSupervisorTitle": "Unvollständige Vorgesetzten-Beziehungen (Supervisor) erkannt",
    "isolvedMappingIncompleteSupervisorAdmin": "Bei einigen Mitarbeitern fehlt eine Berichtsbeziehung in Ihrer aktuellen Vorgesetzten-Zuordnung. Wir haben festgestellt, dass Berichtsbeziehungen auf Basis von assigned manager ID vollständiger sind. Möchten Sie Ihre Vorgesetzten-Zuordnung auf assigned manager ID umstellen? Wenn Sie Ihre aktuelle Zuordnung beibehalten möchten, stellen Sie sicher, dass alle Mitarbeiter in isolved einen Wert dafür haben.",
    "isolvedMappingIncompleteSupervisorUser": "Bei einigen Mitarbeitern fehlt in isolved eine Berichtsbeziehung für die aktuelle Vorgesetzten-Zuordnung Ihres Organigramms. Wenden Sie sich an Ihren isolved-Administrator, um die Vorgesetzten-Zuordnung zu überprüfen.",
    "isolvedMappingNoneDetectedTitle": "Keine Berichtsbeziehungen erkannt",
    "isolvedMappingNoneDetectedAdmin": "Ein Organigramm kann nicht erstellt werden, da keine Berichtsbeziehungen erkannt wurden. Stellen Sie sicher, dass Mitarbeitern in isolved ein Manager oder Supervisor zugewiesen ist. Das Organigramm wird dann innerhalb einer Stunde aktualisiert.",
    "isolvedMappingNoneDetectedUser": "Ein Organigramm kann nicht erstellt werden, da in isolved keine Berichtsbeziehungen erkannt wurden. Wenden Sie sich an Ihren isolved-Administrator, um sicherzustellen, dass Mitarbeitern ein Manager oder Supervisor zugewiesen ist.",
    "isolvedMissingJobIdErrTitle": "Fehlende Stellenzuweisung",
    "isolvedMissingJobIdErrAdmin": "Keinem Ihrer isolved-Mitarbeiter ist eine Stelle zugewiesen. Weisen Sie jedem Mitarbeiter in isolved eine Stelle zu. Das Organigramm wird dann innerhalb einer Stunde aktualisiert.",
    "isolvedMissingJobIdErrUser": "Keinem Mitarbeiter Ihres Unternehmens ist in isolved eine Stelle zugewiesen. Wenden Sie sich an Ihren isolved-Administrator, um diese Stellen zu vervollständigen.",
    "Unlock": "Freischalten",
    "Unlock advanced security": "Erweiterte Sicherheit freischalten",
    "Unlock plan approvals": "Planfreigaben freischalten",
    "Unlock planning": "Planung freischalten",
    "Unlock point in time": "Zeitpunkt freischalten",
    "access groups upgrade message": "Erstellen Sie benutzerdefinierte Zugriffsgruppen, um genau festzulegen, wer bestimmte Organigramme, Ordner und Daten in Ihrem Unternehmen anzeigen, bearbeiten und verwalten darf.",
    "access groups upgrade template": "Erstellen Sie {benutzerdefinierte Zugriffsgruppen}, um genau festzulegen, wer bestimmte Organigramme, Ordner und Daten in Ihrem Unternehmen anzeigen, bearbeiten und verwalten darf.",
    "custom access groups": "benutzerdefinierte Zugriffsgruppen",
    "ui profiles upgrade message": "Steuern Sie den Zugriff auf bestimmte UI-Elemente, damit Benutzer genau das sehen, was sie brauchen.",
    "ui profiles upgrade template": "Steuern Sie den Zugriff auf {bestimmte UI-Elemente}, damit Benutzer genau das sehen, was sie brauchen.",
    "certain UI elements": "bestimmte UI-Elemente",
    "Unlock access groups": "Zugriffsgruppen freischalten",
    "Unlock UI profiles": "UI-Profile freischalten",
    "Unlock Admin Log": "Administrator-Protokoll freischalten",
    "Add to library": "Zur Bibliothek hinzufügen",
    "Edit record details": "Datensatzdetails bearbeiten",
    "Agent profile": "Agentenprofil",
    "Agent profile card": "Agenten-Profilkarte",
    "Agent profile desc": "Wählen Sie die Daten aus, die auf Agenten-Profilkarten angezeigt werden sollen.",
    "Card header information": "Kopfzeileninformation der Karte",
    "About me": "Über mich",
    "Lifecycle and governance details": "Details zu Lebenszyklus und Governance",
    "Lifecycle and governance": "Lebenszyklus und Governance",
    "Adoption & activity": "Nutzung & Aktivität",
    "Adoption and activity": "Nutzung und Aktivität",
    "Additional details": "Weitere Details",
    "view here": "hier ansehen",
    "Agent audit log": "Audit-Protokoll",
    "last ran {n} days ago": "zuletzt vor {n} Tagen ausgeführt",
    "Identity": "Identität",
    "Technical": "Technisch",
    "Cost": "Kosten",
    "Alerts": "Warnungen",
    "Action breakdown": "Aufschlüsselung der Aktionen",
    "1 employee affected": "1 Mitarbeiter betroffen",
    "{n} employees affected": "{n} Mitarbeiter betroffen",
    "Open alert details": "Warnungsdetails öffnen",
    "Agent name": "Agentenname",
    "Agent type": "Agententyp",
    "About": "Über",
    "Detail link": "Detail-Link",
    "Last updated": "Zuletzt aktualisiert",
    "Model used": "Verwendetes Modell",
    "Models used": "Verwendete Modelle",
    "Platform": "Plattform",
    "Review frequency": "Überprüfungsfrequenz",
    "Access scope": "Zugriffsbereich",
    "Audit log link": "Link zum Audit-Protokoll",
    "Date created": "Erstellungsdatum",
    "Date deployed": "Bereitstellungsdatum",
    "Errors prevented": "Verhinderte Fehler",
    "Auto-corrections": "Automatische Korrekturen",
    "Items reviewed": "Überprüfte Elemente",
    "Items reviewed (last pay cycle)": "Überprüfte Elemente (letzter Abrechnungszeitraum)",
    "Time saved": "Eingesparte Zeit",
    "Time saved (this month)": "Eingesparte Zeit (diesen Monat)",
    "Active users": "Aktive Benutzer",
    "Approval rate": "Genehmigungsquote",
    "Days since last use": "Tage seit der letzten Nutzung",
    "Requests made": "Gestellte Anfragen",
    "Sessions": "Sitzungen",
    "Sessions (this month)": "Sitzungen (diesen Monat)",
    "Agent spend": "Agentenausgaben",
    "Token spend": "Token-Verbrauch",
    "Token spend (this month)": "Token-Verbrauch (diesen Monat)",
    "Critical alerts": "Kritische Warnungen",
    "Open alerts": "Offene Warnungen",
    "Top alerts": "Wichtigste Warnungen",
    "Auto-applied": "Automatisch angewendet",
    "Resolved": "Gelöst",
    "Dismissed": "Verworfen",
    "Full name (Title)": "Vollständiger Name (Titel)",
    "Agent View": "Agentenansicht",
    "exportFailedTitle": "Export fehlgeschlagen",
    "exportFailedMsg": "Ihr Export konnte nicht erstellt werden. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an den technischen Support.",
    "Drill down available": "Drilldown nach unten verfügbar",
    "Drill up available": "Drilldown nach oben verfügbar",
    "Drill down": "Drilldown nach unten",
    "Drill up": "Drilldown nach oben",
    "Chart keyboard help": "Organigramm. Verwenden Sie die Pfeiltasten, um zwischen den Feldern zu wechseln, die Eingabetaste, um die Feldaktionen zu öffnen, und Alt plus Pfeil nach oben oder unten für den Drilldown. Drücken Sie die Tabulatortaste, um das Organigramm zu verlassen."
}
